/*! For license information please see storeTemplate.js.LICENSE.txt */
(() => {
  "use strict";
  var e,
    t,
    n = {
      287: (e, t) => {
        var n = Symbol.for("react.element"),
          r = Symbol.for("react.portal"),
          a = Symbol.for("react.fragment"),
          l = Symbol.for("react.strict_mode"),
          i = Symbol.for("react.profiler"),
          o = Symbol.for("react.provider"),
          u = Symbol.for("react.context"),
          s = Symbol.for("react.forward_ref"),
          c = Symbol.for("react.suspense"),
          d = Symbol.for("react.memo"),
          f = Symbol.for("react.lazy"),
          p = Symbol.iterator,
          m = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          g = Object.assign,
          h = {};
        function y(e, t, n) {
          ((this.props = e),
            (this.context = t),
            (this.refs = h),
            (this.updater = n || m));
        }
        function v() {}
        function b(e, t, n) {
          ((this.props = e),
            (this.context = t),
            (this.refs = h),
            (this.updater = n || m));
        }
        ((y.prototype.isReactComponent = {}),
          (y.prototype.setState = function (e, t) {
            if ("object" != typeof e && "function" != typeof e && null != e)
              throw Error(
                "setState(...): takes an object of state variables to update or a function which returns an object of state variables.",
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (y.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (v.prototype = y.prototype));
        var S = (b.prototype = new v());
        ((S.constructor = b), g(S, y.prototype), (S.isPureReactComponent = !0));
        var E = Array.isArray,
          k = Object.prototype.hasOwnProperty,
          w = { current: null },
          x = { key: !0, ref: !0, __self: !0, __source: !0 };
        function C(e, t, r) {
          var a,
            l = {},
            i = null,
            o = null;
          if (null != t)
            for (a in (void 0 !== t.ref && (o = t.ref),
            void 0 !== t.key && (i = "" + t.key),
            t))
              k.call(t, a) && !x.hasOwnProperty(a) && (l[a] = t[a]);
          var u = arguments.length - 2;
          if (1 === u) l.children = r;
          else if (1 < u) {
            for (var s = Array(u), c = 0; c < u; c++) s[c] = arguments[c + 2];
            l.children = s;
          }
          if (e && e.defaultProps)
            for (a in (u = e.defaultProps)) void 0 === l[a] && (l[a] = u[a]);
          return {
            $$typeof: n,
            type: e,
            key: i,
            ref: o,
            props: l,
            _owner: w.current,
          };
        }
        function _(e) {
          return "object" == typeof e && null !== e && e.$$typeof === n;
        }
        var P = /\/+/g;
        function D(e, t) {
          return "object" == typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                  "$" +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })("" + e.key)
            : t.toString(36);
        }
        function N(e, t, a, l, i) {
          var o = typeof e;
          ("undefined" !== o && "boolean" !== o) || (e = null);
          var u = !1;
          if (null === e) u = !0;
          else
            switch (o) {
              case "string":
              case "number":
                u = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    u = !0;
                }
            }
          if (u)
            return (
              (i = i((u = e))),
              (e = "" === l ? "." + D(u, 0) : l),
              E(i)
                ? ((a = ""),
                  null != e && (a = e.replace(P, "$&/") + "/"),
                  N(i, t, a, "", function (e) {
                    return e;
                  }))
                : null != i &&
                  (_(i) &&
                    (i = (function (e, t) {
                      return {
                        $$typeof: n,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner,
                      };
                    })(
                      i,
                      a +
                        (!i.key || (u && u.key === i.key)
                          ? ""
                          : ("" + i.key).replace(P, "$&/") + "/") +
                        e,
                    )),
                  t.push(i)),
              1
            );
          if (((u = 0), (l = "" === l ? "." : l + ":"), E(e)))
            for (var s = 0; s < e.length; s++) {
              var c = l + D((o = e[s]), s);
              u += N(o, t, a, c, i);
            }
          else if (
            ((c = (function (e) {
              return null === e || "object" != typeof e
                ? null
                : "function" == typeof (e = (p && e[p]) || e["@@iterator"])
                  ? e
                  : null;
            })(e)),
            "function" == typeof c)
          )
            for (e = c.call(e), s = 0; !(o = e.next()).done;)
              u += N((o = o.value), t, a, (c = l + D(o, s++)), i);
          else if ("object" === o)
            throw (
              (t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead.",
              )
            );
          return u;
        }
        function L(e, t, n) {
          if (null == e) return e;
          var r = [],
            a = 0;
          return (
            N(e, r, "", "", function (e) {
              return t.call(n, e, a++);
            }),
            r
          );
        }
        function M(e) {
          if (-1 === e._status) {
            var t = e._result;
            ((t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              },
            ),
              -1 === e._status && ((e._status = 0), (e._result = t)));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var X = { current: null },
          T = { transition: null },
          z = {
            ReactCurrentDispatcher: X,
            ReactCurrentBatchConfig: T,
            ReactCurrentOwner: w,
          };
        function R() {
          throw Error(
            "act(...) is not supported in production builds of React.",
          );
        }
        ((t.Children = {
          map: L,
          forEach: function (e, t, n) {
            L(
              e,
              function () {
                t.apply(this, arguments);
              },
              n,
            );
          },
          count: function (e) {
            var t = 0;
            return (
              L(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              L(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!_(e))
              throw Error(
                "React.Children.only expected to receive a single React element child.",
              );
            return e;
          },
        }),
          (t.Component = y),
          (t.Fragment = a),
          (t.Profiler = i),
          (t.PureComponent = b),
          (t.StrictMode = l),
          (t.Suspense = c),
          (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = z),
          (t.act = R),
          (t.cloneElement = function (e, t, r) {
            if (null == e)
              throw Error(
                "React.cloneElement(...): The argument must be a React element, but you passed " +
                  e +
                  ".",
              );
            var a = g({}, e.props),
              l = e.key,
              i = e.ref,
              o = e._owner;
            if (null != t) {
              if (
                (void 0 !== t.ref && ((i = t.ref), (o = w.current)),
                void 0 !== t.key && (l = "" + t.key),
                e.type && e.type.defaultProps)
              )
                var u = e.type.defaultProps;
              for (s in t)
                k.call(t, s) &&
                  !x.hasOwnProperty(s) &&
                  (a[s] = void 0 === t[s] && void 0 !== u ? u[s] : t[s]);
            }
            var s = arguments.length - 2;
            if (1 === s) a.children = r;
            else if (1 < s) {
              u = Array(s);
              for (var c = 0; c < s; c++) u[c] = arguments[c + 2];
              a.children = u;
            }
            return {
              $$typeof: n,
              type: e.type,
              key: l,
              ref: i,
              props: a,
              _owner: o,
            };
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: u,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null,
              }).Provider = { $$typeof: o, _context: e }),
              (e.Consumer = e)
            );
          }),
          (t.createElement = C),
          (t.createFactory = function (e) {
            var t = C.bind(null, e);
            return ((t.type = e), t);
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: s, render: e };
          }),
          (t.isValidElement = _),
          (t.lazy = function (e) {
            return {
              $$typeof: f,
              _payload: { _status: -1, _result: e },
              _init: M,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: d, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = T.transition;
            T.transition = {};
            try {
              e();
            } finally {
              T.transition = t;
            }
          }),
          (t.unstable_act = R),
          (t.useCallback = function (e, t) {
            return X.current.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return X.current.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e) {
            return X.current.useDeferredValue(e);
          }),
          (t.useEffect = function (e, t) {
            return X.current.useEffect(e, t);
          }),
          (t.useId = function () {
            return X.current.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return X.current.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return X.current.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return X.current.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return X.current.useMemo(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return X.current.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return X.current.useRef(e);
          }),
          (t.useState = function (e) {
            return X.current.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return X.current.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return X.current.useTransition();
          }),
          (t.version = "18.3.1"));
      },
      338: (e, t, n) => {
        var r = n(961);
        ((t.createRoot = r.createRoot), (t.hydrateRoot = r.hydrateRoot));
      },
      463: (e, t) => {
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n;) {
            var r = (n - 1) >>> 1,
              a = e[r];
            if (!(0 < l(a, t))) break e;
            ((e[r] = t), (e[n] = a), (n = r));
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function a(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, a = e.length, i = a >>> 1; r < i;) {
              var o = 2 * (r + 1) - 1,
                u = e[o],
                s = o + 1,
                c = e[s];
              if (0 > l(u, n))
                s < a && 0 > l(c, u)
                  ? ((e[r] = c), (e[s] = n), (r = s))
                  : ((e[r] = u), (e[o] = n), (r = o));
              else {
                if (!(s < a && 0 > l(c, n))) break e;
                ((e[r] = c), (e[s] = n), (r = s));
              }
            }
          }
          return t;
        }
        function l(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          "object" == typeof performance &&
          "function" == typeof performance.now
        ) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var o = Date,
            u = o.now();
          t.unstable_now = function () {
            return o.now() - u;
          };
        }
        var s = [],
          c = [],
          d = 1,
          f = null,
          p = 3,
          m = !1,
          g = !1,
          h = !1,
          y = "function" == typeof setTimeout ? setTimeout : null,
          v = "function" == typeof clearTimeout ? clearTimeout : null,
          b = "undefined" != typeof setImmediate ? setImmediate : null;
        function S(e) {
          for (var t = r(c); null !== t;) {
            if (null === t.callback) a(c);
            else {
              if (!(t.startTime <= e)) break;
              (a(c), (t.sortIndex = t.expirationTime), n(s, t));
            }
            t = r(c);
          }
        }
        function E(e) {
          if (((h = !1), S(e), !g))
            if (null !== r(s)) ((g = !0), T(k));
            else {
              var t = r(c);
              null !== t && z(E, t.startTime - e);
            }
        }
        function k(e, n) {
          ((g = !1), h && ((h = !1), v(_), (_ = -1)), (m = !0));
          var l = p;
          try {
            for (
              S(n), f = r(s);
              null !== f && (!(f.expirationTime > n) || (e && !N()));
            ) {
              var i = f.callback;
              if ("function" == typeof i) {
                ((f.callback = null), (p = f.priorityLevel));
                var o = i(f.expirationTime <= n);
                ((n = t.unstable_now()),
                  "function" == typeof o
                    ? (f.callback = o)
                    : f === r(s) && a(s),
                  S(n));
              } else a(s);
              f = r(s);
            }
            if (null !== f) var u = !0;
            else {
              var d = r(c);
              (null !== d && z(E, d.startTime - n), (u = !1));
            }
            return u;
          } finally {
            ((f = null), (p = l), (m = !1));
          }
        }
        "undefined" != typeof navigator &&
          void 0 !== navigator.scheduling &&
          void 0 !== navigator.scheduling.isInputPending &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var w,
          x = !1,
          C = null,
          _ = -1,
          P = 5,
          D = -1;
        function N() {
          return !(t.unstable_now() - D < P);
        }
        function L() {
          if (null !== C) {
            var e = t.unstable_now();
            D = e;
            var n = !0;
            try {
              n = C(!0, e);
            } finally {
              n ? w() : ((x = !1), (C = null));
            }
          } else x = !1;
        }
        if ("function" == typeof b)
          w = function () {
            b(L);
          };
        else if ("undefined" != typeof MessageChannel) {
          var M = new MessageChannel(),
            X = M.port2;
          ((M.port1.onmessage = L),
            (w = function () {
              X.postMessage(null);
            }));
        } else
          w = function () {
            y(L, 0);
          };
        function T(e) {
          ((C = e), x || ((x = !0), w()));
        }
        function z(e, n) {
          _ = y(function () {
            e(t.unstable_now());
          }, n);
        }
        ((t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            g || m || ((g = !0), T(k));
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (P = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return p;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(s);
          }),
          (t.unstable_next = function (e) {
            switch (p) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = p;
            }
            var n = p;
            p = t;
            try {
              return e();
            } finally {
              p = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = p;
            p = e;
            try {
              return t();
            } finally {
              p = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, a, l) {
            var i = t.unstable_now();
            switch (
              ((l =
                "object" == typeof l &&
                null !== l &&
                "number" == typeof (l = l.delay) &&
                0 < l
                  ? i + l
                  : i),
              e)
            ) {
              case 1:
                var o = -1;
                break;
              case 2:
                o = 250;
                break;
              case 5:
                o = 1073741823;
                break;
              case 4:
                o = 1e4;
                break;
              default:
                o = 5e3;
            }
            return (
              (e = {
                id: d++,
                callback: a,
                priorityLevel: e,
                startTime: l,
                expirationTime: (o = l + o),
                sortIndex: -1,
              }),
              l > i
                ? ((e.sortIndex = l),
                  n(c, e),
                  null === r(s) &&
                    e === r(c) &&
                    (h ? (v(_), (_ = -1)) : (h = !0), z(E, l - i)))
                : ((e.sortIndex = o), n(s, e), g || m || ((g = !0), T(k))),
              e
            );
          }),
          (t.unstable_shouldYield = N),
          (t.unstable_wrapCallback = function (e) {
            var t = p;
            return function () {
              var n = p;
              p = t;
              try {
                return e.apply(this, arguments);
              } finally {
                p = n;
              }
            };
          }));
      },
      540: (e, t, n) => {
        e.exports = n(287);
      },
      551: (e, t, n) => {
        var r = n(540),
          a = n(982);
        function l(e) {
          for (
            var t =
                "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
              n = 1;
            n < arguments.length;
            n++
          )
            t += "&args[]=" + encodeURIComponent(arguments[n]);
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        var i = new Set(),
          o = {};
        function u(e, t) {
          (s(e, t), s(e + "Capture", t));
        }
        function s(e, t) {
          for (o[e] = t, e = 0; e < t.length; e++) i.add(t[e]);
        }
        var c = !(
            "undefined" == typeof window ||
            void 0 === window.document ||
            void 0 === window.document.createElement
          ),
          d = Object.prototype.hasOwnProperty,
          f =
            /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          p = {},
          m = {};
        function g(e, t, n, r, a, l, i) {
          ((this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
            (this.attributeName = r),
            (this.attributeNamespace = a),
            (this.mustUseProperty = n),
            (this.propertyName = e),
            (this.type = t),
            (this.sanitizeURL = l),
            (this.removeEmptyString = i));
        }
        var h = {};
        ("children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
          .split(" ")
          .forEach(function (e) {
            h[e] = new g(e, 0, !1, e, null, !1, !1);
          }),
          [
            ["acceptCharset", "accept-charset"],
            ["className", "class"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
          ].forEach(function (e) {
            var t = e[0];
            h[t] = new g(t, 1, !1, e[1], null, !1, !1);
          }),
          ["contentEditable", "draggable", "spellCheck", "value"].forEach(
            function (e) {
              h[e] = new g(e, 2, !1, e.toLowerCase(), null, !1, !1);
            },
          ),
          [
            "autoReverse",
            "externalResourcesRequired",
            "focusable",
            "preserveAlpha",
          ].forEach(function (e) {
            h[e] = new g(e, 2, !1, e, null, !1, !1);
          }),
          "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
            .split(" ")
            .forEach(function (e) {
              h[e] = new g(e, 3, !1, e.toLowerCase(), null, !1, !1);
            }),
          ["checked", "multiple", "muted", "selected"].forEach(function (e) {
            h[e] = new g(e, 3, !0, e, null, !1, !1);
          }),
          ["capture", "download"].forEach(function (e) {
            h[e] = new g(e, 4, !1, e, null, !1, !1);
          }),
          ["cols", "rows", "size", "span"].forEach(function (e) {
            h[e] = new g(e, 6, !1, e, null, !1, !1);
          }),
          ["rowSpan", "start"].forEach(function (e) {
            h[e] = new g(e, 5, !1, e.toLowerCase(), null, !1, !1);
          }));
        var y = /[\-:]([a-z])/g;
        function v(e) {
          return e[1].toUpperCase();
        }
        function b(e, t, n, r) {
          var a = h.hasOwnProperty(t) ? h[t] : null;
          (null !== a
            ? 0 !== a.type
            : r ||
              !(2 < t.length) ||
              ("o" !== t[0] && "O" !== t[0]) ||
              ("n" !== t[1] && "N" !== t[1])) &&
            ((function (e, t, n, r) {
              if (
                null == t ||
                (function (e, t, n, r) {
                  if (null !== n && 0 === n.type) return !1;
                  switch (typeof t) {
                    case "function":
                    case "symbol":
                      return !0;
                    case "boolean":
                      return (
                        !r &&
                        (null !== n
                          ? !n.acceptsBooleans
                          : "data-" !== (e = e.toLowerCase().slice(0, 5)) &&
                            "aria-" !== e)
                      );
                    default:
                      return !1;
                  }
                })(e, t, n, r)
              )
                return !0;
              if (r) return !1;
              if (null !== n)
                switch (n.type) {
                  case 3:
                    return !t;
                  case 4:
                    return !1 === t;
                  case 5:
                    return isNaN(t);
                  case 6:
                    return isNaN(t) || 1 > t;
                }
              return !1;
            })(t, n, a, r) && (n = null),
            r || null === a
              ? (function (e) {
                  return (
                    !!d.call(m, e) ||
                    (!d.call(p, e) &&
                      (f.test(e) ? (m[e] = !0) : ((p[e] = !0), !1)))
                  );
                })(t) &&
                (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
              : a.mustUseProperty
                ? (e[a.propertyName] = null === n ? 3 !== a.type && "" : n)
                : ((t = a.attributeName),
                  (r = a.attributeNamespace),
                  null === n
                    ? e.removeAttribute(t)
                    : ((n =
                        3 === (a = a.type) || (4 === a && !0 === n)
                          ? ""
                          : "" + n),
                      r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
        }
        ("accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
          .split(" ")
          .forEach(function (e) {
            var t = e.replace(y, v);
            h[t] = new g(t, 1, !1, e, null, !1, !1);
          }),
          "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
            .split(" ")
            .forEach(function (e) {
              var t = e.replace(y, v);
              h[t] = new g(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
            }),
          ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
            var t = e.replace(y, v);
            h[t] = new g(
              t,
              1,
              !1,
              e,
              "http://www.w3.org/XML/1998/namespace",
              !1,
              !1,
            );
          }),
          ["tabIndex", "crossOrigin"].forEach(function (e) {
            h[e] = new g(e, 1, !1, e.toLowerCase(), null, !1, !1);
          }),
          (h.xlinkHref = new g(
            "xlinkHref",
            1,
            !1,
            "xlink:href",
            "http://www.w3.org/1999/xlink",
            !0,
            !1,
          )),
          ["src", "href", "action", "formAction"].forEach(function (e) {
            h[e] = new g(e, 1, !1, e.toLowerCase(), null, !0, !0);
          }));
        var S = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          E = Symbol.for("react.element"),
          k = Symbol.for("react.portal"),
          w = Symbol.for("react.fragment"),
          x = Symbol.for("react.strict_mode"),
          C = Symbol.for("react.profiler"),
          _ = Symbol.for("react.provider"),
          P = Symbol.for("react.context"),
          D = Symbol.for("react.forward_ref"),
          N = Symbol.for("react.suspense"),
          L = Symbol.for("react.suspense_list"),
          M = Symbol.for("react.memo"),
          X = Symbol.for("react.lazy");
        (Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode"));
        var T = Symbol.for("react.offscreen");
        (Symbol.for("react.legacy_hidden"),
          Symbol.for("react.cache"),
          Symbol.for("react.tracing_marker"));
        var z = Symbol.iterator;
        function R(e) {
          return null === e || "object" != typeof e
            ? null
            : "function" == typeof (e = (z && e[z]) || e["@@iterator"])
              ? e
              : null;
        }
        var Y,
          O = Object.assign;
        function A(e) {
          if (void 0 === Y)
            try {
              throw Error();
            } catch (e) {
              var t = e.stack.trim().match(/\n( *(at )?)/);
              Y = (t && t[1]) || "";
            }
          return "\n" + Y + e;
        }
        var F = !1;
        function B(e, t) {
          if (!e || F) return "";
          F = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (t)
              if (
                ((t = function () {
                  throw Error();
                }),
                Object.defineProperty(t.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                "object" == typeof Reflect && Reflect.construct)
              ) {
                try {
                  Reflect.construct(t, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], t);
              } else {
                try {
                  t.call();
                } catch (e) {
                  r = e;
                }
                e.call(t.prototype);
              }
            else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              e();
            }
          } catch (t) {
            if (t && r && "string" == typeof t.stack) {
              for (
                var a = t.stack.split("\n"),
                  l = r.stack.split("\n"),
                  i = a.length - 1,
                  o = l.length - 1;
                1 <= i && 0 <= o && a[i] !== l[o];
              )
                o--;
              for (; 1 <= i && 0 <= o; i--, o--)
                if (a[i] !== l[o]) {
                  if (1 !== i || 1 !== o)
                    do {
                      if ((i--, 0 > --o || a[i] !== l[o])) {
                        var u = "\n" + a[i].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            u.includes("<anonymous>") &&
                            (u = u.replace("<anonymous>", e.displayName)),
                          u
                        );
                      }
                    } while (1 <= i && 0 <= o);
                  break;
                }
            }
          } finally {
            ((F = !1), (Error.prepareStackTrace = n));
          }
          return (e = e ? e.displayName || e.name : "") ? A(e) : "";
        }
        function I(e) {
          switch (e.tag) {
            case 5:
              return A(e.type);
            case 16:
              return A("Lazy");
            case 13:
              return A("Suspense");
            case 19:
              return A("SuspenseList");
            case 0:
            case 2:
            case 15:
              return B(e.type, !1);
            case 11:
              return B(e.type.render, !1);
            case 1:
              return B(e.type, !0);
            default:
              return "";
          }
        }
        function U(e) {
          if (null == e) return null;
          if ("function" == typeof e) return e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case w:
              return "Fragment";
            case k:
              return "Portal";
            case C:
              return "Profiler";
            case x:
              return "StrictMode";
            case N:
              return "Suspense";
            case L:
              return "SuspenseList";
          }
          if ("object" == typeof e)
            switch (e.$$typeof) {
              case P:
                return (e.displayName || "Context") + ".Consumer";
              case _:
                return (e._context.displayName || "Context") + ".Provider";
              case D:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case M:
                return null !== (t = e.displayName || null)
                  ? t
                  : U(e.type) || "Memo";
              case X:
                ((t = e._payload), (e = e._init));
                try {
                  return U(e(t));
                } catch (e) {}
            }
          return null;
        }
        function V(e) {
          var t = e.type;
          switch (e.tag) {
            case 24:
              return "Cache";
            case 9:
              return (t.displayName || "Context") + ".Consumer";
            case 10:
              return (t._context.displayName || "Context") + ".Provider";
            case 18:
              return "DehydratedFragment";
            case 11:
              return (
                (e = (e = t.render).displayName || e.name || ""),
                t.displayName ||
                  ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef")
              );
            case 7:
              return "Fragment";
            case 5:
              return t;
            case 4:
              return "Portal";
            case 3:
              return "Root";
            case 6:
              return "Text";
            case 16:
              return U(t);
            case 8:
              return t === x ? "StrictMode" : "Mode";
            case 22:
              return "Offscreen";
            case 12:
              return "Profiler";
            case 21:
              return "Scope";
            case 13:
              return "Suspense";
            case 19:
              return "SuspenseList";
            case 25:
              return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if ("function" == typeof t)
                return t.displayName || t.name || null;
              if ("string" == typeof t) return t;
          }
          return null;
        }
        function q(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function $(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function j(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = $(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                void 0 !== n &&
                "function" == typeof n.get &&
                "function" == typeof n.set
              ) {
                var a = n.get,
                  l = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return a.call(this);
                    },
                    set: function (e) {
                      ((r = "" + e), l.call(this, e));
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      ((e._valueTracker = null), delete e[t]);
                    },
                  }
                );
              }
            })(e));
        }
        function W(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = $(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function H(e) {
          if (
            void 0 ===
            (e = e || ("undefined" != typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        function Q(e, t) {
          var n = t.checked;
          return O({}, t, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != n ? n : e._wrapperState.initialChecked,
          });
        }
        function K(e, t) {
          var n = null == t.defaultValue ? "" : t.defaultValue,
            r = null != t.checked ? t.checked : t.defaultChecked;
          ((n = q(null != t.value ? t.value : n)),
            (e._wrapperState = {
              initialChecked: r,
              initialValue: n,
              controlled:
                "checkbox" === t.type || "radio" === t.type
                  ? null != t.checked
                  : null != t.value,
            }));
        }
        function G(e, t) {
          null != (t = t.checked) && b(e, "checked", t, !1);
        }
        function J(e, t) {
          G(e, t);
          var n = q(t.value),
            r = t.type;
          if (null != n)
            "number" === r
              ? ((0 === n && "" === e.value) || e.value != n) &&
                (e.value = "" + n)
              : e.value !== "" + n && (e.value = "" + n);
          else if ("submit" === r || "reset" === r)
            return void e.removeAttribute("value");
          (t.hasOwnProperty("value")
            ? ee(e, t.type, n)
            : t.hasOwnProperty("defaultValue") &&
              ee(e, t.type, q(t.defaultValue)),
            null == t.checked &&
              null != t.defaultChecked &&
              (e.defaultChecked = !!t.defaultChecked));
        }
        function Z(e, t, n) {
          if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
            var r = t.type;
            if (!(
              ("submit" !== r && "reset" !== r) ||
              (void 0 !== t.value && null !== t.value)
            ))
              return;
            ((t = "" + e._wrapperState.initialValue),
              n || t === e.value || (e.value = t),
              (e.defaultValue = t));
          }
          ("" !== (n = e.name) && (e.name = ""),
            (e.defaultChecked = !!e._wrapperState.initialChecked),
            "" !== n && (e.name = n));
        }
        function ee(e, t, n) {
          ("number" === t && H(e.ownerDocument) === e) ||
            (null == n
              ? (e.defaultValue = "" + e._wrapperState.initialValue)
              : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
        }
        var te = Array.isArray;
        function ne(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var a = 0; a < n.length; a++) t["$" + n[a]] = !0;
            for (n = 0; n < e.length; n++)
              ((a = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== a && (e[n].selected = a),
                a && r && (e[n].defaultSelected = !0));
          } else {
            for (n = "" + q(n), t = null, a = 0; a < e.length; a++) {
              if (e[a].value === n)
                return (
                  (e[a].selected = !0),
                  void (r && (e[a].defaultSelected = !0))
                );
              null !== t || e[a].disabled || (t = e[a]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function re(e, t) {
          if (null != t.dangerouslySetInnerHTML) throw Error(l(91));
          return O({}, t, {
            value: void 0,
            defaultValue: void 0,
            children: "" + e._wrapperState.initialValue,
          });
        }
        function ae(e, t) {
          var n = t.value;
          if (null == n) {
            if (((n = t.children), (t = t.defaultValue), null != n)) {
              if (null != t) throw Error(l(92));
              if (te(n)) {
                if (1 < n.length) throw Error(l(93));
                n = n[0];
              }
              t = n;
            }
            (null == t && (t = ""), (n = t));
          }
          e._wrapperState = { initialValue: q(n) };
        }
        function le(e, t) {
          var n = q(t.value),
            r = q(t.defaultValue);
          (null != n &&
            ((n = "" + n) !== e.value && (e.value = n),
            null == t.defaultValue &&
              e.defaultValue !== n &&
              (e.defaultValue = n)),
            null != r && (e.defaultValue = "" + r));
        }
        function ie(e) {
          var t = e.textContent;
          t === e._wrapperState.initialValue &&
            "" !== t &&
            null !== t &&
            (e.value = t);
        }
        function oe(e) {
          switch (e) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function ue(e, t) {
          return null == e || "http://www.w3.org/1999/xhtml" === e
            ? oe(t)
            : "http://www.w3.org/2000/svg" === e && "foreignObject" === t
              ? "http://www.w3.org/1999/xhtml"
              : e;
        }
        var se,
          ce,
          de =
            ((ce = function (e, t) {
              if (
                "http://www.w3.org/2000/svg" !== e.namespaceURI ||
                "innerHTML" in e
              )
                e.innerHTML = t;
              else {
                for (
                  (se = se || document.createElement("div")).innerHTML =
                    "<svg>" + t.valueOf().toString() + "</svg>",
                    t = se.firstChild;
                  e.firstChild;
                )
                  e.removeChild(e.firstChild);
                for (; t.firstChild;) e.appendChild(t.firstChild);
              }
            }),
            "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction
              ? function (e, t, n, r) {
                  MSApp.execUnsafeLocalFunction(function () {
                    return ce(e, t);
                  });
                }
              : ce);
        function fe(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var pe = {
            animationIterationCount: !0,
            aspectRatio: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0,
          },
          me = ["Webkit", "ms", "Moz", "O"];
        function ge(e, t, n) {
          return null == t || "boolean" == typeof t || "" === t
            ? ""
            : n ||
                "number" != typeof t ||
                0 === t ||
                (pe.hasOwnProperty(e) && pe[e])
              ? ("" + t).trim()
              : t + "px";
        }
        function he(e, t) {
          for (var n in ((e = e.style), t))
            if (t.hasOwnProperty(n)) {
              var r = 0 === n.indexOf("--"),
                a = ge(n, t[n], r);
              ("float" === n && (n = "cssFloat"),
                r ? e.setProperty(n, a) : (e[n] = a));
            }
        }
        Object.keys(pe).forEach(function (e) {
          me.forEach(function (t) {
            ((t = t + e.charAt(0).toUpperCase() + e.substring(1)),
              (pe[t] = pe[e]));
          });
        });
        var ye = O(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          },
        );
        function ve(e, t) {
          if (t) {
            if (
              ye[e] &&
              (null != t.children || null != t.dangerouslySetInnerHTML)
            )
              throw Error(l(137, e));
            if (null != t.dangerouslySetInnerHTML) {
              if (null != t.children) throw Error(l(60));
              if (
                "object" != typeof t.dangerouslySetInnerHTML ||
                !("__html" in t.dangerouslySetInnerHTML)
              )
                throw Error(l(61));
            }
            if (null != t.style && "object" != typeof t.style)
              throw Error(l(62));
          }
        }
        function be(e, t) {
          if (-1 === e.indexOf("-")) return "string" == typeof t.is;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var Se = null;
        function Ee(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var ke = null,
          we = null,
          xe = null;
        function Ce(e) {
          if ((e = ba(e))) {
            if ("function" != typeof ke) throw Error(l(280));
            var t = e.stateNode;
            t && ((t = Ea(t)), ke(e.stateNode, e.type, t));
          }
        }
        function _e(e) {
          we ? (xe ? xe.push(e) : (xe = [e])) : (we = e);
        }
        function Pe() {
          if (we) {
            var e = we,
              t = xe;
            if (((xe = we = null), Ce(e), t))
              for (e = 0; e < t.length; e++) Ce(t[e]);
          }
        }
        function De(e, t) {
          return e(t);
        }
        function Ne() {}
        var Le = !1;
        function Me(e, t, n) {
          if (Le) return e(t, n);
          Le = !0;
          try {
            return De(e, t, n);
          } finally {
            ((Le = !1), (null !== we || null !== xe) && (Ne(), Pe()));
          }
        }
        function Xe(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = Ea(n);
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              ((r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r));
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" != typeof n) throw Error(l(231, t, typeof n));
          return n;
        }
        var Te = !1;
        if (c)
          try {
            var ze = {};
            (Object.defineProperty(ze, "passive", {
              get: function () {
                Te = !0;
              },
            }),
              window.addEventListener("test", ze, ze),
              window.removeEventListener("test", ze, ze));
          } catch (ce) {
            Te = !1;
          }
        function Re(e, t, n, r, a, l, i, o, u) {
          var s = Array.prototype.slice.call(arguments, 3);
          try {
            t.apply(n, s);
          } catch (e) {
            this.onError(e);
          }
        }
        var Ye = !1,
          Oe = null,
          Ae = !1,
          Fe = null,
          Be = {
            onError: function (e) {
              ((Ye = !0), (Oe = e));
            },
          };
        function Ie(e, t, n, r, a, l, i, o, u) {
          ((Ye = !1), (Oe = null), Re.apply(Be, arguments));
        }
        function Ue(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return;) t = t.return;
          else {
            e = t;
            do {
              (!!(4098 & (t = e).flags) && (n = t.return), (e = t.return));
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function Ve(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function qe(e) {
          if (Ue(e) !== e) throw Error(l(188));
        }
        function $e(e) {
          return null !==
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = Ue(e))) throw Error(l(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ;) {
                var a = n.return;
                if (null === a) break;
                var i = a.alternate;
                if (null === i) {
                  if (null !== (r = a.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (a.child === i.child) {
                  for (i = a.child; i;) {
                    if (i === n) return (qe(a), e);
                    if (i === r) return (qe(a), t);
                    i = i.sibling;
                  }
                  throw Error(l(188));
                }
                if (n.return !== r.return) ((n = a), (r = i));
                else {
                  for (var o = !1, u = a.child; u;) {
                    if (u === n) {
                      ((o = !0), (n = a), (r = i));
                      break;
                    }
                    if (u === r) {
                      ((o = !0), (r = a), (n = i));
                      break;
                    }
                    u = u.sibling;
                  }
                  if (!o) {
                    for (u = i.child; u;) {
                      if (u === n) {
                        ((o = !0), (n = i), (r = a));
                        break;
                      }
                      if (u === r) {
                        ((o = !0), (r = i), (n = a));
                        break;
                      }
                      u = u.sibling;
                    }
                    if (!o) throw Error(l(189));
                  }
                }
                if (n.alternate !== r) throw Error(l(190));
              }
              if (3 !== n.tag) throw Error(l(188));
              return n.stateNode.current === n ? e : t;
            })(e))
            ? je(e)
            : null;
        }
        function je(e) {
          if (5 === e.tag || 6 === e.tag) return e;
          for (e = e.child; null !== e;) {
            var t = je(e);
            if (null !== t) return t;
            e = e.sibling;
          }
          return null;
        }
        var We = a.unstable_scheduleCallback,
          He = a.unstable_cancelCallback,
          Qe = a.unstable_shouldYield,
          Ke = a.unstable_requestPaint,
          Ge = a.unstable_now,
          Je = a.unstable_getCurrentPriorityLevel,
          Ze = a.unstable_ImmediatePriority,
          et = a.unstable_UserBlockingPriority,
          tt = a.unstable_NormalPriority,
          nt = a.unstable_LowPriority,
          rt = a.unstable_IdlePriority,
          at = null,
          lt = null,
          it = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 === (e >>>= 0) ? 32 : (31 - ((ot(e) / ut) | 0)) | 0;
              },
          ot = Math.log,
          ut = Math.LN2,
          st = 64,
          ct = 4194304;
        function dt(e) {
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194240 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return 130023424 & e;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 1073741824;
            default:
              return e;
          }
        }
        function ft(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            a = e.suspendedLanes,
            l = e.pingedLanes,
            i = 268435455 & n;
          if (0 !== i) {
            var o = i & ~a;
            0 !== o ? (r = dt(o)) : 0 != (l &= i) && (r = dt(l));
          } else 0 != (i = n & ~a) ? (r = dt(i)) : 0 !== l && (r = dt(l));
          if (0 === r) return 0;
          if (
            0 !== t &&
            t !== r &&
            !(t & a) &&
            ((a = r & -r) >= (l = t & -t) || (16 === a && 4194240 & l))
          )
            return t;
          if ((4 & r && (r |= 16 & n), 0 !== (t = e.entangledLanes)))
            for (e = e.entanglements, t &= r; 0 < t;)
              ((a = 1 << (n = 31 - it(t))), (r |= e[n]), (t &= ~a));
          return r;
        }
        function pt(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
              return t + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function mt(e) {
          return 0 != (e = -1073741825 & e.pendingLanes)
            ? e
            : 1073741824 & e
              ? 1073741824
              : 0;
        }
        function gt() {
          var e = st;
          return (!(4194240 & (st <<= 1)) && (st = 64), e);
        }
        function ht(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function yt(e, t, n) {
          ((e.pendingLanes |= t),
            536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
            ((e = e.eventTimes)[(t = 31 - it(t))] = n));
        }
        function vt(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n;) {
            var r = 31 - it(n),
              a = 1 << r;
            ((a & t) | (e[r] & t) && (e[r] |= t), (n &= ~a));
          }
        }
        var bt = 0;
        function St(e) {
          return 1 < (e &= -e)
            ? 4 < e
              ? 268435455 & e
                ? 16
                : 536870912
              : 4
            : 1;
        }
        var Et,
          kt,
          wt,
          xt,
          Ct,
          _t = !1,
          Pt = [],
          Dt = null,
          Nt = null,
          Lt = null,
          Mt = new Map(),
          Xt = new Map(),
          Tt = [],
          zt =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
              " ",
            );
        function Rt(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              Dt = null;
              break;
            case "dragenter":
            case "dragleave":
              Nt = null;
              break;
            case "mouseover":
            case "mouseout":
              Lt = null;
              break;
            case "pointerover":
            case "pointerout":
              Mt.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              Xt.delete(t.pointerId);
          }
        }
        function Yt(e, t, n, r, a, l) {
          return null === e || e.nativeEvent !== l
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: l,
                targetContainers: [a],
              }),
              null !== t && null !== (t = ba(t)) && kt(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== a && -1 === t.indexOf(a) && t.push(a),
              e);
        }
        function Ot(e) {
          var t = va(e.target);
          if (null !== t) {
            var n = Ue(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = Ve(n)))
                  return (
                    (e.blockedOn = t),
                    void Ct(e.priority, function () {
                      wt(n);
                    })
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function At(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length;) {
            var n = Qt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
            if (null !== n)
              return (null !== (t = ba(n)) && kt(t), (e.blockedOn = n), !1);
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            ((Se = r), n.target.dispatchEvent(r), (Se = null), t.shift());
          }
          return !0;
        }
        function Ft(e, t, n) {
          At(e) && n.delete(t);
        }
        function Bt() {
          ((_t = !1),
            null !== Dt && At(Dt) && (Dt = null),
            null !== Nt && At(Nt) && (Nt = null),
            null !== Lt && At(Lt) && (Lt = null),
            Mt.forEach(Ft),
            Xt.forEach(Ft));
        }
        function It(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            _t ||
              ((_t = !0),
              a.unstable_scheduleCallback(a.unstable_NormalPriority, Bt)));
        }
        function Ut(e) {
          function t(t) {
            return It(t, e);
          }
          if (0 < Pt.length) {
            It(Pt[0], e);
            for (var n = 1; n < Pt.length; n++) {
              var r = Pt[n];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (
            null !== Dt && It(Dt, e),
              null !== Nt && It(Nt, e),
              null !== Lt && It(Lt, e),
              Mt.forEach(t),
              Xt.forEach(t),
              n = 0;
            n < Tt.length;
            n++
          )
            (r = Tt[n]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < Tt.length && null === (n = Tt[0]).blockedOn;)
            (Ot(n), null === n.blockedOn && Tt.shift());
        }
        var Vt = S.ReactCurrentBatchConfig,
          qt = !0;
        function $t(e, t, n, r) {
          var a = bt,
            l = Vt.transition;
          Vt.transition = null;
          try {
            ((bt = 1), Wt(e, t, n, r));
          } finally {
            ((bt = a), (Vt.transition = l));
          }
        }
        function jt(e, t, n, r) {
          var a = bt,
            l = Vt.transition;
          Vt.transition = null;
          try {
            ((bt = 4), Wt(e, t, n, r));
          } finally {
            ((bt = a), (Vt.transition = l));
          }
        }
        function Wt(e, t, n, r) {
          if (qt) {
            var a = Qt(e, t, n, r);
            if (null === a) (qr(e, t, r, Ht, n), Rt(e, r));
            else if (
              (function (e, t, n, r, a) {
                switch (t) {
                  case "focusin":
                    return ((Dt = Yt(Dt, e, t, n, r, a)), !0);
                  case "dragenter":
                    return ((Nt = Yt(Nt, e, t, n, r, a)), !0);
                  case "mouseover":
                    return ((Lt = Yt(Lt, e, t, n, r, a)), !0);
                  case "pointerover":
                    var l = a.pointerId;
                    return (
                      Mt.set(l, Yt(Mt.get(l) || null, e, t, n, r, a)),
                      !0
                    );
                  case "gotpointercapture":
                    return (
                      (l = a.pointerId),
                      Xt.set(l, Yt(Xt.get(l) || null, e, t, n, r, a)),
                      !0
                    );
                }
                return !1;
              })(a, e, t, n, r)
            )
              r.stopPropagation();
            else if ((Rt(e, r), 4 & t && -1 < zt.indexOf(e))) {
              for (; null !== a;) {
                var l = ba(a);
                if (
                  (null !== l && Et(l),
                  null === (l = Qt(e, t, n, r)) && qr(e, t, r, Ht, n),
                  l === a)
                )
                  break;
                a = l;
              }
              null !== a && r.stopPropagation();
            } else qr(e, t, r, null, n);
          }
        }
        var Ht = null;
        function Qt(e, t, n, r) {
          if (((Ht = null), null !== (e = va((e = Ee(r))))))
            if (null === (t = Ue(e))) e = null;
            else if (13 === (n = t.tag)) {
              if (null !== (e = Ve(t))) return e;
              e = null;
            } else if (3 === n) {
              if (t.stateNode.current.memoizedState.isDehydrated)
                return 3 === t.tag ? t.stateNode.containerInfo : null;
              e = null;
            } else t !== e && (e = null);
          return ((Ht = e), null);
        }
        function Kt(e) {
          switch (e) {
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 1;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 4;
            case "message":
              switch (Je()) {
                case Ze:
                  return 1;
                case et:
                  return 4;
                case tt:
                case nt:
                  return 16;
                case rt:
                  return 536870912;
                default:
                  return 16;
              }
            default:
              return 16;
          }
        }
        var Gt = null,
          Jt = null,
          Zt = null;
        function en() {
          if (Zt) return Zt;
          var e,
            t,
            n = Jt,
            r = n.length,
            a = "value" in Gt ? Gt.value : Gt.textContent,
            l = a.length;
          for (e = 0; e < r && n[e] === a[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === a[l - t]; t++);
          return (Zt = a.slice(e, 1 < t ? 1 - t : void 0));
        }
        function tn(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function nn() {
          return !0;
        }
        function rn() {
          return !1;
        }
        function an(e) {
          function t(t, n, r, a, l) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = a),
            (this.target = l),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(a) : a[i]));
            return (
              (this.isDefaultPrevented = (
                null != a.defaultPrevented
                  ? a.defaultPrevented
                  : !1 === a.returnValue
              )
                ? nn
                : rn),
              (this.isPropagationStopped = rn),
              this
            );
          }
          return (
            O(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" != typeof e.returnValue && (e.returnValue = !1),
                  (this.isDefaultPrevented = nn));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" != typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = nn));
              },
              persist: function () {},
              isPersistent: nn,
            }),
            t
          );
        }
        var ln,
          on,
          un,
          sn = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          cn = an(sn),
          dn = O({}, sn, { view: 0, detail: 0 }),
          fn = an(dn),
          pn = O({}, dn, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: Cn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== un &&
                    (un && "mousemove" === e.type
                      ? ((ln = e.screenX - un.screenX),
                        (on = e.screenY - un.screenY))
                      : (on = ln = 0),
                    (un = e)),
                  ln);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : on;
            },
          }),
          mn = an(pn),
          gn = an(O({}, pn, { dataTransfer: 0 })),
          hn = an(O({}, dn, { relatedTarget: 0 })),
          yn = an(
            O({}, sn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
          ),
          vn = O({}, sn, {
            clipboardData: function (e) {
              return "clipboardData" in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          bn = an(vn),
          Sn = an(O({}, sn, { data: 0 })),
          En = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          kn = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          wn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function xn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = wn[e]) && !!t[e];
        }
        function Cn() {
          return xn;
        }
        var _n = O({}, dn, {
            key: function (e) {
              if (e.key) {
                var t = En[e.key] || e.key;
                if ("Unidentified" !== t) return t;
              }
              return "keypress" === e.type
                ? 13 === (e = tn(e))
                  ? "Enter"
                  : String.fromCharCode(e)
                : "keydown" === e.type || "keyup" === e.type
                  ? kn[e.keyCode] || "Unidentified"
                  : "";
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: Cn,
            charCode: function (e) {
              return "keypress" === e.type ? tn(e) : 0;
            },
            keyCode: function (e) {
              return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return "keypress" === e.type
                ? tn(e)
                : "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
            },
          }),
          Pn = an(_n),
          Dn = an(
            O({}, pn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            }),
          ),
          Nn = an(
            O({}, dn, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: Cn,
            }),
          ),
          Ln = an(
            O({}, sn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          ),
          Mn = O({}, pn, {
            deltaX: function (e) {
              return "deltaX" in e
                ? e.deltaX
                : "wheelDeltaX" in e
                  ? -e.wheelDeltaX
                  : 0;
            },
            deltaY: function (e) {
              return "deltaY" in e
                ? e.deltaY
                : "wheelDeltaY" in e
                  ? -e.wheelDeltaY
                  : "wheelDelta" in e
                    ? -e.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Xn = an(Mn),
          Tn = [9, 13, 27, 32],
          zn = c && "CompositionEvent" in window,
          Rn = null;
        c && "documentMode" in document && (Rn = document.documentMode);
        var Yn = c && "TextEvent" in window && !Rn,
          On = c && (!zn || (Rn && 8 < Rn && 11 >= Rn)),
          An = String.fromCharCode(32),
          Fn = !1;
        function Bn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== Tn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function In(e) {
          return "object" == typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var Un = !1,
          Vn = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
          };
        function qn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Vn[e.type] : "textarea" === t;
        }
        function $n(e, t, n, r) {
          (_e(r),
            0 < (t = jr(t, "onChange")).length &&
              ((n = new cn("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t })));
        }
        var jn = null,
          Wn = null;
        function Hn(e) {
          Ar(e, 0);
        }
        function Qn(e) {
          if (W(Sa(e))) return e;
        }
        function Kn(e, t) {
          if ("change" === e) return t;
        }
        var Gn = !1;
        if (c) {
          var Jn;
          if (c) {
            var Zn = "oninput" in document;
            if (!Zn) {
              var er = document.createElement("div");
              (er.setAttribute("oninput", "return;"),
                (Zn = "function" == typeof er.oninput));
            }
            Jn = Zn;
          } else Jn = !1;
          Gn = Jn && (!document.documentMode || 9 < document.documentMode);
        }
        function tr() {
          jn && (jn.detachEvent("onpropertychange", nr), (Wn = jn = null));
        }
        function nr(e) {
          if ("value" === e.propertyName && Qn(Wn)) {
            var t = [];
            ($n(t, Wn, e, Ee(e)), Me(Hn, t));
          }
        }
        function rr(e, t, n) {
          "focusin" === e
            ? (tr(), (Wn = n), (jn = t).attachEvent("onpropertychange", nr))
            : "focusout" === e && tr();
        }
        function ar(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return Qn(Wn);
        }
        function lr(e, t) {
          if ("click" === e) return Qn(t);
        }
        function ir(e, t) {
          if ("input" === e || "change" === e) return Qn(t);
        }
        var or =
          "function" == typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t)
                );
              };
        function ur(e, t) {
          if (or(e, t)) return !0;
          if (
            "object" != typeof e ||
            null === e ||
            "object" != typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var a = n[r];
            if (!d.call(t, a) || !or(e[a], t[a])) return !1;
          }
          return !0;
        }
        function sr(e) {
          for (; e && e.firstChild;) e = e.firstChild;
          return e;
        }
        function cr(e, t) {
          var n,
            r = sr(e);
          for (e = 0; r;) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r;) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = sr(r);
          }
        }
        function dr(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? dr(e, t.parentNode)
                  : "contains" in e
                    ? e.contains(t)
                    : !!e.compareDocumentPosition &&
                      !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function fr() {
          for (var e = window, t = H(); t instanceof e.HTMLIFrameElement;) {
            try {
              var n = "string" == typeof t.contentWindow.location.href;
            } catch (e) {
              n = !1;
            }
            if (!n) break;
            t = H((e = t.contentWindow).document);
          }
          return t;
        }
        function pr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        function mr(e) {
          var t = fr(),
            n = e.focusedElem,
            r = e.selectionRange;
          if (
            t !== n &&
            n &&
            n.ownerDocument &&
            dr(n.ownerDocument.documentElement, n)
          ) {
            if (null !== r && pr(n))
              if (
                ((t = r.start),
                void 0 === (e = r.end) && (e = t),
                "selectionStart" in n)
              )
                ((n.selectionStart = t),
                  (n.selectionEnd = Math.min(e, n.value.length)));
              else if (
                (e =
                  ((t = n.ownerDocument || document) && t.defaultView) ||
                  window).getSelection
              ) {
                e = e.getSelection();
                var a = n.textContent.length,
                  l = Math.min(r.start, a);
                ((r = void 0 === r.end ? l : Math.min(r.end, a)),
                  !e.extend && l > r && ((a = r), (r = l), (l = a)),
                  (a = cr(n, l)));
                var i = cr(n, r);
                a &&
                  i &&
                  (1 !== e.rangeCount ||
                    e.anchorNode !== a.node ||
                    e.anchorOffset !== a.offset ||
                    e.focusNode !== i.node ||
                    e.focusOffset !== i.offset) &&
                  ((t = t.createRange()).setStart(a.node, a.offset),
                  e.removeAllRanges(),
                  l > r
                    ? (e.addRange(t), e.extend(i.node, i.offset))
                    : (t.setEnd(i.node, i.offset), e.addRange(t)));
              }
            for (t = [], e = n; (e = e.parentNode);)
              1 === e.nodeType &&
                t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
            for (
              "function" == typeof n.focus && n.focus(), n = 0;
              n < t.length;
              n++
            )
              (((e = t[n]).element.scrollLeft = e.left),
                (e.element.scrollTop = e.top));
          }
        }
        var gr = c && "documentMode" in document && 11 >= document.documentMode,
          hr = null,
          yr = null,
          vr = null,
          br = !1;
        function Sr(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
                ? n
                : n.ownerDocument;
          br ||
            null == hr ||
            hr !== H(r) ||
            ((r =
              "selectionStart" in (r = hr) && pr(r)
                ? { start: r.selectionStart, end: r.selectionEnd }
                : {
                    anchorNode: (r = (
                      (r.ownerDocument && r.ownerDocument.defaultView) ||
                      window
                    ).getSelection()).anchorNode,
                    anchorOffset: r.anchorOffset,
                    focusNode: r.focusNode,
                    focusOffset: r.focusOffset,
                  }),
            (vr && ur(vr, r)) ||
              ((vr = r),
              0 < (r = jr(yr, "onSelect")).length &&
                ((t = new cn("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = hr))));
        }
        function Er(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var kr = {
            animationend: Er("Animation", "AnimationEnd"),
            animationiteration: Er("Animation", "AnimationIteration"),
            animationstart: Er("Animation", "AnimationStart"),
            transitionend: Er("Transition", "TransitionEnd"),
          },
          wr = {},
          xr = {};
        function Cr(e) {
          if (wr[e]) return wr[e];
          if (!kr[e]) return e;
          var t,
            n = kr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in xr) return (wr[e] = n[t]);
          return e;
        }
        c &&
          ((xr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete kr.animationend.animation,
            delete kr.animationiteration.animation,
            delete kr.animationstart.animation),
          "TransitionEvent" in window || delete kr.transitionend.transition);
        var _r = Cr("animationend"),
          Pr = Cr("animationiteration"),
          Dr = Cr("animationstart"),
          Nr = Cr("transitionend"),
          Lr = new Map(),
          Mr =
            "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
              " ",
            );
        function Xr(e, t) {
          (Lr.set(e, t), u(t, [e]));
        }
        for (var Tr = 0; Tr < Mr.length; Tr++) {
          var zr = Mr[Tr];
          Xr(zr.toLowerCase(), "on" + (zr[0].toUpperCase() + zr.slice(1)));
        }
        (Xr(_r, "onAnimationEnd"),
          Xr(Pr, "onAnimationIteration"),
          Xr(Dr, "onAnimationStart"),
          Xr("dblclick", "onDoubleClick"),
          Xr("focusin", "onFocus"),
          Xr("focusout", "onBlur"),
          Xr(Nr, "onTransitionEnd"),
          s("onMouseEnter", ["mouseout", "mouseover"]),
          s("onMouseLeave", ["mouseout", "mouseover"]),
          s("onPointerEnter", ["pointerout", "pointerover"]),
          s("onPointerLeave", ["pointerout", "pointerover"]),
          u(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " ",
            ),
          ),
          u(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " ",
            ),
          ),
          u("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          u(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " ",
            ),
          ),
          u(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " ",
            ),
          ),
          u(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " ",
            ),
          ));
        var Rr =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " ",
            ),
          Yr = new Set(
            "cancel close invalid load scroll toggle".split(" ").concat(Rr),
          );
        function Or(e, t, n) {
          var r = e.type || "unknown-event";
          ((e.currentTarget = n),
            (function (e, t, n, r, a, i, o, u, s) {
              if ((Ie.apply(this, arguments), Ye)) {
                if (!Ye) throw Error(l(198));
                var c = Oe;
                ((Ye = !1), (Oe = null), Ae || ((Ae = !0), (Fe = c)));
              }
            })(r, t, void 0, e),
            (e.currentTarget = null));
        }
        function Ar(e, t) {
          t = !!(4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              a = r.event;
            r = r.listeners;
            e: {
              var l = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var o = r[i],
                    u = o.instance,
                    s = o.currentTarget;
                  if (((o = o.listener), u !== l && a.isPropagationStopped()))
                    break e;
                  (Or(a, o, s), (l = u));
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((u = (o = r[i]).instance),
                    (s = o.currentTarget),
                    (o = o.listener),
                    u !== l && a.isPropagationStopped())
                  )
                    break e;
                  (Or(a, o, s), (l = u));
                }
            }
          }
          if (Ae) throw ((e = Fe), (Ae = !1), (Fe = null), e);
        }
        function Fr(e, t) {
          var n = t[ga];
          void 0 === n && (n = t[ga] = new Set());
          var r = e + "__bubble";
          n.has(r) || (Vr(t, e, 2, !1), n.add(r));
        }
        function Br(e, t, n) {
          var r = 0;
          (t && (r |= 4), Vr(n, e, r, t));
        }
        var Ir = "_reactListening" + Math.random().toString(36).slice(2);
        function Ur(e) {
          if (!e[Ir]) {
            ((e[Ir] = !0),
              i.forEach(function (t) {
                "selectionchange" !== t &&
                  (Yr.has(t) || Br(t, !1, e), Br(t, !0, e));
              }));
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Ir] || ((t[Ir] = !0), Br("selectionchange", !1, t));
          }
        }
        function Vr(e, t, n, r) {
          switch (Kt(t)) {
            case 1:
              var a = $t;
              break;
            case 4:
              a = jt;
              break;
            default:
              a = Wt;
          }
          ((n = a.bind(null, t, n, e)),
            (a = void 0),
            !Te ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (a = !0),
            r
              ? void 0 !== a
                ? e.addEventListener(t, n, { capture: !0, passive: a })
                : e.addEventListener(t, n, !0)
              : void 0 !== a
                ? e.addEventListener(t, n, { passive: a })
                : e.addEventListener(t, n, !1));
        }
        function qr(e, t, n, r, a) {
          var l = r;
          if (!(1 & t || 2 & t || null === r))
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var o = r.stateNode.containerInfo;
                if (o === a || (8 === o.nodeType && o.parentNode === a)) break;
                if (4 === i)
                  for (i = r.return; null !== i;) {
                    var u = i.tag;
                    if (
                      (3 === u || 4 === u) &&
                      ((u = i.stateNode.containerInfo) === a ||
                        (8 === u.nodeType && u.parentNode === a))
                    )
                      return;
                    i = i.return;
                  }
                for (; null !== o;) {
                  if (null === (i = va(o))) return;
                  if (5 === (u = i.tag) || 6 === u) {
                    r = l = i;
                    continue e;
                  }
                  o = o.parentNode;
                }
              }
              r = r.return;
            }
          Me(function () {
            var r = l,
              a = Ee(n),
              i = [];
            e: {
              var o = Lr.get(e);
              if (void 0 !== o) {
                var u = cn,
                  s = e;
                switch (e) {
                  case "keypress":
                    if (0 === tn(n)) break e;
                  case "keydown":
                  case "keyup":
                    u = Pn;
                    break;
                  case "focusin":
                    ((s = "focus"), (u = hn));
                    break;
                  case "focusout":
                    ((s = "blur"), (u = hn));
                    break;
                  case "beforeblur":
                  case "afterblur":
                    u = hn;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    u = mn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    u = gn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    u = Nn;
                    break;
                  case _r:
                  case Pr:
                  case Dr:
                    u = yn;
                    break;
                  case Nr:
                    u = Ln;
                    break;
                  case "scroll":
                    u = fn;
                    break;
                  case "wheel":
                    u = Xn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    u = bn;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    u = Dn;
                }
                var c = !!(4 & t),
                  d = !c && "scroll" === e,
                  f = c ? (null !== o ? o + "Capture" : null) : o;
                c = [];
                for (var p, m = r; null !== m;) {
                  var g = (p = m).stateNode;
                  if (
                    (5 === p.tag &&
                      null !== g &&
                      ((p = g),
                      null !== f &&
                        null != (g = Xe(m, f)) &&
                        c.push($r(m, g, p))),
                    d)
                  )
                    break;
                  m = m.return;
                }
                0 < c.length &&
                  ((o = new u(o, s, null, n, a)),
                  i.push({ event: o, listeners: c }));
              }
            }
            if (!(7 & t)) {
              if (
                ((u = "mouseout" === e || "pointerout" === e),
                (!(o = "mouseover" === e || "pointerover" === e) ||
                  n === Se ||
                  !(s = n.relatedTarget || n.fromElement) ||
                  (!va(s) && !s[ma])) &&
                  (u || o) &&
                  ((o =
                    a.window === a
                      ? a
                      : (o = a.ownerDocument)
                        ? o.defaultView || o.parentWindow
                        : window),
                  u
                    ? ((u = r),
                      null !==
                        (s = (s = n.relatedTarget || n.toElement)
                          ? va(s)
                          : null) &&
                        (s !== (d = Ue(s)) || (5 !== s.tag && 6 !== s.tag)) &&
                        (s = null))
                    : ((u = null), (s = r)),
                  u !== s))
              ) {
                if (
                  ((c = mn),
                  (g = "onMouseLeave"),
                  (f = "onMouseEnter"),
                  (m = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((c = Dn),
                    (g = "onPointerLeave"),
                    (f = "onPointerEnter"),
                    (m = "pointer")),
                  (d = null == u ? o : Sa(u)),
                  (p = null == s ? o : Sa(s)),
                  ((o = new c(g, m + "leave", u, n, a)).target = d),
                  (o.relatedTarget = p),
                  (g = null),
                  va(a) === r &&
                    (((c = new c(f, m + "enter", s, n, a)).target = p),
                    (c.relatedTarget = d),
                    (g = c)),
                  (d = g),
                  u && s)
                )
                  e: {
                    for (f = s, m = 0, p = c = u; p; p = Wr(p)) m++;
                    for (p = 0, g = f; g; g = Wr(g)) p++;
                    for (; 0 < m - p;) ((c = Wr(c)), m--);
                    for (; 0 < p - m;) ((f = Wr(f)), p--);
                    for (; m--;) {
                      if (c === f || (null !== f && c === f.alternate)) break e;
                      ((c = Wr(c)), (f = Wr(f)));
                    }
                    c = null;
                  }
                else c = null;
                (null !== u && Hr(i, o, u, c, !1),
                  null !== s && null !== d && Hr(i, d, s, c, !0));
              }
              if (
                "select" ===
                  (u =
                    (o = r ? Sa(r) : window).nodeName &&
                    o.nodeName.toLowerCase()) ||
                ("input" === u && "file" === o.type)
              )
                var h = Kn;
              else if (qn(o))
                if (Gn) h = ir;
                else {
                  h = ar;
                  var y = rr;
                }
              else
                (u = o.nodeName) &&
                  "input" === u.toLowerCase() &&
                  ("checkbox" === o.type || "radio" === o.type) &&
                  (h = lr);
              switch (
                (h && (h = h(e, r))
                  ? $n(i, h, n, a)
                  : (y && y(e, o, r),
                    "focusout" === e &&
                      (y = o._wrapperState) &&
                      y.controlled &&
                      "number" === o.type &&
                      ee(o, "number", o.value)),
                (y = r ? Sa(r) : window),
                e)
              ) {
                case "focusin":
                  (qn(y) || "true" === y.contentEditable) &&
                    ((hr = y), (yr = r), (vr = null));
                  break;
                case "focusout":
                  vr = yr = hr = null;
                  break;
                case "mousedown":
                  br = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  ((br = !1), Sr(i, n, a));
                  break;
                case "selectionchange":
                  if (gr) break;
                case "keydown":
                case "keyup":
                  Sr(i, n, a);
              }
              var v;
              if (zn)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var b = "onCompositionStart";
                      break e;
                    case "compositionend":
                      b = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      b = "onCompositionUpdate";
                      break e;
                  }
                  b = void 0;
                }
              else
                Un
                  ? Bn(e, n) && (b = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (b = "onCompositionStart");
              (b &&
                (On &&
                  "ko" !== n.locale &&
                  (Un || "onCompositionStart" !== b
                    ? "onCompositionEnd" === b && Un && (v = en())
                    : ((Jt = "value" in (Gt = a) ? Gt.value : Gt.textContent),
                      (Un = !0))),
                0 < (y = jr(r, b)).length &&
                  ((b = new Sn(b, e, null, n, a)),
                  i.push({ event: b, listeners: y }),
                  (v || null !== (v = In(n))) && (b.data = v))),
                (v = Yn
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return In(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Fn = !0), An);
                        case "textInput":
                          return (e = t.data) === An && Fn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (Un)
                        return "compositionend" === e || (!zn && Bn(e, t))
                          ? ((e = en()), (Zt = Jt = Gt = null), (Un = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return On && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (r = jr(r, "onBeforeInput")).length &&
                  ((a = new Sn("onBeforeInput", "beforeinput", null, n, a)),
                  i.push({ event: a, listeners: r }),
                  (a.data = v)));
            }
            Ar(i, t);
          });
        }
        function $r(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function jr(e, t) {
          for (var n = t + "Capture", r = []; null !== e;) {
            var a = e,
              l = a.stateNode;
            (5 === a.tag &&
              null !== l &&
              ((a = l),
              null != (l = Xe(e, n)) && r.unshift($r(e, l, a)),
              null != (l = Xe(e, t)) && r.push($r(e, l, a))),
              (e = e.return));
          }
          return r;
        }
        function Wr(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function Hr(e, t, n, r, a) {
          for (var l = t._reactName, i = []; null !== n && n !== r;) {
            var o = n,
              u = o.alternate,
              s = o.stateNode;
            if (null !== u && u === r) break;
            (5 === o.tag &&
              null !== s &&
              ((o = s),
              a
                ? null != (u = Xe(n, l)) && i.unshift($r(n, u, o))
                : a || (null != (u = Xe(n, l)) && i.push($r(n, u, o)))),
              (n = n.return));
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var Qr = /\r\n?/g,
          Kr = /\u0000|\uFFFD/g;
        function Gr(e) {
          return ("string" == typeof e ? e : "" + e)
            .replace(Qr, "\n")
            .replace(Kr, "");
        }
        function Jr(e, t, n) {
          if (((t = Gr(t)), Gr(e) !== t && n)) throw Error(l(425));
        }
        function Zr() {}
        var ea = null,
          ta = null;
        function na(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" == typeof t.children ||
            "number" == typeof t.children ||
            ("object" == typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var ra = "function" == typeof setTimeout ? setTimeout : void 0,
          aa = "function" == typeof clearTimeout ? clearTimeout : void 0,
          la = "function" == typeof Promise ? Promise : void 0,
          ia =
            "function" == typeof queueMicrotask
              ? queueMicrotask
              : void 0 !== la
                ? function (e) {
                    return la.resolve(null).then(e).catch(oa);
                  }
                : ra;
        function oa(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function ua(e, t) {
          var n = t,
            r = 0;
          do {
            var a = n.nextSibling;
            if ((e.removeChild(n), a && 8 === a.nodeType))
              if ("/$" === (n = a.data)) {
                if (0 === r) return (e.removeChild(a), void Ut(t));
                r--;
              } else ("$" !== n && "$?" !== n && "$!" !== n) || r++;
            n = a;
          } while (n);
          Ut(t);
        }
        function sa(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if ("$" === (t = e.data) || "$!" === t || "$?" === t) break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        function ca(e) {
          e = e.previousSibling;
          for (var t = 0; e;) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var da = Math.random().toString(36).slice(2),
          fa = "__reactFiber$" + da,
          pa = "__reactProps$" + da,
          ma = "__reactContainer$" + da,
          ga = "__reactEvents$" + da,
          ha = "__reactListeners$" + da,
          ya = "__reactHandles$" + da;
        function va(e) {
          var t = e[fa];
          if (t) return t;
          for (var n = e.parentNode; n;) {
            if ((t = n[ma] || n[fa])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = ca(e); null !== e;) {
                  if ((n = e[fa])) return n;
                  e = ca(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function ba(e) {
          return !(e = e[fa] || e[ma]) ||
            (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
            ? null
            : e;
        }
        function Sa(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(l(33));
        }
        function Ea(e) {
          return e[pa] || null;
        }
        var ka = [],
          wa = -1;
        function xa(e) {
          return { current: e };
        }
        function Ca(e) {
          0 > wa || ((e.current = ka[wa]), (ka[wa] = null), wa--);
        }
        function _a(e, t) {
          (wa++, (ka[wa] = e.current), (e.current = t));
        }
        var Pa = {},
          Da = xa(Pa),
          Na = xa(!1),
          La = Pa;
        function Ma(e, t) {
          var n = e.type.contextTypes;
          if (!n) return Pa;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
            return r.__reactInternalMemoizedMaskedChildContext;
          var a,
            l = {};
          for (a in n) l[a] = t[a];
          return (
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                t),
              (e.__reactInternalMemoizedMaskedChildContext = l)),
            l
          );
        }
        function Xa(e) {
          return null != e.childContextTypes;
        }
        function Ta() {
          (Ca(Na), Ca(Da));
        }
        function za(e, t, n) {
          if (Da.current !== Pa) throw Error(l(168));
          (_a(Da, t), _a(Na, n));
        }
        function Ra(e, t, n) {
          var r = e.stateNode;
          if (
            ((t = t.childContextTypes), "function" != typeof r.getChildContext)
          )
            return n;
          for (var a in (r = r.getChildContext()))
            if (!(a in t)) throw Error(l(108, V(e) || "Unknown", a));
          return O({}, n, r);
        }
        function Ya(e) {
          return (
            (e =
              ((e = e.stateNode) &&
                e.__reactInternalMemoizedMergedChildContext) ||
              Pa),
            (La = Da.current),
            _a(Da, e),
            _a(Na, Na.current),
            !0
          );
        }
        function Oa(e, t, n) {
          var r = e.stateNode;
          if (!r) throw Error(l(169));
          (n
            ? ((e = Ra(e, t, La)),
              (r.__reactInternalMemoizedMergedChildContext = e),
              Ca(Na),
              Ca(Da),
              _a(Da, e))
            : Ca(Na),
            _a(Na, n));
        }
        var Aa = null,
          Fa = !1,
          Ba = !1;
        function Ia(e) {
          null === Aa ? (Aa = [e]) : Aa.push(e);
        }
        function Ua() {
          if (!Ba && null !== Aa) {
            Ba = !0;
            var e = 0,
              t = bt;
            try {
              var n = Aa;
              for (bt = 1; e < n.length; e++) {
                var r = n[e];
                do {
                  r = r(!0);
                } while (null !== r);
              }
              ((Aa = null), (Fa = !1));
            } catch (t) {
              throw (null !== Aa && (Aa = Aa.slice(e + 1)), We(Ze, Ua), t);
            } finally {
              ((bt = t), (Ba = !1));
            }
          }
          return null;
        }
        var Va = [],
          qa = 0,
          $a = null,
          ja = 0,
          Wa = [],
          Ha = 0,
          Qa = null,
          Ka = 1,
          Ga = "";
        function Ja(e, t) {
          ((Va[qa++] = ja), (Va[qa++] = $a), ($a = e), (ja = t));
        }
        function Za(e, t, n) {
          ((Wa[Ha++] = Ka), (Wa[Ha++] = Ga), (Wa[Ha++] = Qa), (Qa = e));
          var r = Ka;
          e = Ga;
          var a = 32 - it(r) - 1;
          ((r &= ~(1 << a)), (n += 1));
          var l = 32 - it(t) + a;
          if (30 < l) {
            var i = a - (a % 5);
            ((l = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (a -= i),
              (Ka = (1 << (32 - it(t) + a)) | (n << a) | r),
              (Ga = l + e));
          } else ((Ka = (1 << l) | (n << a) | r), (Ga = e));
        }
        function el(e) {
          null !== e.return && (Ja(e, 1), Za(e, 1, 0));
        }
        function tl(e) {
          for (; e === $a;)
            (($a = Va[--qa]),
              (Va[qa] = null),
              (ja = Va[--qa]),
              (Va[qa] = null));
          for (; e === Qa;)
            ((Qa = Wa[--Ha]),
              (Wa[Ha] = null),
              (Ga = Wa[--Ha]),
              (Wa[Ha] = null),
              (Ka = Wa[--Ha]),
              (Wa[Ha] = null));
        }
        var nl = null,
          rl = null,
          al = !1,
          ll = null;
        function il(e, t) {
          var n = Ms(5, null, null, 0);
          ((n.elementType = "DELETED"),
            (n.stateNode = t),
            (n.return = e),
            null === (t = e.deletions)
              ? ((e.deletions = [n]), (e.flags |= 16))
              : t.push(n));
        }
        function ol(e, t) {
          switch (e.tag) {
            case 5:
              var n = e.type;
              return (
                null !==
                  (t =
                    1 !== t.nodeType ||
                    n.toLowerCase() !== t.nodeName.toLowerCase()
                      ? null
                      : t) &&
                ((e.stateNode = t), (nl = e), (rl = sa(t.firstChild)), !0)
              );
            case 6:
              return (
                null !==
                  (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) &&
                ((e.stateNode = t), (nl = e), (rl = null), !0)
              );
            case 13:
              return (
                null !== (t = 8 !== t.nodeType ? null : t) &&
                ((n = null !== Qa ? { id: Ka, overflow: Ga } : null),
                (e.memoizedState = {
                  dehydrated: t,
                  treeContext: n,
                  retryLane: 1073741824,
                }),
                ((n = Ms(18, null, null, 0)).stateNode = t),
                (n.return = e),
                (e.child = n),
                (nl = e),
                (rl = null),
                !0)
              );
            default:
              return !1;
          }
        }
        function ul(e) {
          return !(!(1 & e.mode) || 128 & e.flags);
        }
        function sl(e) {
          if (al) {
            var t = rl;
            if (t) {
              var n = t;
              if (!ol(e, t)) {
                if (ul(e)) throw Error(l(418));
                t = sa(n.nextSibling);
                var r = nl;
                t && ol(e, t)
                  ? il(r, n)
                  : ((e.flags = (-4097 & e.flags) | 2), (al = !1), (nl = e));
              }
            } else {
              if (ul(e)) throw Error(l(418));
              ((e.flags = (-4097 & e.flags) | 2), (al = !1), (nl = e));
            }
          }
        }
        function cl(e) {
          for (
            e = e.return;
            null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;
          )
            e = e.return;
          nl = e;
        }
        function dl(e) {
          if (e !== nl) return !1;
          if (!al) return (cl(e), (al = !0), !1);
          var t;
          if (
            ((t = 3 !== e.tag) &&
              !(t = 5 !== e.tag) &&
              (t =
                "head" !== (t = e.type) &&
                "body" !== t &&
                !na(e.type, e.memoizedProps)),
            t && (t = rl))
          ) {
            if (ul(e)) throw (fl(), Error(l(418)));
            for (; t;) (il(e, t), (t = sa(t.nextSibling)));
          }
          if ((cl(e), 13 === e.tag)) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(l(317));
            e: {
              for (e = e.nextSibling, t = 0; e;) {
                if (8 === e.nodeType) {
                  var n = e.data;
                  if ("/$" === n) {
                    if (0 === t) {
                      rl = sa(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else ("$" !== n && "$!" !== n && "$?" !== n) || t++;
                }
                e = e.nextSibling;
              }
              rl = null;
            }
          } else rl = nl ? sa(e.stateNode.nextSibling) : null;
          return !0;
        }
        function fl() {
          for (var e = rl; e;) e = sa(e.nextSibling);
        }
        function pl() {
          ((rl = nl = null), (al = !1));
        }
        function ml(e) {
          null === ll ? (ll = [e]) : ll.push(e);
        }
        var gl = S.ReactCurrentBatchConfig;
        function hl(e, t, n) {
          if (
            null !== (e = n.ref) &&
            "function" != typeof e &&
            "object" != typeof e
          ) {
            if (n._owner) {
              if ((n = n._owner)) {
                if (1 !== n.tag) throw Error(l(309));
                var r = n.stateNode;
              }
              if (!r) throw Error(l(147, e));
              var a = r,
                i = "" + e;
              return null !== t &&
                null !== t.ref &&
                "function" == typeof t.ref &&
                t.ref._stringRef === i
                ? t.ref
                : ((t = function (e) {
                    var t = a.refs;
                    null === e ? delete t[i] : (t[i] = e);
                  }),
                  (t._stringRef = i),
                  t);
            }
            if ("string" != typeof e) throw Error(l(284));
            if (!n._owner) throw Error(l(290, e));
          }
          return e;
        }
        function yl(e, t) {
          throw (
            (e = Object.prototype.toString.call(t)),
            Error(
              l(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e,
              ),
            )
          );
        }
        function vl(e) {
          return (0, e._init)(e._payload);
        }
        function bl(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r;) (t(n, r), (r = r.sibling));
            return null;
          }
          function r(e, t) {
            for (e = new Map(); null !== t;)
              (null !== t.key ? e.set(t.key, t) : e.set(t.index, t),
                (t = t.sibling));
            return e;
          }
          function a(e, t) {
            return (((e = Ts(e, t)).index = 0), (e.sibling = null), e);
          }
          function i(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 2), n)
                    : r
                  : ((t.flags |= 2), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function o(t) {
            return (e && null === t.alternate && (t.flags |= 2), t);
          }
          function u(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Os(n, e.mode, r)).return = e), t)
              : (((t = a(t, n)).return = e), t);
          }
          function s(e, t, n, r) {
            var l = n.type;
            return l === w
              ? d(e, t, n.props.children, r, n.key)
              : null !== t &&
                  (t.elementType === l ||
                    ("object" == typeof l &&
                      null !== l &&
                      l.$$typeof === X &&
                      vl(l) === t.type))
                ? (((r = a(t, n.props)).ref = hl(e, t, n)), (r.return = e), r)
                : (((r = zs(n.type, n.key, n.props, null, e.mode, r)).ref = hl(
                    e,
                    t,
                    n,
                  )),
                  (r.return = e),
                  r);
          }
          function c(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = As(n, e.mode, r)).return = e), t)
              : (((t = a(t, n.children || [])).return = e), t);
          }
          function d(e, t, n, r, l) {
            return null === t || 7 !== t.tag
              ? (((t = Rs(n, e.mode, r, l)).return = e), t)
              : (((t = a(t, n)).return = e), t);
          }
          function f(e, t, n) {
            if (("string" == typeof t && "" !== t) || "number" == typeof t)
              return (((t = Os("" + t, e.mode, n)).return = e), t);
            if ("object" == typeof t && null !== t) {
              switch (t.$$typeof) {
                case E:
                  return (
                    ((n = zs(t.type, t.key, t.props, null, e.mode, n)).ref = hl(
                      e,
                      null,
                      t,
                    )),
                    (n.return = e),
                    n
                  );
                case k:
                  return (((t = As(t, e.mode, n)).return = e), t);
                case X:
                  return f(e, (0, t._init)(t._payload), n);
              }
              if (te(t) || R(t))
                return (((t = Rs(t, e.mode, n, null)).return = e), t);
              yl(e, t);
            }
            return null;
          }
          function p(e, t, n, r) {
            var a = null !== t ? t.key : null;
            if (("string" == typeof n && "" !== n) || "number" == typeof n)
              return null !== a ? null : u(e, t, "" + n, r);
            if ("object" == typeof n && null !== n) {
              switch (n.$$typeof) {
                case E:
                  return n.key === a ? s(e, t, n, r) : null;
                case k:
                  return n.key === a ? c(e, t, n, r) : null;
                case X:
                  return p(e, t, (a = n._init)(n._payload), r);
              }
              if (te(n) || R(n)) return null !== a ? null : d(e, t, n, r, null);
              yl(e, n);
            }
            return null;
          }
          function m(e, t, n, r, a) {
            if (("string" == typeof r && "" !== r) || "number" == typeof r)
              return u(t, (e = e.get(n) || null), "" + r, a);
            if ("object" == typeof r && null !== r) {
              switch (r.$$typeof) {
                case E:
                  return s(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    a,
                  );
                case k:
                  return c(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    a,
                  );
                case X:
                  return m(e, t, n, (0, r._init)(r._payload), a);
              }
              if (te(r) || R(r))
                return d(t, (e = e.get(n) || null), r, a, null);
              yl(t, r);
            }
            return null;
          }
          function g(a, l, o, u) {
            for (
              var s = null, c = null, d = l, g = (l = 0), h = null;
              null !== d && g < o.length;
              g++
            ) {
              d.index > g ? ((h = d), (d = null)) : (h = d.sibling);
              var y = p(a, d, o[g], u);
              if (null === y) {
                null === d && (d = h);
                break;
              }
              (e && d && null === y.alternate && t(a, d),
                (l = i(y, l, g)),
                null === c ? (s = y) : (c.sibling = y),
                (c = y),
                (d = h));
            }
            if (g === o.length) return (n(a, d), al && Ja(a, g), s);
            if (null === d) {
              for (; g < o.length; g++)
                null !== (d = f(a, o[g], u)) &&
                  ((l = i(d, l, g)),
                  null === c ? (s = d) : (c.sibling = d),
                  (c = d));
              return (al && Ja(a, g), s);
            }
            for (d = r(a, d); g < o.length; g++)
              null !== (h = m(d, a, g, o[g], u)) &&
                (e &&
                  null !== h.alternate &&
                  d.delete(null === h.key ? g : h.key),
                (l = i(h, l, g)),
                null === c ? (s = h) : (c.sibling = h),
                (c = h));
            return (
              e &&
                d.forEach(function (e) {
                  return t(a, e);
                }),
              al && Ja(a, g),
              s
            );
          }
          function h(a, o, u, s) {
            var c = R(u);
            if ("function" != typeof c) throw Error(l(150));
            if (null == (u = c.call(u))) throw Error(l(151));
            for (
              var d = (c = null), g = o, h = (o = 0), y = null, v = u.next();
              null !== g && !v.done;
              h++, v = u.next()
            ) {
              g.index > h ? ((y = g), (g = null)) : (y = g.sibling);
              var b = p(a, g, v.value, s);
              if (null === b) {
                null === g && (g = y);
                break;
              }
              (e && g && null === b.alternate && t(a, g),
                (o = i(b, o, h)),
                null === d ? (c = b) : (d.sibling = b),
                (d = b),
                (g = y));
            }
            if (v.done) return (n(a, g), al && Ja(a, h), c);
            if (null === g) {
              for (; !v.done; h++, v = u.next())
                null !== (v = f(a, v.value, s)) &&
                  ((o = i(v, o, h)),
                  null === d ? (c = v) : (d.sibling = v),
                  (d = v));
              return (al && Ja(a, h), c);
            }
            for (g = r(a, g); !v.done; h++, v = u.next())
              null !== (v = m(g, a, h, v.value, s)) &&
                (e &&
                  null !== v.alternate &&
                  g.delete(null === v.key ? h : v.key),
                (o = i(v, o, h)),
                null === d ? (c = v) : (d.sibling = v),
                (d = v));
            return (
              e &&
                g.forEach(function (e) {
                  return t(a, e);
                }),
              al && Ja(a, h),
              c
            );
          }
          return function e(r, l, i, u) {
            if (
              ("object" == typeof i &&
                null !== i &&
                i.type === w &&
                null === i.key &&
                (i = i.props.children),
              "object" == typeof i && null !== i)
            ) {
              switch (i.$$typeof) {
                case E:
                  e: {
                    for (var s = i.key, c = l; null !== c;) {
                      if (c.key === s) {
                        if ((s = i.type) === w) {
                          if (7 === c.tag) {
                            (n(r, c.sibling),
                              ((l = a(c, i.props.children)).return = r),
                              (r = l));
                            break e;
                          }
                        } else if (
                          c.elementType === s ||
                          ("object" == typeof s &&
                            null !== s &&
                            s.$$typeof === X &&
                            vl(s) === c.type)
                        ) {
                          (n(r, c.sibling),
                            ((l = a(c, i.props)).ref = hl(r, c, i)),
                            (l.return = r),
                            (r = l));
                          break e;
                        }
                        n(r, c);
                        break;
                      }
                      (t(r, c), (c = c.sibling));
                    }
                    i.type === w
                      ? (((l = Rs(i.props.children, r.mode, u, i.key)).return =
                          r),
                        (r = l))
                      : (((u = zs(
                          i.type,
                          i.key,
                          i.props,
                          null,
                          r.mode,
                          u,
                        )).ref = hl(r, l, i)),
                        (u.return = r),
                        (r = u));
                  }
                  return o(r);
                case k:
                  e: {
                    for (c = i.key; null !== l;) {
                      if (l.key === c) {
                        if (
                          4 === l.tag &&
                          l.stateNode.containerInfo === i.containerInfo &&
                          l.stateNode.implementation === i.implementation
                        ) {
                          (n(r, l.sibling),
                            ((l = a(l, i.children || [])).return = r),
                            (r = l));
                          break e;
                        }
                        n(r, l);
                        break;
                      }
                      (t(r, l), (l = l.sibling));
                    }
                    (((l = As(i, r.mode, u)).return = r), (r = l));
                  }
                  return o(r);
                case X:
                  return e(r, l, (c = i._init)(i._payload), u);
              }
              if (te(i)) return g(r, l, i, u);
              if (R(i)) return h(r, l, i, u);
              yl(r, i);
            }
            return ("string" == typeof i && "" !== i) || "number" == typeof i
              ? ((i = "" + i),
                null !== l && 6 === l.tag
                  ? (n(r, l.sibling), ((l = a(l, i)).return = r), (r = l))
                  : (n(r, l), ((l = Os(i, r.mode, u)).return = r), (r = l)),
                o(r))
              : n(r, l);
          };
        }
        var Sl = bl(!0),
          El = bl(!1),
          kl = xa(null),
          wl = null,
          xl = null,
          Cl = null;
        function _l() {
          Cl = xl = wl = null;
        }
        function Pl(e) {
          var t = kl.current;
          (Ca(kl), (e._currentValue = t));
        }
        function Dl(e, t, n) {
          for (; null !== e;) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function Nl(e, t) {
          ((wl = e),
            (Cl = xl = null),
            null !== (e = e.dependencies) &&
              null !== e.firstContext &&
              (!!(e.lanes & t) && (bo = !0), (e.firstContext = null)));
        }
        function Ll(e) {
          var t = e._currentValue;
          if (Cl !== e)
            if (
              ((e = { context: e, memoizedValue: t, next: null }), null === xl)
            ) {
              if (null === wl) throw Error(l(308));
              ((xl = e), (wl.dependencies = { lanes: 0, firstContext: e }));
            } else xl = xl.next = e;
          return t;
        }
        var Ml = null;
        function Xl(e) {
          null === Ml ? (Ml = [e]) : Ml.push(e);
        }
        function Tl(e, t, n, r) {
          var a = t.interleaved;
          return (
            null === a
              ? ((n.next = n), Xl(t))
              : ((n.next = a.next), (a.next = n)),
            (t.interleaved = n),
            zl(e, r)
          );
        }
        function zl(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e;)
            ((e.childLanes |= t),
              null !== (n = e.alternate) && (n.childLanes |= t),
              (n = e),
              (e = e.return));
          return 3 === n.tag ? n.stateNode : null;
        }
        var Rl = !1;
        function Yl(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          };
        }
        function Ol(e, t) {
          ((e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                effects: e.effects,
              }));
        }
        function Al(e, t) {
          return {
            eventTime: e,
            lane: t,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
          };
        }
        function Fl(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 2 & Du)) {
            var a = r.pending;
            return (
              null === a ? (t.next = t) : ((t.next = a.next), (a.next = t)),
              (r.pending = t),
              zl(e, n)
            );
          }
          return (
            null === (a = r.interleaved)
              ? ((t.next = t), Xl(r))
              : ((t.next = a.next), (a.next = t)),
            (r.interleaved = t),
            zl(e, n)
          );
        }
        function Bl(e, t, n) {
          if (null !== (t = t.updateQueue) && ((t = t.shared), 4194240 & n)) {
            var r = t.lanes;
            ((n |= r &= e.pendingLanes), (t.lanes = n), vt(e, n));
          }
        }
        function Il(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var a = null,
              l = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  eventTime: n.eventTime,
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: n.callback,
                  next: null,
                };
                (null === l ? (a = l = i) : (l = l.next = i), (n = n.next));
              } while (null !== n);
              null === l ? (a = l = t) : (l = l.next = t);
            } else a = l = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: a,
                lastBaseUpdate: l,
                shared: r.shared,
                effects: r.effects,
              }),
              void (e.updateQueue = n)
            );
          }
          (null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t));
        }
        function Ul(e, t, n, r) {
          var a = e.updateQueue;
          Rl = !1;
          var l = a.firstBaseUpdate,
            i = a.lastBaseUpdate,
            o = a.shared.pending;
          if (null !== o) {
            a.shared.pending = null;
            var u = o,
              s = u.next;
            ((u.next = null), null === i ? (l = s) : (i.next = s), (i = u));
            var c = e.alternate;
            null !== c &&
              (o = (c = c.updateQueue).lastBaseUpdate) !== i &&
              (null === o ? (c.firstBaseUpdate = s) : (o.next = s),
              (c.lastBaseUpdate = u));
          }
          if (null !== l) {
            var d = a.baseState;
            for (i = 0, c = s = u = null, o = l; ;) {
              var f = o.lane,
                p = o.eventTime;
              if ((r & f) === f) {
                null !== c &&
                  (c = c.next =
                    {
                      eventTime: p,
                      lane: 0,
                      tag: o.tag,
                      payload: o.payload,
                      callback: o.callback,
                      next: null,
                    });
                e: {
                  var m = e,
                    g = o;
                  switch (((f = t), (p = n), g.tag)) {
                    case 1:
                      if ("function" == typeof (m = g.payload)) {
                        d = m.call(p, d, f);
                        break e;
                      }
                      d = m;
                      break e;
                    case 3:
                      m.flags = (-65537 & m.flags) | 128;
                    case 0:
                      if (
                        null ==
                        (f =
                          "function" == typeof (m = g.payload)
                            ? m.call(p, d, f)
                            : m)
                      )
                        break e;
                      d = O({}, d, f);
                      break e;
                    case 2:
                      Rl = !0;
                  }
                }
                null !== o.callback &&
                  0 !== o.lane &&
                  ((e.flags |= 64),
                  null === (f = a.effects) ? (a.effects = [o]) : f.push(o));
              } else
                ((p = {
                  eventTime: p,
                  lane: f,
                  tag: o.tag,
                  payload: o.payload,
                  callback: o.callback,
                  next: null,
                }),
                  null === c ? ((s = c = p), (u = d)) : (c = c.next = p),
                  (i |= f));
              if (null === (o = o.next)) {
                if (null === (o = a.shared.pending)) break;
                ((o = (f = o).next),
                  (f.next = null),
                  (a.lastBaseUpdate = f),
                  (a.shared.pending = null));
              }
            }
            if (
              (null === c && (u = d),
              (a.baseState = u),
              (a.firstBaseUpdate = s),
              (a.lastBaseUpdate = c),
              null !== (t = a.shared.interleaved))
            ) {
              a = t;
              do {
                ((i |= a.lane), (a = a.next));
              } while (a !== t);
            } else null === l && (a.shared.lanes = 0);
            ((Yu |= i), (e.lanes = i), (e.memoizedState = d));
          }
        }
        function Vl(e, t, n) {
          if (((e = t.effects), (t.effects = null), null !== e))
            for (t = 0; t < e.length; t++) {
              var r = e[t],
                a = r.callback;
              if (null !== a) {
                if (((r.callback = null), (r = n), "function" != typeof a))
                  throw Error(l(191, a));
                a.call(r);
              }
            }
        }
        var ql = {},
          $l = xa(ql),
          jl = xa(ql),
          Wl = xa(ql);
        function Hl(e) {
          if (e === ql) throw Error(l(174));
          return e;
        }
        function Ql(e, t) {
          switch ((_a(Wl, t), _a(jl, e), _a($l, ql), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) ? t.namespaceURI : ue(null, "");
              break;
            default:
              t = ue(
                (t = (e = 8 === e ? t.parentNode : t).namespaceURI || null),
                (e = e.tagName),
              );
          }
          (Ca($l), _a($l, t));
        }
        function Kl() {
          (Ca($l), Ca(jl), Ca(Wl));
        }
        function Gl(e) {
          Hl(Wl.current);
          var t = Hl($l.current),
            n = ue(t, e.type);
          t !== n && (_a(jl, e), _a($l, n));
        }
        function Jl(e) {
          jl.current === e && (Ca($l), Ca(jl));
        }
        var Zl = xa(0);
        function ei(e) {
          for (var t = e; null !== t;) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) ||
                  "$?" === n.data ||
                  "$!" === n.data)
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (128 & t.flags) return t;
            } else if (null !== t.child) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling;) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            ((t.sibling.return = t.return), (t = t.sibling));
          }
          return null;
        }
        var ti = [];
        function ni() {
          for (var e = 0; e < ti.length; e++)
            ti[e]._workInProgressVersionPrimary = null;
          ti.length = 0;
        }
        var ri = S.ReactCurrentDispatcher,
          ai = S.ReactCurrentBatchConfig,
          li = 0,
          ii = null,
          oi = null,
          ui = null,
          si = !1,
          ci = !1,
          di = 0,
          fi = 0;
        function pi() {
          throw Error(l(321));
        }
        function mi(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!or(e[n], t[n])) return !1;
          return !0;
        }
        function gi(e, t, n, r, a, i) {
          if (
            ((li = i),
            (ii = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (ri.current = null === e || null === e.memoizedState ? Ji : Zi),
            (e = n(r, a)),
            ci)
          ) {
            i = 0;
            do {
              if (((ci = !1), (di = 0), 25 <= i)) throw Error(l(301));
              ((i += 1),
                (ui = oi = null),
                (t.updateQueue = null),
                (ri.current = eo),
                (e = n(r, a)));
            } while (ci);
          }
          if (
            ((ri.current = Gi),
            (t = null !== oi && null !== oi.next),
            (li = 0),
            (ui = oi = ii = null),
            (si = !1),
            t)
          )
            throw Error(l(300));
          return e;
        }
        function hi() {
          var e = 0 !== di;
          return ((di = 0), e);
        }
        function yi() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === ui ? (ii.memoizedState = ui = e) : (ui = ui.next = e),
            ui
          );
        }
        function vi() {
          if (null === oi) {
            var e = ii.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = oi.next;
          var t = null === ui ? ii.memoizedState : ui.next;
          if (null !== t) ((ui = t), (oi = e));
          else {
            if (null === e) throw Error(l(310));
            ((e = {
              memoizedState: (oi = e).memoizedState,
              baseState: oi.baseState,
              baseQueue: oi.baseQueue,
              queue: oi.queue,
              next: null,
            }),
              null === ui ? (ii.memoizedState = ui = e) : (ui = ui.next = e));
          }
          return ui;
        }
        function bi(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
        function Si(e) {
          var t = vi(),
            n = t.queue;
          if (null === n) throw Error(l(311));
          n.lastRenderedReducer = e;
          var r = oi,
            a = r.baseQueue,
            i = n.pending;
          if (null !== i) {
            if (null !== a) {
              var o = a.next;
              ((a.next = i.next), (i.next = o));
            }
            ((r.baseQueue = a = i), (n.pending = null));
          }
          if (null !== a) {
            ((i = a.next), (r = r.baseState));
            var u = (o = null),
              s = null,
              c = i;
            do {
              var d = c.lane;
              if ((li & d) === d)
                (null !== s &&
                  (s = s.next =
                    {
                      lane: 0,
                      action: c.action,
                      hasEagerState: c.hasEagerState,
                      eagerState: c.eagerState,
                      next: null,
                    }),
                  (r = c.hasEagerState ? c.eagerState : e(r, c.action)));
              else {
                var f = {
                  lane: d,
                  action: c.action,
                  hasEagerState: c.hasEagerState,
                  eagerState: c.eagerState,
                  next: null,
                };
                (null === s ? ((u = s = f), (o = r)) : (s = s.next = f),
                  (ii.lanes |= d),
                  (Yu |= d));
              }
              c = c.next;
            } while (null !== c && c !== i);
            (null === s ? (o = r) : (s.next = u),
              or(r, t.memoizedState) || (bo = !0),
              (t.memoizedState = r),
              (t.baseState = o),
              (t.baseQueue = s),
              (n.lastRenderedState = r));
          }
          if (null !== (e = n.interleaved)) {
            a = e;
            do {
              ((i = a.lane), (ii.lanes |= i), (Yu |= i), (a = a.next));
            } while (a !== e);
          } else null === a && (n.lanes = 0);
          return [t.memoizedState, n.dispatch];
        }
        function Ei(e) {
          var t = vi(),
            n = t.queue;
          if (null === n) throw Error(l(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            a = n.pending,
            i = t.memoizedState;
          if (null !== a) {
            n.pending = null;
            var o = (a = a.next);
            do {
              ((i = e(i, o.action)), (o = o.next));
            } while (o !== a);
            (or(i, t.memoizedState) || (bo = !0),
              (t.memoizedState = i),
              null === t.baseQueue && (t.baseState = i),
              (n.lastRenderedState = i));
          }
          return [i, r];
        }
        function ki() {}
        function wi(e, t) {
          var n = ii,
            r = vi(),
            a = t(),
            i = !or(r.memoizedState, a);
          if (
            (i && ((r.memoizedState = a), (bo = !0)),
            (r = r.queue),
            Ri(_i.bind(null, n, r, e), [e]),
            r.getSnapshot !== t ||
              i ||
              (null !== ui && 1 & ui.memoizedState.tag))
          ) {
            if (
              ((n.flags |= 2048),
              Li(9, Ci.bind(null, n, r, a, t), void 0, null),
              null === Nu)
            )
              throw Error(l(349));
            30 & li || xi(n, t, a);
          }
          return a;
        }
        function xi(e, t, n) {
          ((e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = ii.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (ii.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
                ? (t.stores = [e])
                : n.push(e));
        }
        function Ci(e, t, n, r) {
          ((t.value = n), (t.getSnapshot = r), Pi(t) && Di(e));
        }
        function _i(e, t, n) {
          return n(function () {
            Pi(t) && Di(e);
          });
        }
        function Pi(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !or(e, n);
          } catch (e) {
            return !0;
          }
        }
        function Di(e) {
          var t = zl(e, 1);
          null !== t && ns(t, e, 1, -1);
        }
        function Ni(e) {
          var t = yi();
          return (
            "function" == typeof e && (e = e()),
            (t.memoizedState = t.baseState = e),
            (e = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: bi,
              lastRenderedState: e,
            }),
            (t.queue = e),
            (e = e.dispatch = Wi.bind(null, ii, e)),
            [t.memoizedState, e]
          );
        }
        function Li(e, t, n, r) {
          return (
            (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
            null === (t = ii.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (ii.updateQueue = t),
                (t.lastEffect = e.next = e))
              : null === (n = t.lastEffect)
                ? (t.lastEffect = e.next = e)
                : ((r = n.next),
                  (n.next = e),
                  (e.next = r),
                  (t.lastEffect = e)),
            e
          );
        }
        function Mi() {
          return vi().memoizedState;
        }
        function Xi(e, t, n, r) {
          var a = yi();
          ((ii.flags |= e),
            (a.memoizedState = Li(1 | t, n, void 0, void 0 === r ? null : r)));
        }
        function Ti(e, t, n, r) {
          var a = vi();
          r = void 0 === r ? null : r;
          var l = void 0;
          if (null !== oi) {
            var i = oi.memoizedState;
            if (((l = i.destroy), null !== r && mi(r, i.deps)))
              return void (a.memoizedState = Li(t, n, l, r));
          }
          ((ii.flags |= e), (a.memoizedState = Li(1 | t, n, l, r)));
        }
        function zi(e, t) {
          return Xi(8390656, 8, e, t);
        }
        function Ri(e, t) {
          return Ti(2048, 8, e, t);
        }
        function Yi(e, t) {
          return Ti(4, 2, e, t);
        }
        function Oi(e, t) {
          return Ti(4, 4, e, t);
        }
        function Ai(e, t) {
          return "function" == typeof t
            ? ((e = e()),
              t(e),
              function () {
                t(null);
              })
            : null != t
              ? ((e = e()),
                (t.current = e),
                function () {
                  t.current = null;
                })
              : void 0;
        }
        function Fi(e, t, n) {
          return (
            (n = null != n ? n.concat([e]) : null),
            Ti(4, 4, Ai.bind(null, t, e), n)
          );
        }
        function Bi() {}
        function Ii(e, t) {
          var n = vi();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && mi(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function Ui(e, t) {
          var n = vi();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && mi(t, r[1])
            ? r[0]
            : ((e = e()), (n.memoizedState = [e, t]), e);
        }
        function Vi(e, t, n) {
          return 21 & li
            ? (or(n, t) ||
                ((n = gt()), (ii.lanes |= n), (Yu |= n), (e.baseState = !0)),
              t)
            : (e.baseState && ((e.baseState = !1), (bo = !0)),
              (e.memoizedState = n));
        }
        function qi(e, t) {
          var n = bt;
          ((bt = 0 !== n && 4 > n ? n : 4), e(!0));
          var r = ai.transition;
          ai.transition = {};
          try {
            (e(!1), t());
          } finally {
            ((bt = n), (ai.transition = r));
          }
        }
        function $i() {
          return vi().memoizedState;
        }
        function ji(e, t, n) {
          var r = ts(e);
          ((n = {
            lane: r,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Hi(e)
              ? Qi(t, n)
              : null !== (n = Tl(e, t, n, r)) &&
                (ns(n, e, r, es()), Ki(n, t, r)));
        }
        function Wi(e, t, n) {
          var r = ts(e),
            a = {
              lane: r,
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            };
          if (Hi(e)) Qi(t, a);
          else {
            var l = e.alternate;
            if (
              0 === e.lanes &&
              (null === l || 0 === l.lanes) &&
              null !== (l = t.lastRenderedReducer)
            )
              try {
                var i = t.lastRenderedState,
                  o = l(i, n);
                if (((a.hasEagerState = !0), (a.eagerState = o), or(o, i))) {
                  var u = t.interleaved;
                  return (
                    null === u
                      ? ((a.next = a), Xl(t))
                      : ((a.next = u.next), (u.next = a)),
                    void (t.interleaved = a)
                  );
                }
              } catch (e) {}
            null !== (n = Tl(e, t, a, r)) &&
              (ns(n, e, r, (a = es())), Ki(n, t, r));
          }
        }
        function Hi(e) {
          var t = e.alternate;
          return e === ii || (null !== t && t === ii);
        }
        function Qi(e, t) {
          ci = si = !0;
          var n = e.pending;
          (null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t));
        }
        function Ki(e, t, n) {
          if (4194240 & n) {
            var r = t.lanes;
            ((n |= r &= e.pendingLanes), (t.lanes = n), vt(e, n));
          }
        }
        var Gi = {
            readContext: Ll,
            useCallback: pi,
            useContext: pi,
            useEffect: pi,
            useImperativeHandle: pi,
            useInsertionEffect: pi,
            useLayoutEffect: pi,
            useMemo: pi,
            useReducer: pi,
            useRef: pi,
            useState: pi,
            useDebugValue: pi,
            useDeferredValue: pi,
            useTransition: pi,
            useMutableSource: pi,
            useSyncExternalStore: pi,
            useId: pi,
            unstable_isNewReconciler: !1,
          },
          Ji = {
            readContext: Ll,
            useCallback: function (e, t) {
              return ((yi().memoizedState = [e, void 0 === t ? null : t]), e);
            },
            useContext: Ll,
            useEffect: zi,
            useImperativeHandle: function (e, t, n) {
              return (
                (n = null != n ? n.concat([e]) : null),
                Xi(4194308, 4, Ai.bind(null, t, e), n)
              );
            },
            useLayoutEffect: function (e, t) {
              return Xi(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              return Xi(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = yi();
              return (
                (t = void 0 === t ? null : t),
                (e = e()),
                (n.memoizedState = [e, t]),
                e
              );
            },
            useReducer: function (e, t, n) {
              var r = yi();
              return (
                (t = void 0 !== n ? n(t) : t),
                (r.memoizedState = r.baseState = t),
                (e = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: t,
                }),
                (r.queue = e),
                (e = e.dispatch = ji.bind(null, ii, e)),
                [r.memoizedState, e]
              );
            },
            useRef: function (e) {
              return ((e = { current: e }), (yi().memoizedState = e));
            },
            useState: Ni,
            useDebugValue: Bi,
            useDeferredValue: function (e) {
              return (yi().memoizedState = e);
            },
            useTransition: function () {
              var e = Ni(!1),
                t = e[0];
              return (
                (e = qi.bind(null, e[1])),
                (yi().memoizedState = e),
                [t, e]
              );
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (e, t, n) {
              var r = ii,
                a = yi();
              if (al) {
                if (void 0 === n) throw Error(l(407));
                n = n();
              } else {
                if (((n = t()), null === Nu)) throw Error(l(349));
                30 & li || xi(r, t, n);
              }
              a.memoizedState = n;
              var i = { value: n, getSnapshot: t };
              return (
                (a.queue = i),
                zi(_i.bind(null, r, i, e), [e]),
                (r.flags |= 2048),
                Li(9, Ci.bind(null, r, i, n, t), void 0, null),
                n
              );
            },
            useId: function () {
              var e = yi(),
                t = Nu.identifierPrefix;
              if (al) {
                var n = Ga;
                ((t =
                  ":" +
                  t +
                  "R" +
                  (n = (Ka & ~(1 << (32 - it(Ka) - 1))).toString(32) + n)),
                  0 < (n = di++) && (t += "H" + n.toString(32)),
                  (t += ":"));
              } else t = ":" + t + "r" + (n = fi++).toString(32) + ":";
              return (e.memoizedState = t);
            },
            unstable_isNewReconciler: !1,
          },
          Zi = {
            readContext: Ll,
            useCallback: Ii,
            useContext: Ll,
            useEffect: Ri,
            useImperativeHandle: Fi,
            useInsertionEffect: Yi,
            useLayoutEffect: Oi,
            useMemo: Ui,
            useReducer: Si,
            useRef: Mi,
            useState: function () {
              return Si(bi);
            },
            useDebugValue: Bi,
            useDeferredValue: function (e) {
              return Vi(vi(), oi.memoizedState, e);
            },
            useTransition: function () {
              return [Si(bi)[0], vi().memoizedState];
            },
            useMutableSource: ki,
            useSyncExternalStore: wi,
            useId: $i,
            unstable_isNewReconciler: !1,
          },
          eo = {
            readContext: Ll,
            useCallback: Ii,
            useContext: Ll,
            useEffect: Ri,
            useImperativeHandle: Fi,
            useInsertionEffect: Yi,
            useLayoutEffect: Oi,
            useMemo: Ui,
            useReducer: Ei,
            useRef: Mi,
            useState: function () {
              return Ei(bi);
            },
            useDebugValue: Bi,
            useDeferredValue: function (e) {
              var t = vi();
              return null === oi
                ? (t.memoizedState = e)
                : Vi(t, oi.memoizedState, e);
            },
            useTransition: function () {
              return [Ei(bi)[0], vi().memoizedState];
            },
            useMutableSource: ki,
            useSyncExternalStore: wi,
            useId: $i,
            unstable_isNewReconciler: !1,
          };
        function to(e, t) {
          if (e && e.defaultProps) {
            for (var n in ((t = O({}, t)), (e = e.defaultProps)))
              void 0 === t[n] && (t[n] = e[n]);
            return t;
          }
          return t;
        }
        function no(e, t, n, r) {
          ((n = null == (n = n(r, (t = e.memoizedState))) ? t : O({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n));
        }
        var ro = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && Ue(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = es(),
              a = ts(e),
              l = Al(r, a);
            ((l.payload = t),
              null != n && (l.callback = n),
              null !== (t = Fl(e, l, a)) && (ns(t, e, a, r), Bl(t, e, a)));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = es(),
              a = ts(e),
              l = Al(r, a);
            ((l.tag = 1),
              (l.payload = t),
              null != n && (l.callback = n),
              null !== (t = Fl(e, l, a)) && (ns(t, e, a, r), Bl(t, e, a)));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = es(),
              r = ts(e),
              a = Al(n, r);
            ((a.tag = 2),
              null != t && (a.callback = t),
              null !== (t = Fl(e, a, r)) && (ns(t, e, r, n), Bl(t, e, r)));
          },
        };
        function ao(e, t, n, r, a, l, i) {
          return "function" == typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, l, i)
            : !(
                t.prototype &&
                t.prototype.isPureReactComponent &&
                ur(n, r) &&
                ur(a, l)
              );
        }
        function lo(e, t, n) {
          var r = !1,
            a = Pa,
            l = t.contextType;
          return (
            "object" == typeof l && null !== l
              ? (l = Ll(l))
              : ((a = Xa(t) ? La : Da.current),
                (l = (r = null != (r = t.contextTypes)) ? Ma(e, a) : Pa)),
            (t = new t(n, l)),
            (e.memoizedState =
              null !== t.state && void 0 !== t.state ? t.state : null),
            (t.updater = ro),
            (e.stateNode = t),
            (t._reactInternals = e),
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                a),
              (e.__reactInternalMemoizedMaskedChildContext = l)),
            t
          );
        }
        function io(e, t, n, r) {
          ((e = t.state),
            "function" == typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" == typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && ro.enqueueReplaceState(t, t.state, null));
        }
        function oo(e, t, n, r) {
          var a = e.stateNode;
          ((a.props = n), (a.state = e.memoizedState), (a.refs = {}), Yl(e));
          var l = t.contextType;
          ("object" == typeof l && null !== l
            ? (a.context = Ll(l))
            : ((l = Xa(t) ? La : Da.current), (a.context = Ma(e, l))),
            (a.state = e.memoizedState),
            "function" == typeof (l = t.getDerivedStateFromProps) &&
              (no(e, t, l, n), (a.state = e.memoizedState)),
            "function" == typeof t.getDerivedStateFromProps ||
              "function" == typeof a.getSnapshotBeforeUpdate ||
              ("function" != typeof a.UNSAFE_componentWillMount &&
                "function" != typeof a.componentWillMount) ||
              ((t = a.state),
              "function" == typeof a.componentWillMount &&
                a.componentWillMount(),
              "function" == typeof a.UNSAFE_componentWillMount &&
                a.UNSAFE_componentWillMount(),
              t !== a.state && ro.enqueueReplaceState(a, a.state, null),
              Ul(e, n, a, r),
              (a.state = e.memoizedState)),
            "function" == typeof a.componentDidMount && (e.flags |= 4194308));
        }
        function uo(e, t) {
          try {
            var n = "",
              r = t;
            do {
              ((n += I(r)), (r = r.return));
            } while (r);
            var a = n;
          } catch (e) {
            a = "\nError generating stack: " + e.message + "\n" + e.stack;
          }
          return { value: e, source: t, stack: a, digest: null };
        }
        function so(e, t, n) {
          return {
            value: e,
            source: null,
            stack: null != n ? n : null,
            digest: null != t ? t : null,
          };
        }
        function co(e, t) {
          try {
            console.error(t.value);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        var fo = "function" == typeof WeakMap ? WeakMap : Map;
        function po(e, t, n) {
          (((n = Al(-1, n)).tag = 3), (n.payload = { element: null }));
          var r = t.value;
          return (
            (n.callback = function () {
              (qu || ((qu = !0), ($u = r)), co(0, t));
            }),
            n
          );
        }
        function mo(e, t, n) {
          (n = Al(-1, n)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ("function" == typeof r) {
            var a = t.value;
            ((n.payload = function () {
              return r(a);
            }),
              (n.callback = function () {
                co(0, t);
              }));
          }
          var l = e.stateNode;
          return (
            null !== l &&
              "function" == typeof l.componentDidCatch &&
              (n.callback = function () {
                (co(0, t),
                  "function" != typeof r &&
                    (null === ju ? (ju = new Set([this])) : ju.add(this)));
                var e = t.stack;
                this.componentDidCatch(t.value, {
                  componentStack: null !== e ? e : "",
                });
              }),
            n
          );
        }
        function go(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new fo();
            var a = new Set();
            r.set(t, a);
          } else void 0 === (a = r.get(t)) && ((a = new Set()), r.set(t, a));
          a.has(n) || (a.add(n), (e = Cs.bind(null, e, t, n)), t.then(e, e));
        }
        function ho(e) {
          do {
            var t;
            if (
              ((t = 13 === e.tag) &&
                (t = null === (t = e.memoizedState) || null !== t.dehydrated),
              t)
            )
              return e;
            e = e.return;
          } while (null !== e);
          return null;
        }
        function yo(e, t, n, r, a) {
          return 1 & e.mode
            ? ((e.flags |= 65536), (e.lanes = a), e)
            : (e === t
                ? (e.flags |= 65536)
                : ((e.flags |= 128),
                  (n.flags |= 131072),
                  (n.flags &= -52805),
                  1 === n.tag &&
                    (null === n.alternate
                      ? (n.tag = 17)
                      : (((t = Al(-1, 1)).tag = 2), Fl(n, t, 1))),
                  (n.lanes |= 1)),
              e);
        }
        var vo = S.ReactCurrentOwner,
          bo = !1;
        function So(e, t, n, r) {
          t.child = null === e ? El(t, null, n, r) : Sl(t, e.child, n, r);
        }
        function Eo(e, t, n, r, a) {
          n = n.render;
          var l = t.ref;
          return (
            Nl(t, a),
            (r = gi(e, t, n, r, l, a)),
            (n = hi()),
            null === e || bo
              ? (al && n && el(t), (t.flags |= 1), So(e, t, r, a), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~a),
                qo(e, t, a))
          );
        }
        function ko(e, t, n, r, a) {
          if (null === e) {
            var l = n.type;
            return "function" != typeof l ||
              Xs(l) ||
              void 0 !== l.defaultProps ||
              null !== n.compare ||
              void 0 !== n.defaultProps
              ? (((e = zs(n.type, null, r, t, t.mode, a)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = l), wo(e, t, l, r, a));
          }
          if (((l = e.child), !(e.lanes & a))) {
            var i = l.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : ur)(i, r) &&
              e.ref === t.ref
            )
              return qo(e, t, a);
          }
          return (
            (t.flags |= 1),
            ((e = Ts(l, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function wo(e, t, n, r, a) {
          if (null !== e) {
            var l = e.memoizedProps;
            if (ur(l, r) && e.ref === t.ref) {
              if (((bo = !1), (t.pendingProps = r = l), !(e.lanes & a)))
                return ((t.lanes = e.lanes), qo(e, t, a));
              131072 & e.flags && (bo = !0);
            }
          }
          return _o(e, t, n, r, a);
        }
        function xo(e, t, n) {
          var r = t.pendingProps,
            a = r.children,
            l = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode)
            if (1 & t.mode) {
              if (!(1073741824 & n))
                return (
                  (e = null !== l ? l.baseLanes | n : n),
                  (t.lanes = t.childLanes = 1073741824),
                  (t.memoizedState = {
                    baseLanes: e,
                    cachePool: null,
                    transitions: null,
                  }),
                  (t.updateQueue = null),
                  _a(Tu, Xu),
                  (Xu |= e),
                  null
                );
              ((t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                (r = null !== l ? l.baseLanes : n),
                _a(Tu, Xu),
                (Xu |= r));
            } else
              ((t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                _a(Tu, Xu),
                (Xu |= n));
          else
            (null !== l
              ? ((r = l.baseLanes | n), (t.memoizedState = null))
              : (r = n),
              _a(Tu, Xu),
              (Xu |= r));
          return (So(e, t, a, n), t.child);
        }
        function Co(e, t) {
          var n = t.ref;
          ((null === e && null !== n) || (null !== e && e.ref !== n)) &&
            ((t.flags |= 512), (t.flags |= 2097152));
        }
        function _o(e, t, n, r, a) {
          var l = Xa(n) ? La : Da.current;
          return (
            (l = Ma(t, l)),
            Nl(t, a),
            (n = gi(e, t, n, r, l, a)),
            (r = hi()),
            null === e || bo
              ? (al && r && el(t), (t.flags |= 1), So(e, t, n, a), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~a),
                qo(e, t, a))
          );
        }
        function Po(e, t, n, r, a) {
          if (Xa(n)) {
            var l = !0;
            Ya(t);
          } else l = !1;
          if ((Nl(t, a), null === t.stateNode))
            (Vo(e, t), lo(t, n, r), oo(t, n, r, a), (r = !0));
          else if (null === e) {
            var i = t.stateNode,
              o = t.memoizedProps;
            i.props = o;
            var u = i.context,
              s = n.contextType;
            s =
              "object" == typeof s && null !== s
                ? Ll(s)
                : Ma(t, (s = Xa(n) ? La : Da.current));
            var c = n.getDerivedStateFromProps,
              d =
                "function" == typeof c ||
                "function" == typeof i.getSnapshotBeforeUpdate;
            (d ||
              ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
                "function" != typeof i.componentWillReceiveProps) ||
              ((o !== r || u !== s) && io(t, i, r, s)),
              (Rl = !1));
            var f = t.memoizedState;
            ((i.state = f),
              Ul(t, r, i, a),
              (u = t.memoizedState),
              o !== r || f !== u || Na.current || Rl
                ? ("function" == typeof c &&
                    (no(t, n, c, r), (u = t.memoizedState)),
                  (o = Rl || ao(t, n, o, r, f, u, s))
                    ? (d ||
                        ("function" != typeof i.UNSAFE_componentWillMount &&
                          "function" != typeof i.componentWillMount) ||
                        ("function" == typeof i.componentWillMount &&
                          i.componentWillMount(),
                        "function" == typeof i.UNSAFE_componentWillMount &&
                          i.UNSAFE_componentWillMount()),
                      "function" == typeof i.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" == typeof i.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = u)),
                  (i.props = r),
                  (i.state = u),
                  (i.context = s),
                  (r = o))
                : ("function" == typeof i.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1)));
          } else {
            ((i = t.stateNode),
              Ol(e, t),
              (o = t.memoizedProps),
              (s = t.type === t.elementType ? o : to(t.type, o)),
              (i.props = s),
              (d = t.pendingProps),
              (f = i.context),
              (u =
                "object" == typeof (u = n.contextType) && null !== u
                  ? Ll(u)
                  : Ma(t, (u = Xa(n) ? La : Da.current))));
            var p = n.getDerivedStateFromProps;
            ((c =
              "function" == typeof p ||
              "function" == typeof i.getSnapshotBeforeUpdate) ||
              ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
                "function" != typeof i.componentWillReceiveProps) ||
              ((o !== d || f !== u) && io(t, i, r, u)),
              (Rl = !1),
              (f = t.memoizedState),
              (i.state = f),
              Ul(t, r, i, a));
            var m = t.memoizedState;
            o !== d || f !== m || Na.current || Rl
              ? ("function" == typeof p &&
                  (no(t, n, p, r), (m = t.memoizedState)),
                (s = Rl || ao(t, n, s, r, f, m, u) || !1)
                  ? (c ||
                      ("function" != typeof i.UNSAFE_componentWillUpdate &&
                        "function" != typeof i.componentWillUpdate) ||
                      ("function" == typeof i.componentWillUpdate &&
                        i.componentWillUpdate(r, m, u),
                      "function" == typeof i.UNSAFE_componentWillUpdate &&
                        i.UNSAFE_componentWillUpdate(r, m, u)),
                    "function" == typeof i.componentDidUpdate && (t.flags |= 4),
                    "function" == typeof i.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" != typeof i.componentDidUpdate ||
                      (o === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" != typeof i.getSnapshotBeforeUpdate ||
                      (o === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = m)),
                (i.props = r),
                (i.state = m),
                (i.context = u),
                (r = s))
              : ("function" != typeof i.componentDidUpdate ||
                  (o === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 4),
                "function" != typeof i.getSnapshotBeforeUpdate ||
                  (o === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return Do(e, t, n, r, l, a);
        }
        function Do(e, t, n, r, a, l) {
          Co(e, t);
          var i = !!(128 & t.flags);
          if (!r && !i) return (a && Oa(t, n, !1), qo(e, t, l));
          ((r = t.stateNode), (vo.current = t));
          var o =
            i && "function" != typeof n.getDerivedStateFromError
              ? null
              : r.render();
          return (
            (t.flags |= 1),
            null !== e && i
              ? ((t.child = Sl(t, e.child, null, l)),
                (t.child = Sl(t, null, o, l)))
              : So(e, t, o, l),
            (t.memoizedState = r.state),
            a && Oa(t, n, !0),
            t.child
          );
        }
        function No(e) {
          var t = e.stateNode;
          (t.pendingContext
            ? za(0, t.pendingContext, t.pendingContext !== t.context)
            : t.context && za(0, t.context, !1),
            Ql(e, t.containerInfo));
        }
        function Lo(e, t, n, r, a) {
          return (pl(), ml(a), (t.flags |= 256), So(e, t, n, r), t.child);
        }
        var Mo,
          Xo,
          To,
          zo,
          Ro = { dehydrated: null, treeContext: null, retryLane: 0 };
        function Yo(e) {
          return { baseLanes: e, cachePool: null, transitions: null };
        }
        function Oo(e, t, n) {
          var r,
            a = t.pendingProps,
            i = Zl.current,
            o = !1,
            u = !!(128 & t.flags);
          if (
            ((r = u) ||
              (r = (null === e || null !== e.memoizedState) && !!(2 & i)),
            r
              ? ((o = !0), (t.flags &= -129))
              : (null !== e && null === e.memoizedState) || (i |= 1),
            _a(Zl, 1 & i),
            null === e)
          )
            return (
              sl(t),
              null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
                ? (1 & t.mode
                    ? "$!" === e.data
                      ? (t.lanes = 8)
                      : (t.lanes = 1073741824)
                    : (t.lanes = 1),
                  null)
                : ((u = a.children),
                  (e = a.fallback),
                  o
                    ? ((a = t.mode),
                      (o = t.child),
                      (u = { mode: "hidden", children: u }),
                      1 & a || null === o
                        ? (o = Ys(u, a, 0, null))
                        : ((o.childLanes = 0), (o.pendingProps = u)),
                      (e = Rs(e, a, n, null)),
                      (o.return = t),
                      (e.return = t),
                      (o.sibling = e),
                      (t.child = o),
                      (t.child.memoizedState = Yo(n)),
                      (t.memoizedState = Ro),
                      e)
                    : Ao(t, u))
            );
          if (null !== (i = e.memoizedState) && null !== (r = i.dehydrated))
            return (function (e, t, n, r, a, i, o) {
              if (n)
                return 256 & t.flags
                  ? ((t.flags &= -257), Fo(e, t, o, (r = so(Error(l(422))))))
                  : null !== t.memoizedState
                    ? ((t.child = e.child), (t.flags |= 128), null)
                    : ((i = r.fallback),
                      (a = t.mode),
                      (r = Ys(
                        { mode: "visible", children: r.children },
                        a,
                        0,
                        null,
                      )),
                      ((i = Rs(i, a, o, null)).flags |= 2),
                      (r.return = t),
                      (i.return = t),
                      (r.sibling = i),
                      (t.child = r),
                      1 & t.mode && Sl(t, e.child, null, o),
                      (t.child.memoizedState = Yo(o)),
                      (t.memoizedState = Ro),
                      i);
              if (!(1 & t.mode)) return Fo(e, t, o, null);
              if ("$!" === a.data) {
                if ((r = a.nextSibling && a.nextSibling.dataset))
                  var u = r.dgst;
                return (
                  (r = u),
                  Fo(e, t, o, (r = so((i = Error(l(419))), r, void 0)))
                );
              }
              if (((u = !!(o & e.childLanes)), bo || u)) {
                if (null !== (r = Nu)) {
                  switch (o & -o) {
                    case 4:
                      a = 2;
                      break;
                    case 16:
                      a = 8;
                      break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      a = 32;
                      break;
                    case 536870912:
                      a = 268435456;
                      break;
                    default:
                      a = 0;
                  }
                  0 !== (a = a & (r.suspendedLanes | o) ? 0 : a) &&
                    a !== i.retryLane &&
                    ((i.retryLane = a), zl(e, a), ns(r, e, a, -1));
                }
                return (gs(), Fo(e, t, o, (r = so(Error(l(421))))));
              }
              return "$?" === a.data
                ? ((t.flags |= 128),
                  (t.child = e.child),
                  (t = Ps.bind(null, e)),
                  (a._reactRetry = t),
                  null)
                : ((e = i.treeContext),
                  (rl = sa(a.nextSibling)),
                  (nl = t),
                  (al = !0),
                  (ll = null),
                  null !== e &&
                    ((Wa[Ha++] = Ka),
                    (Wa[Ha++] = Ga),
                    (Wa[Ha++] = Qa),
                    (Ka = e.id),
                    (Ga = e.overflow),
                    (Qa = t)),
                  ((t = Ao(t, r.children)).flags |= 4096),
                  t);
            })(e, t, u, a, r, i, n);
          if (o) {
            ((o = a.fallback), (u = t.mode), (r = (i = e.child).sibling));
            var s = { mode: "hidden", children: a.children };
            return (
              1 & u || t.child === i
                ? ((a = Ts(i, s)).subtreeFlags = 14680064 & i.subtreeFlags)
                : (((a = t.child).childLanes = 0),
                  (a.pendingProps = s),
                  (t.deletions = null)),
              null !== r
                ? (o = Ts(r, o))
                : ((o = Rs(o, u, n, null)).flags |= 2),
              (o.return = t),
              (a.return = t),
              (a.sibling = o),
              (t.child = a),
              (a = o),
              (o = t.child),
              (u =
                null === (u = e.child.memoizedState)
                  ? Yo(n)
                  : {
                      baseLanes: u.baseLanes | n,
                      cachePool: null,
                      transitions: u.transitions,
                    }),
              (o.memoizedState = u),
              (o.childLanes = e.childLanes & ~n),
              (t.memoizedState = Ro),
              a
            );
          }
          return (
            (e = (o = e.child).sibling),
            (a = Ts(o, { mode: "visible", children: a.children })),
            !(1 & t.mode) && (a.lanes = n),
            (a.return = t),
            (a.sibling = null),
            null !== e &&
              (null === (n = t.deletions)
                ? ((t.deletions = [e]), (t.flags |= 16))
                : n.push(e)),
            (t.child = a),
            (t.memoizedState = null),
            a
          );
        }
        function Ao(e, t) {
          return (
            ((t = Ys(
              { mode: "visible", children: t },
              e.mode,
              0,
              null,
            )).return = e),
            (e.child = t)
          );
        }
        function Fo(e, t, n, r) {
          return (
            null !== r && ml(r),
            Sl(t, e.child, null, n),
            ((e = Ao(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Bo(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          (null !== r && (r.lanes |= t), Dl(e.return, t, n));
        }
        function Io(e, t, n, r, a) {
          var l = e.memoizedState;
          null === l
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: a,
              })
            : ((l.isBackwards = t),
              (l.rendering = null),
              (l.renderingStartTime = 0),
              (l.last = r),
              (l.tail = n),
              (l.tailMode = a));
        }
        function Uo(e, t, n) {
          var r = t.pendingProps,
            a = r.revealOrder,
            l = r.tail;
          if ((So(e, t, r.children, n), 2 & (r = Zl.current)))
            ((r = (1 & r) | 2), (t.flags |= 128));
          else {
            if (null !== e && 128 & e.flags)
              e: for (e = t.child; null !== e;) {
                if (13 === e.tag) null !== e.memoizedState && Bo(e, n, t);
                else if (19 === e.tag) Bo(e, n, t);
                else if (null !== e.child) {
                  ((e.child.return = e), (e = e.child));
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling;) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                ((e.sibling.return = e.return), (e = e.sibling));
              }
            r &= 1;
          }
          if ((_a(Zl, r), 1 & t.mode))
            switch (a) {
              case "forwards":
                for (n = t.child, a = null; null !== n;)
                  (null !== (e = n.alternate) && null === ei(e) && (a = n),
                    (n = n.sibling));
                (null === (n = a)
                  ? ((a = t.child), (t.child = null))
                  : ((a = n.sibling), (n.sibling = null)),
                  Io(t, !1, a, n, l));
                break;
              case "backwards":
                for (n = null, a = t.child, t.child = null; null !== a;) {
                  if (null !== (e = a.alternate) && null === ei(e)) {
                    t.child = a;
                    break;
                  }
                  ((e = a.sibling), (a.sibling = n), (n = a), (a = e));
                }
                Io(t, !0, n, null, l);
                break;
              case "together":
                Io(t, !1, null, null, void 0);
                break;
              default:
                t.memoizedState = null;
            }
          else t.memoizedState = null;
          return t.child;
        }
        function Vo(e, t) {
          !(1 & t.mode) &&
            null !== e &&
            ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
        }
        function qo(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (Yu |= t.lanes),
            !(n & t.childLanes))
          )
            return null;
          if (null !== e && t.child !== e.child) throw Error(l(153));
          if (null !== t.child) {
            for (
              n = Ts((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;
            )
              ((e = e.sibling),
                ((n = n.sibling = Ts(e, e.pendingProps)).return = t));
            n.sibling = null;
          }
          return t.child;
        }
        function $o(e, t) {
          if (!al)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t;)
                  (null !== t.alternate && (n = t), (t = t.sibling));
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n;)
                  (null !== n.alternate && (r = n), (n = n.sibling));
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function jo(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var a = e.child; null !== a;)
              ((n |= a.lanes | a.childLanes),
                (r |= 14680064 & a.subtreeFlags),
                (r |= 14680064 & a.flags),
                (a.return = e),
                (a = a.sibling));
          else
            for (a = e.child; null !== a;)
              ((n |= a.lanes | a.childLanes),
                (r |= a.subtreeFlags),
                (r |= a.flags),
                (a.return = e),
                (a = a.sibling));
          return ((e.subtreeFlags |= r), (e.childLanes = n), t);
        }
        function Wo(e, t, n) {
          var r = t.pendingProps;
          switch ((tl(t), t.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (jo(t), null);
            case 1:
            case 17:
              return (Xa(t.type) && Ta(), jo(t), null);
            case 3:
              return (
                (r = t.stateNode),
                Kl(),
                Ca(Na),
                Ca(Da),
                ni(),
                r.pendingContext &&
                  ((r.context = r.pendingContext), (r.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (dl(t)
                    ? (t.flags |= 4)
                    : null === e ||
                      (e.memoizedState.isDehydrated && !(256 & t.flags)) ||
                      ((t.flags |= 1024),
                      null !== ll && (is(ll), (ll = null)))),
                Xo(e, t),
                jo(t),
                null
              );
            case 5:
              Jl(t);
              var a = Hl(Wl.current);
              if (((n = t.type), null !== e && null != t.stateNode))
                (To(e, t, n, r, a),
                  e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152)));
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(l(166));
                  return (jo(t), null);
                }
                if (((e = Hl($l.current)), dl(t))) {
                  ((r = t.stateNode), (n = t.type));
                  var i = t.memoizedProps;
                  switch (((r[fa] = t), (r[pa] = i), (e = !!(1 & t.mode)), n)) {
                    case "dialog":
                      (Fr("cancel", r), Fr("close", r));
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      Fr("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (a = 0; a < Rr.length; a++) Fr(Rr[a], r);
                      break;
                    case "source":
                      Fr("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      (Fr("error", r), Fr("load", r));
                      break;
                    case "details":
                      Fr("toggle", r);
                      break;
                    case "input":
                      (K(r, i), Fr("invalid", r));
                      break;
                    case "select":
                      ((r._wrapperState = { wasMultiple: !!i.multiple }),
                        Fr("invalid", r));
                      break;
                    case "textarea":
                      (ae(r, i), Fr("invalid", r));
                  }
                  for (var u in (ve(n, i), (a = null), i))
                    if (i.hasOwnProperty(u)) {
                      var s = i[u];
                      "children" === u
                        ? "string" == typeof s
                          ? r.textContent !== s &&
                            (!0 !== i.suppressHydrationWarning &&
                              Jr(r.textContent, s, e),
                            (a = ["children", s]))
                          : "number" == typeof s &&
                            r.textContent !== "" + s &&
                            (!0 !== i.suppressHydrationWarning &&
                              Jr(r.textContent, s, e),
                            (a = ["children", "" + s]))
                        : o.hasOwnProperty(u) &&
                          null != s &&
                          "onScroll" === u &&
                          Fr("scroll", r);
                    }
                  switch (n) {
                    case "input":
                      (j(r), Z(r, i, !0));
                      break;
                    case "textarea":
                      (j(r), ie(r));
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" == typeof i.onClick && (r.onclick = Zr);
                  }
                  ((r = a), (t.updateQueue = r), null !== r && (t.flags |= 4));
                } else {
                  ((u = 9 === a.nodeType ? a : a.ownerDocument),
                    "http://www.w3.org/1999/xhtml" === e && (e = oe(n)),
                    "http://www.w3.org/1999/xhtml" === e
                      ? "script" === n
                        ? (((e = u.createElement("div")).innerHTML =
                            "<script><\/script>"),
                          (e = e.removeChild(e.firstChild)))
                        : "string" == typeof r.is
                          ? (e = u.createElement(n, { is: r.is }))
                          : ((e = u.createElement(n)),
                            "select" === n &&
                              ((u = e),
                              r.multiple
                                ? (u.multiple = !0)
                                : r.size && (u.size = r.size)))
                      : (e = u.createElementNS(e, n)),
                    (e[fa] = t),
                    (e[pa] = r),
                    Mo(e, t, !1, !1),
                    (t.stateNode = e));
                  e: {
                    switch (((u = be(n, r)), n)) {
                      case "dialog":
                        (Fr("cancel", e), Fr("close", e), (a = r));
                        break;
                      case "iframe":
                      case "object":
                      case "embed":
                        (Fr("load", e), (a = r));
                        break;
                      case "video":
                      case "audio":
                        for (a = 0; a < Rr.length; a++) Fr(Rr[a], e);
                        a = r;
                        break;
                      case "source":
                        (Fr("error", e), (a = r));
                        break;
                      case "img":
                      case "image":
                      case "link":
                        (Fr("error", e), Fr("load", e), (a = r));
                        break;
                      case "details":
                        (Fr("toggle", e), (a = r));
                        break;
                      case "input":
                        (K(e, r), (a = Q(e, r)), Fr("invalid", e));
                        break;
                      case "option":
                      default:
                        a = r;
                        break;
                      case "select":
                        ((e._wrapperState = { wasMultiple: !!r.multiple }),
                          (a = O({}, r, { value: void 0 })),
                          Fr("invalid", e));
                        break;
                      case "textarea":
                        (ae(e, r), (a = re(e, r)), Fr("invalid", e));
                    }
                    for (i in (ve(n, a), (s = a)))
                      if (s.hasOwnProperty(i)) {
                        var c = s[i];
                        "style" === i
                          ? he(e, c)
                          : "dangerouslySetInnerHTML" === i
                            ? null != (c = c ? c.__html : void 0) && de(e, c)
                            : "children" === i
                              ? "string" == typeof c
                                ? ("textarea" !== n || "" !== c) && fe(e, c)
                                : "number" == typeof c && fe(e, "" + c)
                              : "suppressContentEditableWarning" !== i &&
                                "suppressHydrationWarning" !== i &&
                                "autoFocus" !== i &&
                                (o.hasOwnProperty(i)
                                  ? null != c &&
                                    "onScroll" === i &&
                                    Fr("scroll", e)
                                  : null != c && b(e, i, c, u));
                      }
                    switch (n) {
                      case "input":
                        (j(e), Z(e, r, !1));
                        break;
                      case "textarea":
                        (j(e), ie(e));
                        break;
                      case "option":
                        null != r.value &&
                          e.setAttribute("value", "" + q(r.value));
                        break;
                      case "select":
                        ((e.multiple = !!r.multiple),
                          null != (i = r.value)
                            ? ne(e, !!r.multiple, i, !1)
                            : null != r.defaultValue &&
                              ne(e, !!r.multiple, r.defaultValue, !0));
                        break;
                      default:
                        "function" == typeof a.onClick && (e.onclick = Zr);
                    }
                    switch (n) {
                      case "button":
                      case "input":
                      case "select":
                      case "textarea":
                        r = !!r.autoFocus;
                        break e;
                      case "img":
                        r = !0;
                        break e;
                      default:
                        r = !1;
                    }
                  }
                  r && (t.flags |= 4);
                }
                null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              }
              return (jo(t), null);
            case 6:
              if (e && null != t.stateNode) zo(e, t, e.memoizedProps, r);
              else {
                if ("string" != typeof r && null === t.stateNode)
                  throw Error(l(166));
                if (((n = Hl(Wl.current)), Hl($l.current), dl(t))) {
                  if (
                    ((r = t.stateNode),
                    (n = t.memoizedProps),
                    (r[fa] = t),
                    (i = r.nodeValue !== n) && null !== (e = nl))
                  )
                    switch (e.tag) {
                      case 3:
                        Jr(r.nodeValue, n, !!(1 & e.mode));
                        break;
                      case 5:
                        !0 !== e.memoizedProps.suppressHydrationWarning &&
                          Jr(r.nodeValue, n, !!(1 & e.mode));
                    }
                  i && (t.flags |= 4);
                } else
                  (((r = (
                    9 === n.nodeType ? n : n.ownerDocument
                  ).createTextNode(r))[fa] = t),
                    (t.stateNode = r));
              }
              return (jo(t), null);
            case 13:
              if (
                (Ca(Zl),
                (r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (al && null !== rl && 1 & t.mode && !(128 & t.flags))
                  (fl(), pl(), (t.flags |= 98560), (i = !1));
                else if (((i = dl(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!i) throw Error(l(318));
                    if (
                      !(i =
                        null !== (i = t.memoizedState) ? i.dehydrated : null)
                    )
                      throw Error(l(317));
                    i[fa] = t;
                  } else
                    (pl(),
                      !(128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4));
                  (jo(t), (i = !1));
                } else (null !== ll && (is(ll), (ll = null)), (i = !0));
                if (!i) return 65536 & t.flags ? t : null;
              }
              return 128 & t.flags
                ? ((t.lanes = n), t)
                : ((r = null !== r) !=
                    (null !== e && null !== e.memoizedState) &&
                    r &&
                    ((t.child.flags |= 8192),
                    1 & t.mode &&
                      (null === e || 1 & Zl.current
                        ? 0 === zu && (zu = 3)
                        : gs())),
                  null !== t.updateQueue && (t.flags |= 4),
                  jo(t),
                  null);
            case 4:
              return (
                Kl(),
                Xo(e, t),
                null === e && Ur(t.stateNode.containerInfo),
                jo(t),
                null
              );
            case 10:
              return (Pl(t.type._context), jo(t), null);
            case 19:
              if ((Ca(Zl), null === (i = t.memoizedState)))
                return (jo(t), null);
              if (((r = !!(128 & t.flags)), null === (u = i.rendering)))
                if (r) $o(i, !1);
                else {
                  if (0 !== zu || (null !== e && 128 & e.flags))
                    for (e = t.child; null !== e;) {
                      if (null !== (u = ei(e))) {
                        for (
                          t.flags |= 128,
                            $o(i, !1),
                            null !== (r = u.updateQueue) &&
                              ((t.updateQueue = r), (t.flags |= 4)),
                            t.subtreeFlags = 0,
                            r = n,
                            n = t.child;
                          null !== n;
                        )
                          ((e = r),
                            ((i = n).flags &= 14680066),
                            null === (u = i.alternate)
                              ? ((i.childLanes = 0),
                                (i.lanes = e),
                                (i.child = null),
                                (i.subtreeFlags = 0),
                                (i.memoizedProps = null),
                                (i.memoizedState = null),
                                (i.updateQueue = null),
                                (i.dependencies = null),
                                (i.stateNode = null))
                              : ((i.childLanes = u.childLanes),
                                (i.lanes = u.lanes),
                                (i.child = u.child),
                                (i.subtreeFlags = 0),
                                (i.deletions = null),
                                (i.memoizedProps = u.memoizedProps),
                                (i.memoizedState = u.memoizedState),
                                (i.updateQueue = u.updateQueue),
                                (i.type = u.type),
                                (e = u.dependencies),
                                (i.dependencies =
                                  null === e
                                    ? null
                                    : {
                                        lanes: e.lanes,
                                        firstContext: e.firstContext,
                                      })),
                            (n = n.sibling));
                        return (_a(Zl, (1 & Zl.current) | 2), t.child);
                      }
                      e = e.sibling;
                    }
                  null !== i.tail &&
                    Ge() > Uu &&
                    ((t.flags |= 128),
                    (r = !0),
                    $o(i, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = ei(u))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      null !== (n = e.updateQueue) &&
                        ((t.updateQueue = n), (t.flags |= 4)),
                      $o(i, !0),
                      null === i.tail &&
                        "hidden" === i.tailMode &&
                        !u.alternate &&
                        !al)
                    )
                      return (jo(t), null);
                  } else
                    2 * Ge() - i.renderingStartTime > Uu &&
                      1073741824 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      $o(i, !1),
                      (t.lanes = 4194304));
                i.isBackwards
                  ? ((u.sibling = t.child), (t.child = u))
                  : (null !== (n = i.last) ? (n.sibling = u) : (t.child = u),
                    (i.last = u));
              }
              return null !== i.tail
                ? ((t = i.tail),
                  (i.rendering = t),
                  (i.tail = t.sibling),
                  (i.renderingStartTime = Ge()),
                  (t.sibling = null),
                  (n = Zl.current),
                  _a(Zl, r ? (1 & n) | 2 : 1 & n),
                  t)
                : (jo(t), null);
            case 22:
            case 23:
              return (
                ds(),
                (r = null !== t.memoizedState),
                null !== e &&
                  (null !== e.memoizedState) !== r &&
                  (t.flags |= 8192),
                r && 1 & t.mode
                  ? !!(1073741824 & Xu) &&
                    (jo(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : jo(t),
                null
              );
            case 24:
            case 25:
              return null;
          }
          throw Error(l(156, t.tag));
        }
        function Ho(e, t) {
          switch ((tl(t), t.tag)) {
            case 1:
              return (
                Xa(t.type) && Ta(),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 3:
              return (
                Kl(),
                Ca(Na),
                Ca(Da),
                ni(),
                65536 & (e = t.flags) && !(128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 5:
              return (Jl(t), null);
            case 13:
              if (
                (Ca(Zl),
                null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(l(340));
                pl();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return (Ca(Zl), null);
            case 4:
              return (Kl(), null);
            case 10:
              return (Pl(t.type._context), null);
            case 22:
            case 23:
              return (ds(), null);
            default:
              return null;
          }
        }
        ((Mo = function (e, t) {
          for (var n = t.child; null !== n;) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
            else if (4 !== n.tag && null !== n.child) {
              ((n.child.return = n), (n = n.child));
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling;) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            ((n.sibling.return = n.return), (n = n.sibling));
          }
        }),
          (Xo = function () {}),
          (To = function (e, t, n, r) {
            var a = e.memoizedProps;
            if (a !== r) {
              ((e = t.stateNode), Hl($l.current));
              var l,
                i = null;
              switch (n) {
                case "input":
                  ((a = Q(e, a)), (r = Q(e, r)), (i = []));
                  break;
                case "select":
                  ((a = O({}, a, { value: void 0 })),
                    (r = O({}, r, { value: void 0 })),
                    (i = []));
                  break;
                case "textarea":
                  ((a = re(e, a)), (r = re(e, r)), (i = []));
                  break;
                default:
                  "function" != typeof a.onClick &&
                    "function" == typeof r.onClick &&
                    (e.onclick = Zr);
              }
              for (c in (ve(n, r), (n = null), a))
                if (!r.hasOwnProperty(c) && a.hasOwnProperty(c) && null != a[c])
                  if ("style" === c) {
                    var u = a[c];
                    for (l in u)
                      u.hasOwnProperty(l) && (n || (n = {}), (n[l] = ""));
                  } else
                    "dangerouslySetInnerHTML" !== c &&
                      "children" !== c &&
                      "suppressContentEditableWarning" !== c &&
                      "suppressHydrationWarning" !== c &&
                      "autoFocus" !== c &&
                      (o.hasOwnProperty(c)
                        ? i || (i = [])
                        : (i = i || []).push(c, null));
              for (c in r) {
                var s = r[c];
                if (
                  ((u = null != a ? a[c] : void 0),
                  r.hasOwnProperty(c) && s !== u && (null != s || null != u))
                )
                  if ("style" === c)
                    if (u) {
                      for (l in u)
                        !u.hasOwnProperty(l) ||
                          (s && s.hasOwnProperty(l)) ||
                          (n || (n = {}), (n[l] = ""));
                      for (l in s)
                        s.hasOwnProperty(l) &&
                          u[l] !== s[l] &&
                          (n || (n = {}), (n[l] = s[l]));
                    } else (n || (i || (i = []), i.push(c, n)), (n = s));
                  else
                    "dangerouslySetInnerHTML" === c
                      ? ((s = s ? s.__html : void 0),
                        (u = u ? u.__html : void 0),
                        null != s && u !== s && (i = i || []).push(c, s))
                      : "children" === c
                        ? ("string" != typeof s && "number" != typeof s) ||
                          (i = i || []).push(c, "" + s)
                        : "suppressContentEditableWarning" !== c &&
                          "suppressHydrationWarning" !== c &&
                          (o.hasOwnProperty(c)
                            ? (null != s && "onScroll" === c && Fr("scroll", e),
                              i || u === s || (i = []))
                            : (i = i || []).push(c, s));
              }
              n && (i = i || []).push("style", n);
              var c = i;
              (t.updateQueue = c) && (t.flags |= 4);
            }
          }),
          (zo = function (e, t, n, r) {
            n !== r && (t.flags |= 4);
          }));
        var Qo = !1,
          Ko = !1,
          Go = "function" == typeof WeakSet ? WeakSet : Set,
          Jo = null;
        function Zo(e, t) {
          var n = e.ref;
          if (null !== n)
            if ("function" == typeof n)
              try {
                n(null);
              } catch (n) {
                xs(e, t, n);
              }
            else n.current = null;
        }
        function eu(e, t, n) {
          try {
            n();
          } catch (n) {
            xs(e, t, n);
          }
        }
        var tu = !1;
        function nu(e, t, n) {
          var r = t.updateQueue;
          if (null !== (r = null !== r ? r.lastEffect : null)) {
            var a = (r = r.next);
            do {
              if ((a.tag & e) === e) {
                var l = a.destroy;
                ((a.destroy = void 0), void 0 !== l && eu(t, n, l));
              }
              a = a.next;
            } while (a !== r);
          }
        }
        function ru(e, t) {
          if (
            null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)
          ) {
            var n = (t = t.next);
            do {
              if ((n.tag & e) === e) {
                var r = n.create;
                n.destroy = r();
              }
              n = n.next;
            } while (n !== t);
          }
        }
        function au(e) {
          var t = e.ref;
          if (null !== t) {
            var n = e.stateNode;
            (e.tag, (e = n), "function" == typeof t ? t(e) : (t.current = e));
          }
        }
        function lu(e) {
          var t = e.alternate;
          (null !== t && ((e.alternate = null), lu(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag &&
              null !== (t = e.stateNode) &&
              (delete t[fa],
              delete t[pa],
              delete t[ga],
              delete t[ha],
              delete t[ya]),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null));
        }
        function iu(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function ou(e) {
          e: for (;;) {
            for (; null === e.sibling;) {
              if (null === e.return || iu(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 18 !== e.tag;
            ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              ((e.child.return = e), (e = e.child));
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function uu(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            ((e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType
                    ? (t = n.parentNode).insertBefore(e, n)
                    : (t = n).appendChild(e),
                  null != (n = n._reactRootContainer) ||
                    null !== t.onclick ||
                    (t.onclick = Zr)));
          else if (4 !== r && null !== (e = e.child))
            for (uu(e, t, n), e = e.sibling; null !== e;)
              (uu(e, t, n), (e = e.sibling));
        }
        function su(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            ((e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e));
          else if (4 !== r && null !== (e = e.child))
            for (su(e, t, n), e = e.sibling; null !== e;)
              (su(e, t, n), (e = e.sibling));
        }
        var cu = null,
          du = !1;
        function fu(e, t, n) {
          for (n = n.child; null !== n;) (pu(e, t, n), (n = n.sibling));
        }
        function pu(e, t, n) {
          if (lt && "function" == typeof lt.onCommitFiberUnmount)
            try {
              lt.onCommitFiberUnmount(at, n);
            } catch (e) {}
          switch (n.tag) {
            case 5:
              Ko || Zo(n, t);
            case 6:
              var r = cu,
                a = du;
              ((cu = null),
                fu(e, t, n),
                (du = a),
                null !== (cu = r) &&
                  (du
                    ? ((e = cu),
                      (n = n.stateNode),
                      8 === e.nodeType
                        ? e.parentNode.removeChild(n)
                        : e.removeChild(n))
                    : cu.removeChild(n.stateNode)));
              break;
            case 18:
              null !== cu &&
                (du
                  ? ((e = cu),
                    (n = n.stateNode),
                    8 === e.nodeType
                      ? ua(e.parentNode, n)
                      : 1 === e.nodeType && ua(e, n),
                    Ut(e))
                  : ua(cu, n.stateNode));
              break;
            case 4:
              ((r = cu),
                (a = du),
                (cu = n.stateNode.containerInfo),
                (du = !0),
                fu(e, t, n),
                (cu = r),
                (du = a));
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              if (
                !Ko &&
                null !== (r = n.updateQueue) &&
                null !== (r = r.lastEffect)
              ) {
                a = r = r.next;
                do {
                  var l = a,
                    i = l.destroy;
                  ((l = l.tag),
                    void 0 !== i && (2 & l || 4 & l) && eu(n, t, i),
                    (a = a.next));
                } while (a !== r);
              }
              fu(e, t, n);
              break;
            case 1:
              if (
                !Ko &&
                (Zo(n, t),
                "function" == typeof (r = n.stateNode).componentWillUnmount)
              )
                try {
                  ((r.props = n.memoizedProps),
                    (r.state = n.memoizedState),
                    r.componentWillUnmount());
                } catch (e) {
                  xs(n, t, e);
                }
              fu(e, t, n);
              break;
            case 21:
              fu(e, t, n);
              break;
            case 22:
              1 & n.mode
                ? ((Ko = (r = Ko) || null !== n.memoizedState),
                  fu(e, t, n),
                  (Ko = r))
                : fu(e, t, n);
              break;
            default:
              fu(e, t, n);
          }
        }
        function mu(e) {
          var t = e.updateQueue;
          if (null !== t) {
            e.updateQueue = null;
            var n = e.stateNode;
            (null === n && (n = e.stateNode = new Go()),
              t.forEach(function (t) {
                var r = Ds.bind(null, e, t);
                n.has(t) || (n.add(t), t.then(r, r));
              }));
          }
        }
        function gu(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var a = n[r];
              try {
                var i = e,
                  o = t,
                  u = o;
                e: for (; null !== u;) {
                  switch (u.tag) {
                    case 5:
                      ((cu = u.stateNode), (du = !1));
                      break e;
                    case 3:
                    case 4:
                      ((cu = u.stateNode.containerInfo), (du = !0));
                      break e;
                  }
                  u = u.return;
                }
                if (null === cu) throw Error(l(160));
                (pu(i, o, a), (cu = null), (du = !1));
                var s = a.alternate;
                (null !== s && (s.return = null), (a.return = null));
              } catch (e) {
                xs(a, t, e);
              }
            }
          if (12854 & t.subtreeFlags)
            for (t = t.child; null !== t;) (hu(t, e), (t = t.sibling));
        }
        function hu(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if ((gu(t, e), yu(e), 4 & r)) {
                try {
                  (nu(3, e, e.return), ru(3, e));
                } catch (t) {
                  xs(e, e.return, t);
                }
                try {
                  nu(5, e, e.return);
                } catch (t) {
                  xs(e, e.return, t);
                }
              }
              break;
            case 1:
              (gu(t, e), yu(e), 512 & r && null !== n && Zo(n, n.return));
              break;
            case 5:
              if (
                (gu(t, e),
                yu(e),
                512 & r && null !== n && Zo(n, n.return),
                32 & e.flags)
              ) {
                var a = e.stateNode;
                try {
                  fe(a, "");
                } catch (t) {
                  xs(e, e.return, t);
                }
              }
              if (4 & r && null != (a = e.stateNode)) {
                var i = e.memoizedProps,
                  o = null !== n ? n.memoizedProps : i,
                  u = e.type,
                  s = e.updateQueue;
                if (((e.updateQueue = null), null !== s))
                  try {
                    ("input" === u &&
                      "radio" === i.type &&
                      null != i.name &&
                      G(a, i),
                      be(u, o));
                    var c = be(u, i);
                    for (o = 0; o < s.length; o += 2) {
                      var d = s[o],
                        f = s[o + 1];
                      "style" === d
                        ? he(a, f)
                        : "dangerouslySetInnerHTML" === d
                          ? de(a, f)
                          : "children" === d
                            ? fe(a, f)
                            : b(a, d, f, c);
                    }
                    switch (u) {
                      case "input":
                        J(a, i);
                        break;
                      case "textarea":
                        le(a, i);
                        break;
                      case "select":
                        var p = a._wrapperState.wasMultiple;
                        a._wrapperState.wasMultiple = !!i.multiple;
                        var m = i.value;
                        null != m
                          ? ne(a, !!i.multiple, m, !1)
                          : p !== !!i.multiple &&
                            (null != i.defaultValue
                              ? ne(a, !!i.multiple, i.defaultValue, !0)
                              : ne(a, !!i.multiple, i.multiple ? [] : "", !1));
                    }
                    a[pa] = i;
                  } catch (t) {
                    xs(e, e.return, t);
                  }
              }
              break;
            case 6:
              if ((gu(t, e), yu(e), 4 & r)) {
                if (null === e.stateNode) throw Error(l(162));
                ((a = e.stateNode), (i = e.memoizedProps));
                try {
                  a.nodeValue = i;
                } catch (t) {
                  xs(e, e.return, t);
                }
              }
              break;
            case 3:
              if (
                (gu(t, e),
                yu(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  Ut(t.containerInfo);
                } catch (t) {
                  xs(e, e.return, t);
                }
              break;
            case 4:
            default:
              (gu(t, e), yu(e));
              break;
            case 13:
              (gu(t, e),
                yu(e),
                8192 & (a = e.child).flags &&
                  ((i = null !== a.memoizedState),
                  (a.stateNode.isHidden = i),
                  !i ||
                    (null !== a.alternate &&
                      null !== a.alternate.memoizedState) ||
                    (Iu = Ge())),
                4 & r && mu(e));
              break;
            case 22:
              if (
                ((d = null !== n && null !== n.memoizedState),
                1 & e.mode
                  ? ((Ko = (c = Ko) || d), gu(t, e), (Ko = c))
                  : gu(t, e),
                yu(e),
                8192 & r)
              ) {
                if (
                  ((c = null !== e.memoizedState),
                  (e.stateNode.isHidden = c) && !d && 1 & e.mode)
                )
                  for (Jo = e, d = e.child; null !== d;) {
                    for (f = Jo = d; null !== Jo;) {
                      switch (((m = (p = Jo).child), p.tag)) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                          nu(4, p, p.return);
                          break;
                        case 1:
                          Zo(p, p.return);
                          var g = p.stateNode;
                          if ("function" == typeof g.componentWillUnmount) {
                            ((r = p), (n = p.return));
                            try {
                              ((t = r),
                                (g.props = t.memoizedProps),
                                (g.state = t.memoizedState),
                                g.componentWillUnmount());
                            } catch (e) {
                              xs(r, n, e);
                            }
                          }
                          break;
                        case 5:
                          Zo(p, p.return);
                          break;
                        case 22:
                          if (null !== p.memoizedState) {
                            Eu(f);
                            continue;
                          }
                      }
                      null !== m ? ((m.return = p), (Jo = m)) : Eu(f);
                    }
                    d = d.sibling;
                  }
                e: for (d = null, f = e; ;) {
                  if (5 === f.tag) {
                    if (null === d) {
                      d = f;
                      try {
                        ((a = f.stateNode),
                          c
                            ? "function" == typeof (i = a.style).setProperty
                              ? i.setProperty("display", "none", "important")
                              : (i.display = "none")
                            : ((u = f.stateNode),
                              (o =
                                null != (s = f.memoizedProps.style) &&
                                s.hasOwnProperty("display")
                                  ? s.display
                                  : null),
                              (u.style.display = ge("display", o))));
                      } catch (t) {
                        xs(e, e.return, t);
                      }
                    }
                  } else if (6 === f.tag) {
                    if (null === d)
                      try {
                        f.stateNode.nodeValue = c ? "" : f.memoizedProps;
                      } catch (t) {
                        xs(e, e.return, t);
                      }
                  } else if (
                    ((22 !== f.tag && 23 !== f.tag) ||
                      null === f.memoizedState ||
                      f === e) &&
                    null !== f.child
                  ) {
                    ((f.child.return = f), (f = f.child));
                    continue;
                  }
                  if (f === e) break e;
                  for (; null === f.sibling;) {
                    if (null === f.return || f.return === e) break e;
                    (d === f && (d = null), (f = f.return));
                  }
                  (d === f && (d = null),
                    (f.sibling.return = f.return),
                    (f = f.sibling));
                }
              }
              break;
            case 19:
              (gu(t, e), yu(e), 4 & r && mu(e));
            case 21:
          }
        }
        function yu(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              e: {
                for (var n = e.return; null !== n;) {
                  if (iu(n)) {
                    var r = n;
                    break e;
                  }
                  n = n.return;
                }
                throw Error(l(160));
              }
              switch (r.tag) {
                case 5:
                  var a = r.stateNode;
                  (32 & r.flags && (fe(a, ""), (r.flags &= -33)),
                    su(e, ou(e), a));
                  break;
                case 3:
                case 4:
                  var i = r.stateNode.containerInfo;
                  uu(e, ou(e), i);
                  break;
                default:
                  throw Error(l(161));
              }
            } catch (t) {
              xs(e, e.return, t);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function vu(e, t, n) {
          ((Jo = e), bu(e, t, n));
        }
        function bu(e, t, n) {
          for (var r = !!(1 & e.mode); null !== Jo;) {
            var a = Jo,
              l = a.child;
            if (22 === a.tag && r) {
              var i = null !== a.memoizedState || Qo;
              if (!i) {
                var o = a.alternate,
                  u = (null !== o && null !== o.memoizedState) || Ko;
                o = Qo;
                var s = Ko;
                if (((Qo = i), (Ko = u) && !s))
                  for (Jo = a; null !== Jo;)
                    ((u = (i = Jo).child),
                      22 === i.tag && null !== i.memoizedState
                        ? ku(a)
                        : null !== u
                          ? ((u.return = i), (Jo = u))
                          : ku(a));
                for (; null !== l;) ((Jo = l), bu(l, t, n), (l = l.sibling));
                ((Jo = a), (Qo = o), (Ko = s));
              }
              Su(e);
            } else
              8772 & a.subtreeFlags && null !== l
                ? ((l.return = a), (Jo = l))
                : Su(e);
          }
        }
        function Su(e) {
          for (; null !== Jo;) {
            var t = Jo;
            if (8772 & t.flags) {
              var n = t.alternate;
              try {
                if (8772 & t.flags)
                  switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Ko || ru(5, t);
                      break;
                    case 1:
                      var r = t.stateNode;
                      if (4 & t.flags && !Ko)
                        if (null === n) r.componentDidMount();
                        else {
                          var a =
                            t.elementType === t.type
                              ? n.memoizedProps
                              : to(t.type, n.memoizedProps);
                          r.componentDidUpdate(
                            a,
                            n.memoizedState,
                            r.__reactInternalSnapshotBeforeUpdate,
                          );
                        }
                      var i = t.updateQueue;
                      null !== i && Vl(t, i, r);
                      break;
                    case 3:
                      var o = t.updateQueue;
                      if (null !== o) {
                        if (((n = null), null !== t.child))
                          switch (t.child.tag) {
                            case 5:
                            case 1:
                              n = t.child.stateNode;
                          }
                        Vl(t, o, n);
                      }
                      break;
                    case 5:
                      var u = t.stateNode;
                      if (null === n && 4 & t.flags) {
                        n = u;
                        var s = t.memoizedProps;
                        switch (t.type) {
                          case "button":
                          case "input":
                          case "select":
                          case "textarea":
                            s.autoFocus && n.focus();
                            break;
                          case "img":
                            s.src && (n.src = s.src);
                        }
                      }
                      break;
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                      break;
                    case 13:
                      if (null === t.memoizedState) {
                        var c = t.alternate;
                        if (null !== c) {
                          var d = c.memoizedState;
                          if (null !== d) {
                            var f = d.dehydrated;
                            null !== f && Ut(f);
                          }
                        }
                      }
                      break;
                    default:
                      throw Error(l(163));
                  }
                Ko || (512 & t.flags && au(t));
              } catch (e) {
                xs(t, t.return, e);
              }
            }
            if (t === e) {
              Jo = null;
              break;
            }
            if (null !== (n = t.sibling)) {
              ((n.return = t.return), (Jo = n));
              break;
            }
            Jo = t.return;
          }
        }
        function Eu(e) {
          for (; null !== Jo;) {
            var t = Jo;
            if (t === e) {
              Jo = null;
              break;
            }
            var n = t.sibling;
            if (null !== n) {
              ((n.return = t.return), (Jo = n));
              break;
            }
            Jo = t.return;
          }
        }
        function ku(e) {
          for (; null !== Jo;) {
            var t = Jo;
            try {
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  var n = t.return;
                  try {
                    ru(4, t);
                  } catch (e) {
                    xs(t, n, e);
                  }
                  break;
                case 1:
                  var r = t.stateNode;
                  if ("function" == typeof r.componentDidMount) {
                    var a = t.return;
                    try {
                      r.componentDidMount();
                    } catch (e) {
                      xs(t, a, e);
                    }
                  }
                  var l = t.return;
                  try {
                    au(t);
                  } catch (e) {
                    xs(t, l, e);
                  }
                  break;
                case 5:
                  var i = t.return;
                  try {
                    au(t);
                  } catch (e) {
                    xs(t, i, e);
                  }
              }
            } catch (e) {
              xs(t, t.return, e);
            }
            if (t === e) {
              Jo = null;
              break;
            }
            var o = t.sibling;
            if (null !== o) {
              ((o.return = t.return), (Jo = o));
              break;
            }
            Jo = t.return;
          }
        }
        var wu,
          xu = Math.ceil,
          Cu = S.ReactCurrentDispatcher,
          _u = S.ReactCurrentOwner,
          Pu = S.ReactCurrentBatchConfig,
          Du = 0,
          Nu = null,
          Lu = null,
          Mu = 0,
          Xu = 0,
          Tu = xa(0),
          zu = 0,
          Ru = null,
          Yu = 0,
          Ou = 0,
          Au = 0,
          Fu = null,
          Bu = null,
          Iu = 0,
          Uu = 1 / 0,
          Vu = null,
          qu = !1,
          $u = null,
          ju = null,
          Wu = !1,
          Hu = null,
          Qu = 0,
          Ku = 0,
          Gu = null,
          Ju = -1,
          Zu = 0;
        function es() {
          return 6 & Du ? Ge() : -1 !== Ju ? Ju : (Ju = Ge());
        }
        function ts(e) {
          return 1 & e.mode
            ? 2 & Du && 0 !== Mu
              ? Mu & -Mu
              : null !== gl.transition
                ? (0 === Zu && (Zu = gt()), Zu)
                : 0 !== (e = bt)
                  ? e
                  : (e = void 0 === (e = window.event) ? 16 : Kt(e.type))
            : 1;
        }
        function ns(e, t, n, r) {
          if (50 < Ku) throw ((Ku = 0), (Gu = null), Error(l(185)));
          (yt(e, n, r),
            (2 & Du && e === Nu) ||
              (e === Nu && (!(2 & Du) && (Ou |= n), 4 === zu && os(e, Mu)),
              rs(e, r),
              1 === n &&
                0 === Du &&
                !(1 & t.mode) &&
                ((Uu = Ge() + 500), Fa && Ua())));
        }
        function rs(e, t) {
          var n = e.callbackNode;
          !(function (e, t) {
            for (
              var n = e.suspendedLanes,
                r = e.pingedLanes,
                a = e.expirationTimes,
                l = e.pendingLanes;
              0 < l;
            ) {
              var i = 31 - it(l),
                o = 1 << i,
                u = a[i];
              (-1 === u
                ? (o & n && !(o & r)) || (a[i] = pt(o, t))
                : u <= t && (e.expiredLanes |= o),
                (l &= ~o));
            }
          })(e, t);
          var r = ft(e, e === Nu ? Mu : 0);
          if (0 === r)
            (null !== n && He(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0));
          else if (((t = r & -r), e.callbackPriority !== t)) {
            if ((null != n && He(n), 1 === t))
              (0 === e.tag
                ? (function (e) {
                    ((Fa = !0), Ia(e));
                  })(us.bind(null, e))
                : Ia(us.bind(null, e)),
                ia(function () {
                  !(6 & Du) && Ua();
                }),
                (n = null));
            else {
              switch (St(r)) {
                case 1:
                  n = Ze;
                  break;
                case 4:
                  n = et;
                  break;
                case 16:
                default:
                  n = tt;
                  break;
                case 536870912:
                  n = rt;
              }
              n = Ns(n, as.bind(null, e));
            }
            ((e.callbackPriority = t), (e.callbackNode = n));
          }
        }
        function as(e, t) {
          if (((Ju = -1), (Zu = 0), 6 & Du)) throw Error(l(327));
          var n = e.callbackNode;
          if (ks() && e.callbackNode !== n) return null;
          var r = ft(e, e === Nu ? Mu : 0);
          if (0 === r) return null;
          if (30 & r || r & e.expiredLanes || t) t = hs(e, r);
          else {
            t = r;
            var a = Du;
            Du |= 2;
            var i = ms();
            for (
              (Nu === e && Mu === t) ||
              ((Vu = null), (Uu = Ge() + 500), fs(e, t));
              ;
            )
              try {
                vs();
                break;
              } catch (t) {
                ps(e, t);
              }
            (_l(),
              (Cu.current = i),
              (Du = a),
              null !== Lu ? (t = 0) : ((Nu = null), (Mu = 0), (t = zu)));
          }
          if (0 !== t) {
            if (
              (2 === t && 0 !== (a = mt(e)) && ((r = a), (t = ls(e, a))),
              1 === t)
            )
              throw ((n = Ru), fs(e, 0), os(e, r), rs(e, Ge()), n);
            if (6 === t) os(e, r);
            else {
              if (
                ((a = e.current.alternate),
                !(
                  30 & r ||
                  (function (e) {
                    for (var t = e; ;) {
                      if (16384 & t.flags) {
                        var n = t.updateQueue;
                        if (null !== n && null !== (n = n.stores))
                          for (var r = 0; r < n.length; r++) {
                            var a = n[r],
                              l = a.getSnapshot;
                            a = a.value;
                            try {
                              if (!or(l(), a)) return !1;
                            } catch (e) {
                              return !1;
                            }
                          }
                      }
                      if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
                        ((n.return = t), (t = n));
                      else {
                        if (t === e) break;
                        for (; null === t.sibling;) {
                          if (null === t.return || t.return === e) return !0;
                          t = t.return;
                        }
                        ((t.sibling.return = t.return), (t = t.sibling));
                      }
                    }
                    return !0;
                  })(a) ||
                  ((t = hs(e, r)),
                  2 === t &&
                    ((i = mt(e)), 0 !== i && ((r = i), (t = ls(e, i)))),
                  1 !== t)
                ))
              )
                throw ((n = Ru), fs(e, 0), os(e, r), rs(e, Ge()), n);
              switch (((e.finishedWork = a), (e.finishedLanes = r), t)) {
                case 0:
                case 1:
                  throw Error(l(345));
                case 2:
                case 5:
                  Es(e, Bu, Vu);
                  break;
                case 3:
                  if (
                    (os(e, r),
                    (130023424 & r) === r && 10 < (t = Iu + 500 - Ge()))
                  ) {
                    if (0 !== ft(e, 0)) break;
                    if (((a = e.suspendedLanes) & r) !== r) {
                      (es(), (e.pingedLanes |= e.suspendedLanes & a));
                      break;
                    }
                    e.timeoutHandle = ra(Es.bind(null, e, Bu, Vu), t);
                    break;
                  }
                  Es(e, Bu, Vu);
                  break;
                case 4:
                  if ((os(e, r), (4194240 & r) === r)) break;
                  for (t = e.eventTimes, a = -1; 0 < r;) {
                    var o = 31 - it(r);
                    ((i = 1 << o), (o = t[o]) > a && (a = o), (r &= ~i));
                  }
                  if (
                    ((r = a),
                    10 <
                      (r =
                        (120 > (r = Ge() - r)
                          ? 120
                          : 480 > r
                            ? 480
                            : 1080 > r
                              ? 1080
                              : 1920 > r
                                ? 1920
                                : 3e3 > r
                                  ? 3e3
                                  : 4320 > r
                                    ? 4320
                                    : 1960 * xu(r / 1960)) - r))
                  ) {
                    e.timeoutHandle = ra(Es.bind(null, e, Bu, Vu), r);
                    break;
                  }
                  Es(e, Bu, Vu);
                  break;
                default:
                  throw Error(l(329));
              }
            }
          }
          return (rs(e, Ge()), e.callbackNode === n ? as.bind(null, e) : null);
        }
        function ls(e, t) {
          var n = Fu;
          return (
            e.current.memoizedState.isDehydrated && (fs(e, t).flags |= 256),
            2 !== (e = hs(e, t)) && ((t = Bu), (Bu = n), null !== t && is(t)),
            e
          );
        }
        function is(e) {
          null === Bu ? (Bu = e) : Bu.push.apply(Bu, e);
        }
        function os(e, t) {
          for (
            t &= ~Au,
              t &= ~Ou,
              e.suspendedLanes |= t,
              e.pingedLanes &= ~t,
              e = e.expirationTimes;
            0 < t;
          ) {
            var n = 31 - it(t),
              r = 1 << n;
            ((e[n] = -1), (t &= ~r));
          }
        }
        function us(e) {
          if (6 & Du) throw Error(l(327));
          ks();
          var t = ft(e, 0);
          if (!(1 & t)) return (rs(e, Ge()), null);
          var n = hs(e, t);
          if (0 !== e.tag && 2 === n) {
            var r = mt(e);
            0 !== r && ((t = r), (n = ls(e, r)));
          }
          if (1 === n) throw ((n = Ru), fs(e, 0), os(e, t), rs(e, Ge()), n);
          if (6 === n) throw Error(l(345));
          return (
            (e.finishedWork = e.current.alternate),
            (e.finishedLanes = t),
            Es(e, Bu, Vu),
            rs(e, Ge()),
            null
          );
        }
        function ss(e, t) {
          var n = Du;
          Du |= 1;
          try {
            return e(t);
          } finally {
            0 === (Du = n) && ((Uu = Ge() + 500), Fa && Ua());
          }
        }
        function cs(e) {
          null !== Hu && 0 === Hu.tag && !(6 & Du) && ks();
          var t = Du;
          Du |= 1;
          var n = Pu.transition,
            r = bt;
          try {
            if (((Pu.transition = null), (bt = 1), e)) return e();
          } finally {
            ((bt = r), (Pu.transition = n), !(6 & (Du = t)) && Ua());
          }
        }
        function ds() {
          ((Xu = Tu.current), Ca(Tu));
        }
        function fs(e, t) {
          ((e.finishedWork = null), (e.finishedLanes = 0));
          var n = e.timeoutHandle;
          if ((-1 !== n && ((e.timeoutHandle = -1), aa(n)), null !== Lu))
            for (n = Lu.return; null !== n;) {
              var r = n;
              switch ((tl(r), r.tag)) {
                case 1:
                  null != (r = r.type.childContextTypes) && Ta();
                  break;
                case 3:
                  (Kl(), Ca(Na), Ca(Da), ni());
                  break;
                case 5:
                  Jl(r);
                  break;
                case 4:
                  Kl();
                  break;
                case 13:
                case 19:
                  Ca(Zl);
                  break;
                case 10:
                  Pl(r.type._context);
                  break;
                case 22:
                case 23:
                  ds();
              }
              n = n.return;
            }
          if (
            ((Nu = e),
            (Lu = e = Ts(e.current, null)),
            (Mu = Xu = t),
            (zu = 0),
            (Ru = null),
            (Au = Ou = Yu = 0),
            (Bu = Fu = null),
            null !== Ml)
          ) {
            for (t = 0; t < Ml.length; t++)
              if (null !== (r = (n = Ml[t]).interleaved)) {
                n.interleaved = null;
                var a = r.next,
                  l = n.pending;
                if (null !== l) {
                  var i = l.next;
                  ((l.next = a), (r.next = i));
                }
                n.pending = r;
              }
            Ml = null;
          }
          return e;
        }
        function ps(e, t) {
          for (;;) {
            var n = Lu;
            try {
              if ((_l(), (ri.current = Gi), si)) {
                for (var r = ii.memoizedState; null !== r;) {
                  var a = r.queue;
                  (null !== a && (a.pending = null), (r = r.next));
                }
                si = !1;
              }
              if (
                ((li = 0),
                (ui = oi = ii = null),
                (ci = !1),
                (di = 0),
                (_u.current = null),
                null === n || null === n.return)
              ) {
                ((zu = 1), (Ru = t), (Lu = null));
                break;
              }
              e: {
                var i = e,
                  o = n.return,
                  u = n,
                  s = t;
                if (
                  ((t = Mu),
                  (u.flags |= 32768),
                  null !== s &&
                    "object" == typeof s &&
                    "function" == typeof s.then)
                ) {
                  var c = s,
                    d = u,
                    f = d.tag;
                  if (!(1 & d.mode || (0 !== f && 11 !== f && 15 !== f))) {
                    var p = d.alternate;
                    p
                      ? ((d.updateQueue = p.updateQueue),
                        (d.memoizedState = p.memoizedState),
                        (d.lanes = p.lanes))
                      : ((d.updateQueue = null), (d.memoizedState = null));
                  }
                  var m = ho(o);
                  if (null !== m) {
                    ((m.flags &= -257),
                      yo(m, o, u, 0, t),
                      1 & m.mode && go(i, c, t),
                      (s = c));
                    var g = (t = m).updateQueue;
                    if (null === g) {
                      var h = new Set();
                      (h.add(s), (t.updateQueue = h));
                    } else g.add(s);
                    break e;
                  }
                  if (!(1 & t)) {
                    (go(i, c, t), gs());
                    break e;
                  }
                  s = Error(l(426));
                } else if (al && 1 & u.mode) {
                  var y = ho(o);
                  if (null !== y) {
                    (!(65536 & y.flags) && (y.flags |= 256),
                      yo(y, o, u, 0, t),
                      ml(uo(s, u)));
                    break e;
                  }
                }
                ((i = s = uo(s, u)),
                  4 !== zu && (zu = 2),
                  null === Fu ? (Fu = [i]) : Fu.push(i),
                  (i = o));
                do {
                  switch (i.tag) {
                    case 3:
                      ((i.flags |= 65536),
                        (t &= -t),
                        (i.lanes |= t),
                        Il(i, po(0, s, t)));
                      break e;
                    case 1:
                      u = s;
                      var v = i.type,
                        b = i.stateNode;
                      if (!(
                        128 & i.flags ||
                        ("function" != typeof v.getDerivedStateFromError &&
                          (null === b ||
                            "function" != typeof b.componentDidCatch ||
                            (null !== ju && ju.has(b))))
                      )) {
                        ((i.flags |= 65536),
                          (t &= -t),
                          (i.lanes |= t),
                          Il(i, mo(i, u, t)));
                        break e;
                      }
                  }
                  i = i.return;
                } while (null !== i);
              }
              Ss(n);
            } catch (e) {
              ((t = e), Lu === n && null !== n && (Lu = n = n.return));
              continue;
            }
            break;
          }
        }
        function ms() {
          var e = Cu.current;
          return ((Cu.current = Gi), null === e ? Gi : e);
        }
        function gs() {
          ((0 !== zu && 3 !== zu && 2 !== zu) || (zu = 4),
            null === Nu ||
              (!(268435455 & Yu) && !(268435455 & Ou)) ||
              os(Nu, Mu));
        }
        function hs(e, t) {
          var n = Du;
          Du |= 2;
          var r = ms();
          for ((Nu === e && Mu === t) || ((Vu = null), fs(e, t)); ;)
            try {
              ys();
              break;
            } catch (t) {
              ps(e, t);
            }
          if ((_l(), (Du = n), (Cu.current = r), null !== Lu))
            throw Error(l(261));
          return ((Nu = null), (Mu = 0), zu);
        }
        function ys() {
          for (; null !== Lu;) bs(Lu);
        }
        function vs() {
          for (; null !== Lu && !Qe();) bs(Lu);
        }
        function bs(e) {
          var t = wu(e.alternate, e, Xu);
          ((e.memoizedProps = e.pendingProps),
            null === t ? Ss(e) : (Lu = t),
            (_u.current = null));
        }
        function Ss(e) {
          var t = e;
          do {
            var n = t.alternate;
            if (((e = t.return), 32768 & t.flags)) {
              if (null !== (n = Ho(n, t)))
                return ((n.flags &= 32767), void (Lu = n));
              if (null === e) return ((zu = 6), void (Lu = null));
              ((e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null));
            } else if (null !== (n = Wo(n, t, Xu))) return void (Lu = n);
            if (null !== (t = t.sibling)) return void (Lu = t);
            Lu = t = e;
          } while (null !== t);
          0 === zu && (zu = 5);
        }
        function Es(e, t, n) {
          var r = bt,
            a = Pu.transition;
          try {
            ((Pu.transition = null),
              (bt = 1),
              (function (e, t, n, r) {
                do {
                  ks();
                } while (null !== Hu);
                if (6 & Du) throw Error(l(327));
                n = e.finishedWork;
                var a = e.finishedLanes;
                if (null === n) return null;
                if (
                  ((e.finishedWork = null),
                  (e.finishedLanes = 0),
                  n === e.current)
                )
                  throw Error(l(177));
                ((e.callbackNode = null), (e.callbackPriority = 0));
                var i = n.lanes | n.childLanes;
                if (
                  ((function (e, t) {
                    var n = e.pendingLanes & ~t;
                    ((e.pendingLanes = t),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.expiredLanes &= t),
                      (e.mutableReadLanes &= t),
                      (e.entangledLanes &= t),
                      (t = e.entanglements));
                    var r = e.eventTimes;
                    for (e = e.expirationTimes; 0 < n;) {
                      var a = 31 - it(n),
                        l = 1 << a;
                      ((t[a] = 0), (r[a] = -1), (e[a] = -1), (n &= ~l));
                    }
                  })(e, i),
                  e === Nu && ((Lu = Nu = null), (Mu = 0)),
                  (!(2064 & n.subtreeFlags) && !(2064 & n.flags)) ||
                    Wu ||
                    ((Wu = !0),
                    Ns(tt, function () {
                      return (ks(), null);
                    })),
                  (i = !!(15990 & n.flags)),
                  15990 & n.subtreeFlags || i)
                ) {
                  ((i = Pu.transition), (Pu.transition = null));
                  var o = bt;
                  bt = 1;
                  var u = Du;
                  ((Du |= 4),
                    (_u.current = null),
                    (function (e, t) {
                      if (((ea = qt), pr((e = fr())))) {
                        if ("selectionStart" in e)
                          var n = {
                            start: e.selectionStart,
                            end: e.selectionEnd,
                          };
                        else
                          e: {
                            var r =
                              (n =
                                ((n = e.ownerDocument) && n.defaultView) ||
                                window).getSelection && n.getSelection();
                            if (r && 0 !== r.rangeCount) {
                              n = r.anchorNode;
                              var a = r.anchorOffset,
                                i = r.focusNode;
                              r = r.focusOffset;
                              try {
                                (n.nodeType, i.nodeType);
                              } catch (e) {
                                n = null;
                                break e;
                              }
                              var o = 0,
                                u = -1,
                                s = -1,
                                c = 0,
                                d = 0,
                                f = e,
                                p = null;
                              t: for (;;) {
                                for (
                                  var m;
                                  f !== n ||
                                    (0 !== a && 3 !== f.nodeType) ||
                                    (u = o + a),
                                    f !== i ||
                                      (0 !== r && 3 !== f.nodeType) ||
                                      (s = o + r),
                                    3 === f.nodeType &&
                                      (o += f.nodeValue.length),
                                    null !== (m = f.firstChild);
                                )
                                  ((p = f), (f = m));
                                for (;;) {
                                  if (f === e) break t;
                                  if (
                                    (p === n && ++c === a && (u = o),
                                    p === i && ++d === r && (s = o),
                                    null !== (m = f.nextSibling))
                                  )
                                    break;
                                  p = (f = p).parentNode;
                                }
                                f = m;
                              }
                              n =
                                -1 === u || -1 === s
                                  ? null
                                  : { start: u, end: s };
                            } else n = null;
                          }
                        n = n || { start: 0, end: 0 };
                      } else n = null;
                      for (
                        ta = { focusedElem: e, selectionRange: n },
                          qt = !1,
                          Jo = t;
                        null !== Jo;
                      )
                        if (
                          ((e = (t = Jo).child),
                          1028 & t.subtreeFlags && null !== e)
                        )
                          ((e.return = t), (Jo = e));
                        else
                          for (; null !== Jo;) {
                            t = Jo;
                            try {
                              var g = t.alternate;
                              if (1024 & t.flags)
                                switch (t.tag) {
                                  case 0:
                                  case 11:
                                  case 15:
                                  case 5:
                                  case 6:
                                  case 4:
                                  case 17:
                                    break;
                                  case 1:
                                    if (null !== g) {
                                      var h = g.memoizedProps,
                                        y = g.memoizedState,
                                        v = t.stateNode,
                                        b = v.getSnapshotBeforeUpdate(
                                          t.elementType === t.type
                                            ? h
                                            : to(t.type, h),
                                          y,
                                        );
                                      v.__reactInternalSnapshotBeforeUpdate = b;
                                    }
                                    break;
                                  case 3:
                                    var S = t.stateNode.containerInfo;
                                    1 === S.nodeType
                                      ? (S.textContent = "")
                                      : 9 === S.nodeType &&
                                        S.documentElement &&
                                        S.removeChild(S.documentElement);
                                    break;
                                  default:
                                    throw Error(l(163));
                                }
                            } catch (e) {
                              xs(t, t.return, e);
                            }
                            if (null !== (e = t.sibling)) {
                              ((e.return = t.return), (Jo = e));
                              break;
                            }
                            Jo = t.return;
                          }
                      ((g = tu), (tu = !1));
                    })(e, n),
                    hu(n, e),
                    mr(ta),
                    (qt = !!ea),
                    (ta = ea = null),
                    (e.current = n),
                    vu(n, e, a),
                    Ke(),
                    (Du = u),
                    (bt = o),
                    (Pu.transition = i));
                } else e.current = n;
                if (
                  (Wu && ((Wu = !1), (Hu = e), (Qu = a)),
                  0 === (i = e.pendingLanes) && (ju = null),
                  (function (e) {
                    if (lt && "function" == typeof lt.onCommitFiberRoot)
                      try {
                        lt.onCommitFiberRoot(
                          at,
                          e,
                          void 0,
                          !(128 & ~e.current.flags),
                        );
                      } catch (e) {}
                  })(n.stateNode),
                  rs(e, Ge()),
                  null !== t)
                )
                  for (r = e.onRecoverableError, n = 0; n < t.length; n++)
                    r((a = t[n]).value, {
                      componentStack: a.stack,
                      digest: a.digest,
                    });
                if (qu) throw ((qu = !1), (e = $u), ($u = null), e);
                (!!(1 & Qu) && 0 !== e.tag && ks(),
                  1 & (i = e.pendingLanes)
                    ? e === Gu
                      ? Ku++
                      : ((Ku = 0), (Gu = e))
                    : (Ku = 0),
                  Ua());
              })(e, t, n, r));
          } finally {
            ((Pu.transition = a), (bt = r));
          }
          return null;
        }
        function ks() {
          if (null !== Hu) {
            var e = St(Qu),
              t = Pu.transition,
              n = bt;
            try {
              if (((Pu.transition = null), (bt = 16 > e ? 16 : e), null === Hu))
                var r = !1;
              else {
                if (((e = Hu), (Hu = null), (Qu = 0), 6 & Du))
                  throw Error(l(331));
                var a = Du;
                for (Du |= 4, Jo = e.current; null !== Jo;) {
                  var i = Jo,
                    o = i.child;
                  if (16 & Jo.flags) {
                    var u = i.deletions;
                    if (null !== u) {
                      for (var s = 0; s < u.length; s++) {
                        var c = u[s];
                        for (Jo = c; null !== Jo;) {
                          var d = Jo;
                          switch (d.tag) {
                            case 0:
                            case 11:
                            case 15:
                              nu(8, d, i);
                          }
                          var f = d.child;
                          if (null !== f) ((f.return = d), (Jo = f));
                          else
                            for (; null !== Jo;) {
                              var p = (d = Jo).sibling,
                                m = d.return;
                              if ((lu(d), d === c)) {
                                Jo = null;
                                break;
                              }
                              if (null !== p) {
                                ((p.return = m), (Jo = p));
                                break;
                              }
                              Jo = m;
                            }
                        }
                      }
                      var g = i.alternate;
                      if (null !== g) {
                        var h = g.child;
                        if (null !== h) {
                          g.child = null;
                          do {
                            var y = h.sibling;
                            ((h.sibling = null), (h = y));
                          } while (null !== h);
                        }
                      }
                      Jo = i;
                    }
                  }
                  if (2064 & i.subtreeFlags && null !== o)
                    ((o.return = i), (Jo = o));
                  else
                    e: for (; null !== Jo;) {
                      if (2048 & (i = Jo).flags)
                        switch (i.tag) {
                          case 0:
                          case 11:
                          case 15:
                            nu(9, i, i.return);
                        }
                      var v = i.sibling;
                      if (null !== v) {
                        ((v.return = i.return), (Jo = v));
                        break e;
                      }
                      Jo = i.return;
                    }
                }
                var b = e.current;
                for (Jo = b; null !== Jo;) {
                  var S = (o = Jo).child;
                  if (2064 & o.subtreeFlags && null !== S)
                    ((S.return = o), (Jo = S));
                  else
                    e: for (o = b; null !== Jo;) {
                      if (2048 & (u = Jo).flags)
                        try {
                          switch (u.tag) {
                            case 0:
                            case 11:
                            case 15:
                              ru(9, u);
                          }
                        } catch (e) {
                          xs(u, u.return, e);
                        }
                      if (u === o) {
                        Jo = null;
                        break e;
                      }
                      var E = u.sibling;
                      if (null !== E) {
                        ((E.return = u.return), (Jo = E));
                        break e;
                      }
                      Jo = u.return;
                    }
                }
                if (
                  ((Du = a),
                  Ua(),
                  lt && "function" == typeof lt.onPostCommitFiberRoot)
                )
                  try {
                    lt.onPostCommitFiberRoot(at, e);
                  } catch (e) {}
                r = !0;
              }
              return r;
            } finally {
              ((bt = n), (Pu.transition = t));
            }
          }
          return !1;
        }
        function ws(e, t, n) {
          ((e = Fl(e, (t = po(0, (t = uo(n, t)), 1)), 1)),
            (t = es()),
            null !== e && (yt(e, 1, t), rs(e, t)));
        }
        function xs(e, t, n) {
          if (3 === e.tag) ws(e, e, n);
          else
            for (; null !== t;) {
              if (3 === t.tag) {
                ws(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" == typeof t.type.getDerivedStateFromError ||
                  ("function" == typeof r.componentDidCatch &&
                    (null === ju || !ju.has(r)))
                ) {
                  ((t = Fl(t, (e = mo(t, (e = uo(n, e)), 1)), 1)),
                    (e = es()),
                    null !== t && (yt(t, 1, e), rs(t, e)));
                  break;
                }
              }
              t = t.return;
            }
        }
        function Cs(e, t, n) {
          var r = e.pingCache;
          (null !== r && r.delete(t),
            (t = es()),
            (e.pingedLanes |= e.suspendedLanes & n),
            Nu === e &&
              (Mu & n) === n &&
              (4 === zu ||
              (3 === zu && (130023424 & Mu) === Mu && 500 > Ge() - Iu)
                ? fs(e, 0)
                : (Au |= n)),
            rs(e, t));
        }
        function _s(e, t) {
          0 === t &&
            (1 & e.mode
              ? ((t = ct), !(130023424 & (ct <<= 1)) && (ct = 4194304))
              : (t = 1));
          var n = es();
          null !== (e = zl(e, t)) && (yt(e, t, n), rs(e, n));
        }
        function Ps(e) {
          var t = e.memoizedState,
            n = 0;
          (null !== t && (n = t.retryLane), _s(e, n));
        }
        function Ds(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                a = e.memoizedState;
              null !== a && (n = a.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            default:
              throw Error(l(314));
          }
          (null !== r && r.delete(t), _s(e, n));
        }
        function Ns(e, t) {
          return We(e, t);
        }
        function Ls(e, t, n, r) {
          ((this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null));
        }
        function Ms(e, t, n, r) {
          return new Ls(e, t, n, r);
        }
        function Xs(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Ts(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = Ms(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 14680064 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            n
          );
        }
        function zs(e, t, n, r, a, i) {
          var o = 2;
          if (((r = e), "function" == typeof e)) Xs(e) && (o = 1);
          else if ("string" == typeof e) o = 5;
          else
            e: switch (e) {
              case w:
                return Rs(n.children, a, i, t);
              case x:
                ((o = 8), (a |= 8));
                break;
              case C:
                return (
                  ((e = Ms(12, n, t, 2 | a)).elementType = C),
                  (e.lanes = i),
                  e
                );
              case N:
                return (
                  ((e = Ms(13, n, t, a)).elementType = N),
                  (e.lanes = i),
                  e
                );
              case L:
                return (
                  ((e = Ms(19, n, t, a)).elementType = L),
                  (e.lanes = i),
                  e
                );
              case T:
                return Ys(n, a, i, t);
              default:
                if ("object" == typeof e && null !== e)
                  switch (e.$$typeof) {
                    case _:
                      o = 10;
                      break e;
                    case P:
                      o = 9;
                      break e;
                    case D:
                      o = 11;
                      break e;
                    case M:
                      o = 14;
                      break e;
                    case X:
                      ((o = 16), (r = null));
                      break e;
                  }
                throw Error(l(130, null == e ? e : typeof e, ""));
            }
          return (
            ((t = Ms(o, n, t, a)).elementType = e),
            (t.type = r),
            (t.lanes = i),
            t
          );
        }
        function Rs(e, t, n, r) {
          return (((e = Ms(7, e, r, t)).lanes = n), e);
        }
        function Ys(e, t, n, r) {
          return (
            ((e = Ms(22, e, r, t)).elementType = T),
            (e.lanes = n),
            (e.stateNode = { isHidden: !1 }),
            e
          );
        }
        function Os(e, t, n) {
          return (((e = Ms(6, e, null, t)).lanes = n), e);
        }
        function As(e, t, n) {
          return (
            ((t = Ms(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t,
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        function Fs(e, t, n, r, a) {
          ((this.tag = t),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = ht(0)),
            (this.expirationTimes = ht(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = ht(0)),
            (this.identifierPrefix = r),
            (this.onRecoverableError = a),
            (this.mutableSourceEagerHydrationData = null));
        }
        function Bs(e, t, n, r, a, l, i, o, u) {
          return (
            (e = new Fs(e, t, n, o, u)),
            1 === t ? ((t = 1), !0 === l && (t |= 8)) : (t = 0),
            (l = Ms(3, null, null, t)),
            (e.current = l),
            (l.stateNode = e),
            (l.memoizedState = {
              element: r,
              isDehydrated: n,
              cache: null,
              transitions: null,
              pendingSuspenseBoundaries: null,
            }),
            Yl(l),
            e
          );
        }
        function Is(e) {
          if (!e) return Pa;
          e: {
            if (Ue((e = e._reactInternals)) !== e || 1 !== e.tag)
              throw Error(l(170));
            var t = e;
            do {
              switch (t.tag) {
                case 3:
                  t = t.stateNode.context;
                  break e;
                case 1:
                  if (Xa(t.type)) {
                    t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                    break e;
                  }
              }
              t = t.return;
            } while (null !== t);
            throw Error(l(171));
          }
          if (1 === e.tag) {
            var n = e.type;
            if (Xa(n)) return Ra(e, n, t);
          }
          return t;
        }
        function Us(e, t, n, r, a, l, i, o, u) {
          return (
            ((e = Bs(n, r, !0, e, 0, l, 0, o, u)).context = Is(null)),
            (n = e.current),
            ((l = Al((r = es()), (a = ts(n)))).callback = null != t ? t : null),
            Fl(n, l, a),
            (e.current.lanes = a),
            yt(e, a, r),
            rs(e, r),
            e
          );
        }
        function Vs(e, t, n, r) {
          var a = t.current,
            l = es(),
            i = ts(a);
          return (
            (n = Is(n)),
            null === t.context ? (t.context = n) : (t.pendingContext = n),
            ((t = Al(l, i)).payload = { element: e }),
            null !== (r = void 0 === r ? null : r) && (t.callback = r),
            null !== (e = Fl(a, t, i)) && (ns(e, a, i, l), Bl(e, a, i)),
            i
          );
        }
        function qs(e) {
          return (e = e.current).child
            ? (e.child.tag, e.child.stateNode)
            : null;
        }
        function $s(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function js(e, t) {
          ($s(e, t), (e = e.alternate) && $s(e, t));
        }
        wu = function (e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps || Na.current) bo = !0;
            else {
              if (!(e.lanes & n || 128 & t.flags))
                return (
                  (bo = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        (No(t), pl());
                        break;
                      case 5:
                        Gl(t);
                        break;
                      case 1:
                        Xa(t.type) && Ya(t);
                        break;
                      case 4:
                        Ql(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        var r = t.type._context,
                          a = t.memoizedProps.value;
                        (_a(kl, r._currentValue), (r._currentValue = a));
                        break;
                      case 13:
                        if (null !== (r = t.memoizedState))
                          return null !== r.dehydrated
                            ? (_a(Zl, 1 & Zl.current), (t.flags |= 128), null)
                            : n & t.child.childLanes
                              ? Oo(e, t, n)
                              : (_a(Zl, 1 & Zl.current),
                                null !== (e = qo(e, t, n)) ? e.sibling : null);
                        _a(Zl, 1 & Zl.current);
                        break;
                      case 19:
                        if (((r = !!(n & t.childLanes)), 128 & e.flags)) {
                          if (r) return Uo(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (a = t.memoizedState) &&
                            ((a.rendering = null),
                            (a.tail = null),
                            (a.lastEffect = null)),
                          _a(Zl, Zl.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return ((t.lanes = 0), xo(e, t, n));
                    }
                    return qo(e, t, n);
                  })(e, t, n)
                );
              bo = !!(131072 & e.flags);
            }
          else ((bo = !1), al && 1048576 & t.flags && Za(t, ja, t.index));
          switch (((t.lanes = 0), t.tag)) {
            case 2:
              var r = t.type;
              (Vo(e, t), (e = t.pendingProps));
              var a = Ma(t, Da.current);
              (Nl(t, n), (a = gi(null, t, r, e, a, n)));
              var i = hi();
              return (
                (t.flags |= 1),
                "object" == typeof a &&
                null !== a &&
                "function" == typeof a.render &&
                void 0 === a.$$typeof
                  ? ((t.tag = 1),
                    (t.memoizedState = null),
                    (t.updateQueue = null),
                    Xa(r) ? ((i = !0), Ya(t)) : (i = !1),
                    (t.memoizedState =
                      null !== a.state && void 0 !== a.state ? a.state : null),
                    Yl(t),
                    (a.updater = ro),
                    (t.stateNode = a),
                    (a._reactInternals = t),
                    oo(t, r, e, n),
                    (t = Do(null, t, r, !0, i, n)))
                  : ((t.tag = 0),
                    al && i && el(t),
                    So(null, t, a, n),
                    (t = t.child)),
                t
              );
            case 16:
              r = t.elementType;
              e: {
                switch (
                  (Vo(e, t),
                  (e = t.pendingProps),
                  (r = (a = r._init)(r._payload)),
                  (t.type = r),
                  (a = t.tag =
                    (function (e) {
                      if ("function" == typeof e) return Xs(e) ? 1 : 0;
                      if (null != e) {
                        if ((e = e.$$typeof) === D) return 11;
                        if (e === M) return 14;
                      }
                      return 2;
                    })(r)),
                  (e = to(r, e)),
                  a)
                ) {
                  case 0:
                    t = _o(null, t, r, e, n);
                    break e;
                  case 1:
                    t = Po(null, t, r, e, n);
                    break e;
                  case 11:
                    t = Eo(null, t, r, e, n);
                    break e;
                  case 14:
                    t = ko(null, t, r, to(r.type, e), n);
                    break e;
                }
                throw Error(l(306, r, ""));
              }
              return t;
            case 0:
              return (
                (r = t.type),
                (a = t.pendingProps),
                _o(e, t, r, (a = t.elementType === r ? a : to(r, a)), n)
              );
            case 1:
              return (
                (r = t.type),
                (a = t.pendingProps),
                Po(e, t, r, (a = t.elementType === r ? a : to(r, a)), n)
              );
            case 3:
              e: {
                if ((No(t), null === e)) throw Error(l(387));
                ((r = t.pendingProps),
                  (a = (i = t.memoizedState).element),
                  Ol(e, t),
                  Ul(t, r, null, n));
                var o = t.memoizedState;
                if (((r = o.element), i.isDehydrated)) {
                  if (
                    ((i = {
                      element: r,
                      isDehydrated: !1,
                      cache: o.cache,
                      pendingSuspenseBoundaries: o.pendingSuspenseBoundaries,
                      transitions: o.transitions,
                    }),
                    (t.updateQueue.baseState = i),
                    (t.memoizedState = i),
                    256 & t.flags)
                  ) {
                    t = Lo(e, t, r, n, (a = uo(Error(l(423)), t)));
                    break e;
                  }
                  if (r !== a) {
                    t = Lo(e, t, r, n, (a = uo(Error(l(424)), t)));
                    break e;
                  }
                  for (
                    rl = sa(t.stateNode.containerInfo.firstChild),
                      nl = t,
                      al = !0,
                      ll = null,
                      n = El(t, null, r, n),
                      t.child = n;
                    n;
                  )
                    ((n.flags = (-3 & n.flags) | 4096), (n = n.sibling));
                } else {
                  if ((pl(), r === a)) {
                    t = qo(e, t, n);
                    break e;
                  }
                  So(e, t, r, n);
                }
                t = t.child;
              }
              return t;
            case 5:
              return (
                Gl(t),
                null === e && sl(t),
                (r = t.type),
                (a = t.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (o = a.children),
                na(r, a)
                  ? (o = null)
                  : null !== i && na(r, i) && (t.flags |= 32),
                Co(e, t),
                So(e, t, o, n),
                t.child
              );
            case 6:
              return (null === e && sl(t), null);
            case 13:
              return Oo(e, t, n);
            case 4:
              return (
                Ql(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = Sl(t, null, r, n)) : So(e, t, r, n),
                t.child
              );
            case 11:
              return (
                (r = t.type),
                (a = t.pendingProps),
                Eo(e, t, r, (a = t.elementType === r ? a : to(r, a)), n)
              );
            case 7:
              return (So(e, t, t.pendingProps, n), t.child);
            case 8:
            case 12:
              return (So(e, t, t.pendingProps.children, n), t.child);
            case 10:
              e: {
                if (
                  ((r = t.type._context),
                  (a = t.pendingProps),
                  (i = t.memoizedProps),
                  (o = a.value),
                  _a(kl, r._currentValue),
                  (r._currentValue = o),
                  null !== i)
                )
                  if (or(i.value, o)) {
                    if (i.children === a.children && !Na.current) {
                      t = qo(e, t, n);
                      break e;
                    }
                  } else
                    for (
                      null !== (i = t.child) && (i.return = t);
                      null !== i;
                    ) {
                      var u = i.dependencies;
                      if (null !== u) {
                        o = i.child;
                        for (var s = u.firstContext; null !== s;) {
                          if (s.context === r) {
                            if (1 === i.tag) {
                              (s = Al(-1, n & -n)).tag = 2;
                              var c = i.updateQueue;
                              if (null !== c) {
                                var d = (c = c.shared).pending;
                                (null === d
                                  ? (s.next = s)
                                  : ((s.next = d.next), (d.next = s)),
                                  (c.pending = s));
                              }
                            }
                            ((i.lanes |= n),
                              null !== (s = i.alternate) && (s.lanes |= n),
                              Dl(i.return, n, t),
                              (u.lanes |= n));
                            break;
                          }
                          s = s.next;
                        }
                      } else if (10 === i.tag)
                        o = i.type === t.type ? null : i.child;
                      else if (18 === i.tag) {
                        if (null === (o = i.return)) throw Error(l(341));
                        ((o.lanes |= n),
                          null !== (u = o.alternate) && (u.lanes |= n),
                          Dl(o, n, t),
                          (o = i.sibling));
                      } else o = i.child;
                      if (null !== o) o.return = i;
                      else
                        for (o = i; null !== o;) {
                          if (o === t) {
                            o = null;
                            break;
                          }
                          if (null !== (i = o.sibling)) {
                            ((i.return = o.return), (o = i));
                            break;
                          }
                          o = o.return;
                        }
                      i = o;
                    }
                (So(e, t, a.children, n), (t = t.child));
              }
              return t;
            case 9:
              return (
                (a = t.type),
                (r = t.pendingProps.children),
                Nl(t, n),
                (r = r((a = Ll(a)))),
                (t.flags |= 1),
                So(e, t, r, n),
                t.child
              );
            case 14:
              return (
                (a = to((r = t.type), t.pendingProps)),
                ko(e, t, r, (a = to(r.type, a)), n)
              );
            case 15:
              return wo(e, t, t.type, t.pendingProps, n);
            case 17:
              return (
                (r = t.type),
                (a = t.pendingProps),
                (a = t.elementType === r ? a : to(r, a)),
                Vo(e, t),
                (t.tag = 1),
                Xa(r) ? ((e = !0), Ya(t)) : (e = !1),
                Nl(t, n),
                lo(t, r, a),
                oo(t, r, a, n),
                Do(null, t, r, !0, e, n)
              );
            case 19:
              return Uo(e, t, n);
            case 22:
              return xo(e, t, n);
          }
          throw Error(l(156, t.tag));
        };
        var Ws =
          "function" == typeof reportError
            ? reportError
            : function (e) {
                console.error(e);
              };
        function Hs(e) {
          this._internalRoot = e;
        }
        function Qs(e) {
          this._internalRoot = e;
        }
        function Ks(e) {
          return !(
            !e ||
            (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType)
          );
        }
        function Gs(e) {
          return !(
            !e ||
            (1 !== e.nodeType &&
              9 !== e.nodeType &&
              11 !== e.nodeType &&
              (8 !== e.nodeType ||
                " react-mount-point-unstable " !== e.nodeValue))
          );
        }
        function Js() {}
        function Zs(e, t, n, r, a) {
          var l = n._reactRootContainer;
          if (l) {
            var i = l;
            if ("function" == typeof a) {
              var o = a;
              a = function () {
                var e = qs(i);
                o.call(e);
              };
            }
            Vs(t, i, e, a);
          } else
            i = (function (e, t, n, r, a) {
              if (a) {
                if ("function" == typeof r) {
                  var l = r;
                  r = function () {
                    var e = qs(i);
                    l.call(e);
                  };
                }
                var i = Us(t, r, e, 0, null, !1, 0, "", Js);
                return (
                  (e._reactRootContainer = i),
                  (e[ma] = i.current),
                  Ur(8 === e.nodeType ? e.parentNode : e),
                  cs(),
                  i
                );
              }
              for (; (a = e.lastChild);) e.removeChild(a);
              if ("function" == typeof r) {
                var o = r;
                r = function () {
                  var e = qs(u);
                  o.call(e);
                };
              }
              var u = Bs(e, 0, !1, null, 0, !1, 0, "", Js);
              return (
                (e._reactRootContainer = u),
                (e[ma] = u.current),
                Ur(8 === e.nodeType ? e.parentNode : e),
                cs(function () {
                  Vs(t, u, n, r);
                }),
                u
              );
            })(n, t, e, a, r);
          return qs(i);
        }
        ((Qs.prototype.render = Hs.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(l(409));
            Vs(e, t, null, null);
          }),
          (Qs.prototype.unmount = Hs.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                (cs(function () {
                  Vs(null, e, null, null);
                }),
                  (t[ma] = null));
              }
            }),
          (Qs.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = xt();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < Tt.length && 0 !== t && t < Tt[n].priority;
                n++
              );
              (Tt.splice(n, 0, e), 0 === n && Ot(e));
            }
          }),
          (Et = function (e) {
            switch (e.tag) {
              case 3:
                var t = e.stateNode;
                if (t.current.memoizedState.isDehydrated) {
                  var n = dt(t.pendingLanes);
                  0 !== n &&
                    (vt(t, 1 | n),
                    rs(t, Ge()),
                    !(6 & Du) && ((Uu = Ge() + 500), Ua()));
                }
                break;
              case 13:
                (cs(function () {
                  var t = zl(e, 1);
                  if (null !== t) {
                    var n = es();
                    ns(t, e, 1, n);
                  }
                }),
                  js(e, 1));
            }
          }),
          (kt = function (e) {
            if (13 === e.tag) {
              var t = zl(e, 134217728);
              (null !== t && ns(t, e, 134217728, es()), js(e, 134217728));
            }
          }),
          (wt = function (e) {
            if (13 === e.tag) {
              var t = ts(e),
                n = zl(e, t);
              (null !== n && ns(n, e, t, es()), js(e, t));
            }
          }),
          (xt = function () {
            return bt;
          }),
          (Ct = function (e, t) {
            var n = bt;
            try {
              return ((bt = e), t());
            } finally {
              bt = n;
            }
          }),
          (ke = function (e, t, n) {
            switch (t) {
              case "input":
                if ((J(e, n), (t = n.name), "radio" === n.type && null != t)) {
                  for (n = e; n.parentNode;) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      "input[name=" +
                        JSON.stringify("" + t) +
                        '][type="radio"]',
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var a = Ea(r);
                      if (!a) throw Error(l(90));
                      (W(r), J(r, a));
                    }
                  }
                }
                break;
              case "textarea":
                le(e, n);
                break;
              case "select":
                null != (t = n.value) && ne(e, !!n.multiple, t, !1);
            }
          }),
          (De = ss),
          (Ne = cs));
        var ec = {
            usingClientEntryPoint: !1,
            Events: [ba, Sa, Ea, _e, Pe, ss],
          },
          tc = {
            findFiberByHostInstance: va,
            bundleType: 0,
            version: "18.3.1",
            rendererPackageName: "react-dom",
          },
          nc = {
            bundleType: tc.bundleType,
            version: tc.version,
            rendererPackageName: tc.rendererPackageName,
            rendererConfig: tc.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: S.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = $e(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance:
              tc.findFiberByHostInstance ||
              function () {
                return null;
              },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
          };
        if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var rc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!rc.isDisabled && rc.supportsFiber)
            try {
              ((at = rc.inject(nc)), (lt = rc));
            } catch (ce) {}
        }
        ((t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ec),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (!Ks(t)) throw Error(l(200));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: k,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.createRoot = function (e, t) {
            if (!Ks(e)) throw Error(l(299));
            var n = !1,
              r = "",
              a = Ws;
            return (
              null != t &&
                (!0 === t.unstable_strictMode && (n = !0),
                void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
                void 0 !== t.onRecoverableError && (a = t.onRecoverableError)),
              (t = Bs(e, 1, !1, null, 0, n, 0, r, a)),
              (e[ma] = t.current),
              Ur(8 === e.nodeType ? e.parentNode : e),
              new Hs(t)
            );
          }),
          (t.findDOMNode = function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var t = e._reactInternals;
            if (void 0 === t) {
              if ("function" == typeof e.render) throw Error(l(188));
              throw ((e = Object.keys(e).join(",")), Error(l(268, e)));
            }
            return null === (e = $e(t)) ? null : e.stateNode;
          }),
          (t.flushSync = function (e) {
            return cs(e);
          }),
          (t.hydrate = function (e, t, n) {
            if (!Gs(t)) throw Error(l(200));
            return Zs(null, e, t, !0, n);
          }),
          (t.hydrateRoot = function (e, t, n) {
            if (!Ks(e)) throw Error(l(405));
            var r = (null != n && n.hydratedSources) || null,
              a = !1,
              i = "",
              o = Ws;
            if (
              (null != n &&
                (!0 === n.unstable_strictMode && (a = !0),
                void 0 !== n.identifierPrefix && (i = n.identifierPrefix),
                void 0 !== n.onRecoverableError && (o = n.onRecoverableError)),
              (t = Us(t, null, e, 1, null != n ? n : null, a, 0, i, o)),
              (e[ma] = t.current),
              Ur(e),
              r)
            )
              for (e = 0; e < r.length; e++)
                ((a = (a = (n = r[e])._getVersion)(n._source)),
                  null == t.mutableSourceEagerHydrationData
                    ? (t.mutableSourceEagerHydrationData = [n, a])
                    : t.mutableSourceEagerHydrationData.push(n, a));
            return new Qs(t);
          }),
          (t.render = function (e, t, n) {
            if (!Gs(t)) throw Error(l(200));
            return Zs(null, e, t, !1, n);
          }),
          (t.unmountComponentAtNode = function (e) {
            if (!Gs(e)) throw Error(l(40));
            return (
              !!e._reactRootContainer &&
              (cs(function () {
                Zs(null, null, e, !1, function () {
                  ((e._reactRootContainer = null), (e[ma] = null));
                });
              }),
              !0)
            );
          }),
          (t.unstable_batchedUpdates = ss),
          (t.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
            if (!Gs(n)) throw Error(l(200));
            if (null == e || void 0 === e._reactInternals) throw Error(l(38));
            return Zs(e, t, n, !1, r);
          }),
          (t.version = "18.3.1-next-f1338f8080-20240426"));
      },
      961: (e, t, n) => {
        (!(function e() {
          if (
            "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (e) {
              console.error(e);
            }
        })(),
          (e.exports = n(551)));
      },
      982: (e, t, n) => {
        e.exports = n(463);
      },
    },
    r = {};
  function a(e) {
    var t = r[e];
    if (void 0 !== t) return t.exports;
    var l = (r[e] = { exports: {} });
    return (n[e](l, l.exports, a), l.exports);
  }
  ((t = Object.getPrototypeOf
    ? (e) => Object.getPrototypeOf(e)
    : (e) => e.__proto__),
    (a.t = function (n, r) {
      if ((1 & r && (n = this(n)), 8 & r)) return n;
      if ("object" == typeof n && n) {
        if (4 & r && n.__esModule) return n;
        if (16 & r && "function" == typeof n.then) return n;
      }
      var l = Object.create(null);
      a.r(l);
      var i = {};
      e = e || [null, t({}), t([]), t(t)];
      for (var o = 2 & r && n; "object" == typeof o && !~e.indexOf(o); o = t(o))
        Object.getOwnPropertyNames(o).forEach((e) => (i[e] = () => n[e]));
      return ((i.default = () => n), a.d(l, i), l);
    }),
    (a.d = (e, t) => {
      for (var n in t)
        a.o(t, n) &&
          !a.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (a.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (a.r = (e) => {
      ("undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 }));
    }),
    (a.p = ""));
  var l,
    i = a(540),
    o = a.t(i, 2),
    u = a(338),
    s = a(961),
    c = a.t(s, 2);
  function d() {
    return (
      (d = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      d.apply(this, arguments)
    );
  }
  !(function (e) {
    ((e.Pop = "POP"), (e.Push = "PUSH"), (e.Replace = "REPLACE"));
  })(l || (l = {}));
  const f = "popstate";
  function p(e, t) {
    if (!1 === e || null == e) throw new Error(t);
  }
  function m(e, t) {
    if (!e) {
      "undefined" != typeof console && console.warn(t);
      try {
        throw new Error(t);
      } catch (e) {}
    }
  }
  function g(e, t) {
    return { usr: e.state, key: e.key, idx: t };
  }
  function h(e, t, n, r) {
    return (
      void 0 === n && (n = null),
      d(
        {
          pathname: "string" == typeof e ? e : e.pathname,
          search: "",
          hash: "",
        },
        "string" == typeof t ? v(t) : t,
        {
          state: n,
          key: (t && t.key) || r || Math.random().toString(36).substr(2, 8),
        },
      )
    );
  }
  function y(e) {
    let { pathname: t = "/", search: n = "", hash: r = "" } = e;
    return (
      n && "?" !== n && (t += "?" === n.charAt(0) ? n : "?" + n),
      r && "#" !== r && (t += "#" === r.charAt(0) ? r : "#" + r),
      t
    );
  }
  function v(e) {
    let t = {};
    if (e) {
      let n = e.indexOf("#");
      n >= 0 && ((t.hash = e.substr(n)), (e = e.substr(0, n)));
      let r = e.indexOf("?");
      (r >= 0 && ((t.search = e.substr(r)), (e = e.substr(0, r))),
        e && (t.pathname = e));
    }
    return t;
  }
  var b;
  function S(e, t, n) {
    return (
      void 0 === n && (n = "/"),
      (function (e, t, n, r) {
        let a = z(("string" == typeof t ? v(t) : t).pathname || "/", n);
        if (null == a) return null;
        let l = E(e);
        !(function (e) {
          e.sort((e, t) =>
            e.score !== t.score
              ? t.score - e.score
              : (function (e, t) {
                  return e.length === t.length &&
                    e.slice(0, -1).every((e, n) => e === t[n])
                    ? e[e.length - 1] - t[t.length - 1]
                    : 0;
                })(
                  e.routesMeta.map((e) => e.childrenIndex),
                  t.routesMeta.map((e) => e.childrenIndex),
                ),
          );
        })(l);
        let i = null;
        for (let e = 0; null == i && e < l.length; ++e) {
          let t = T(a);
          i = M(l[e], t, r);
        }
        return i;
      })(e, t, n, !1)
    );
  }
  function E(e, t, n, r) {
    (void 0 === t && (t = []),
      void 0 === n && (n = []),
      void 0 === r && (r = ""));
    let a = (e, a, l) => {
      let i = {
        relativePath: void 0 === l ? e.path || "" : l,
        caseSensitive: !0 === e.caseSensitive,
        childrenIndex: a,
        route: e,
      };
      i.relativePath.startsWith("/") &&
        (p(
          i.relativePath.startsWith(r),
          'Absolute route path "' +
            i.relativePath +
            '" nested under path "' +
            r +
            '" is not valid. An absolute child route path must start with the combined path of all its parent routes.',
        ),
        (i.relativePath = i.relativePath.slice(r.length)));
      let o = Y([r, i.relativePath]),
        u = n.concat(i);
      (e.children &&
        e.children.length > 0 &&
        (p(
          !0 !== e.index,
          'Index routes must not have child routes. Please remove all child routes from route path "' +
            o +
            '".',
        ),
        E(e.children, t, u, o)),
        (null != e.path || e.index) &&
          t.push({ path: o, score: L(o, e.index), routesMeta: u }));
    };
    return (
      e.forEach((e, t) => {
        var n;
        if ("" !== e.path && null != (n = e.path) && n.includes("?"))
          for (let n of k(e.path)) a(e, t, n);
        else a(e, t);
      }),
      t
    );
  }
  function k(e) {
    let t = e.split("/");
    if (0 === t.length) return [];
    let [n, ...r] = t,
      a = n.endsWith("?"),
      l = n.replace(/\?$/, "");
    if (0 === r.length) return a ? [l, ""] : [l];
    let i = k(r.join("/")),
      o = [];
    return (
      o.push(...i.map((e) => ("" === e ? l : [l, e].join("/")))),
      a && o.push(...i),
      o.map((t) => (e.startsWith("/") && "" === t ? "/" : t))
    );
  }
  (!(function (e) {
    ((e.data = "data"),
      (e.deferred = "deferred"),
      (e.redirect = "redirect"),
      (e.error = "error"));
  })(b || (b = {})),
    new Set(["lazy", "caseSensitive", "path", "id", "index", "children"]));
  const w = /^:[\w-]+$/,
    x = 3,
    C = 2,
    _ = 1,
    P = 10,
    D = -2,
    N = (e) => "*" === e;
  function L(e, t) {
    let n = e.split("/"),
      r = n.length;
    return (
      n.some(N) && (r += D),
      t && (r += C),
      n
        .filter((e) => !N(e))
        .reduce((e, t) => e + (w.test(t) ? x : "" === t ? _ : P), r)
    );
  }
  function M(e, t, n) {
    void 0 === n && (n = !1);
    let { routesMeta: r } = e,
      a = {},
      l = "/",
      i = [];
    for (let e = 0; e < r.length; ++e) {
      let o = r[e],
        u = e === r.length - 1,
        s = "/" === l ? t : t.slice(l.length) || "/",
        c = X(
          { path: o.relativePath, caseSensitive: o.caseSensitive, end: u },
          s,
        ),
        d = o.route;
      if (
        (!c &&
          u &&
          n &&
          !r[r.length - 1].route.index &&
          (c = X(
            { path: o.relativePath, caseSensitive: o.caseSensitive, end: !1 },
            s,
          )),
        !c)
      )
        return null;
      (Object.assign(a, c.params),
        i.push({
          params: a,
          pathname: Y([l, c.pathname]),
          pathnameBase: O(Y([l, c.pathnameBase])),
          route: d,
        }),
        "/" !== c.pathnameBase && (l = Y([l, c.pathnameBase])));
    }
    return i;
  }
  function X(e, t) {
    "string" == typeof e && (e = { path: e, caseSensitive: !1, end: !0 });
    let [n, r] = (function (e, t, n) {
        (void 0 === t && (t = !1),
          void 0 === n && (n = !0),
          m(
            "*" === e || !e.endsWith("*") || e.endsWith("/*"),
            'Route path "' +
              e +
              '" will be treated as if it were "' +
              e.replace(/\*$/, "/*") +
              '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "' +
              e.replace(/\*$/, "/*") +
              '".',
          ));
        let r = [],
          a =
            "^" +
            e
              .replace(/\/*\*?$/, "")
              .replace(/^\/*/, "/")
              .replace(/[\\.*+^${}|()[\]]/g, "\\$&")
              .replace(
                /\/:([\w-]+)(\?)?/g,
                (e, t, n) => (
                  r.push({ paramName: t, isOptional: null != n }),
                  n ? "/?([^\\/]+)?" : "/([^\\/]+)"
                ),
              );
        return (
          e.endsWith("*")
            ? (r.push({ paramName: "*" }),
              (a += "*" === e || "/*" === e ? "(.*)$" : "(?:\\/(.+)|\\/*)$"))
            : n
              ? (a += "\\/*$")
              : "" !== e && "/" !== e && (a += "(?:(?=\\/|$))"),
          [new RegExp(a, t ? void 0 : "i"), r]
        );
      })(e.path, e.caseSensitive, e.end),
      a = t.match(n);
    if (!a) return null;
    let l = a[0],
      i = l.replace(/(.)\/+$/, "$1"),
      o = a.slice(1);
    return {
      params: r.reduce((e, t, n) => {
        let { paramName: r, isOptional: a } = t;
        if ("*" === r) {
          let e = o[n] || "";
          i = l.slice(0, l.length - e.length).replace(/(.)\/+$/, "$1");
        }
        const u = o[n];
        return ((e[r] = a && !u ? void 0 : (u || "").replace(/%2F/g, "/")), e);
      }, {}),
      pathname: l,
      pathnameBase: i,
      pattern: e,
    };
  }
  function T(e) {
    try {
      return e
        .split("/")
        .map((e) => decodeURIComponent(e).replace(/\//g, "%2F"))
        .join("/");
    } catch (t) {
      return (
        m(
          !1,
          'The URL path "' +
            e +
            '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (' +
            t +
            ").",
        ),
        e
      );
    }
  }
  function z(e, t) {
    if ("/" === t) return e;
    if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
    let n = t.endsWith("/") ? t.length - 1 : t.length,
      r = e.charAt(n);
    return r && "/" !== r ? null : e.slice(n) || "/";
  }
  function R(e, t, n, r) {
    return (
      "Cannot include a '" +
      e +
      "' character in a manually specified `to." +
      t +
      "` field [" +
      JSON.stringify(r) +
      "].  Please separate it out to the `to." +
      n +
      '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.'
    );
  }
  const Y = (e) => e.join("/").replace(/\/\/+/g, "/"),
    O = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"),
    A = (e) => (e && "?" !== e ? (e.startsWith("?") ? e : "?" + e) : ""),
    F = (e) => (e && "#" !== e ? (e.startsWith("#") ? e : "#" + e) : "");
  Error;
  const B = ["post", "put", "patch", "delete"],
    I = (new Set(B), ["get", ...B]);
  function U() {
    return (
      (U = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      U.apply(this, arguments)
    );
  }
  (new Set(I),
    new Set([301, 302, 303, 307, 308]),
    new Set([307, 308]),
    Symbol("deferred"));
  const V = i.createContext(null),
    q = i.createContext(null),
    $ = i.createContext(null),
    j = i.createContext(null),
    W = i.createContext({ outlet: null, matches: [], isDataRoute: !1 }),
    H = i.createContext(null);
  function Q() {
    return null != i.useContext(j);
  }
  function K() {
    return (Q() || p(!1), i.useContext(j).location);
  }
  function G(e) {
    i.useContext($).static || i.useLayoutEffect(e);
  }
  function J() {
    let { isDataRoute: e } = i.useContext(W);
    return e
      ? (function () {
          let { router: e } = (function () {
              let e = i.useContext(V);
              return (e || p(!1), e);
            })(ae.UseNavigateStable),
            t = ie(le.UseNavigateStable),
            n = i.useRef(!1);
          return (
            G(() => {
              n.current = !0;
            }),
            i.useCallback(
              function (r, a) {
                (void 0 === a && (a = {}),
                  n.current &&
                    ("number" == typeof r
                      ? e.navigate(r)
                      : e.navigate(r, U({ fromRouteId: t }, a))));
              },
              [e, t],
            )
          );
        })()
      : (function () {
          Q() || p(!1);
          let e = i.useContext(V),
            { basename: t, future: n, navigator: r } = i.useContext($),
            { matches: a } = i.useContext(W),
            { pathname: l } = K(),
            o = JSON.stringify(
              (function (e, t) {
                let n = (function (e) {
                  return e.filter(
                    (e, t) =>
                      0 === t || (e.route.path && e.route.path.length > 0),
                  );
                })(e);
                return t
                  ? n.map((e, t) =>
                      t === n.length - 1 ? e.pathname : e.pathnameBase,
                    )
                  : n.map((e) => e.pathnameBase);
              })(a, n.v7_relativeSplatPath),
            ),
            u = i.useRef(!1);
          return (
            G(() => {
              u.current = !0;
            }),
            i.useCallback(
              function (n, a) {
                if ((void 0 === a && (a = {}), !u.current)) return;
                if ("number" == typeof n) return void r.go(n);
                let i = (function (e, t, n, r) {
                  let a;
                  (void 0 === r && (r = !1),
                    "string" == typeof e
                      ? (a = v(e))
                      : ((a = d({}, e)),
                        p(
                          !a.pathname || !a.pathname.includes("?"),
                          R("?", "pathname", "search", a),
                        ),
                        p(
                          !a.pathname || !a.pathname.includes("#"),
                          R("#", "pathname", "hash", a),
                        ),
                        p(
                          !a.search || !a.search.includes("#"),
                          R("#", "search", "hash", a),
                        )));
                  let l,
                    i = "" === e || "" === a.pathname,
                    o = i ? "/" : a.pathname;
                  if (null == o) l = n;
                  else {
                    let e = t.length - 1;
                    if (!r && o.startsWith("..")) {
                      let t = o.split("/");
                      for (; ".." === t[0];) (t.shift(), (e -= 1));
                      a.pathname = t.join("/");
                    }
                    l = e >= 0 ? t[e] : "/";
                  }
                  let u = (function (e, t) {
                      void 0 === t && (t = "/");
                      let {
                          pathname: n,
                          search: r = "",
                          hash: a = "",
                        } = "string" == typeof e ? v(e) : e,
                        l = n
                          ? n.startsWith("/")
                            ? n
                            : (function (e, t) {
                                let n = t.replace(/\/+$/, "").split("/");
                                return (
                                  e.split("/").forEach((e) => {
                                    ".." === e
                                      ? n.length > 1 && n.pop()
                                      : "." !== e && n.push(e);
                                  }),
                                  n.length > 1 ? n.join("/") : "/"
                                );
                              })(n, t)
                          : t;
                      return { pathname: l, search: A(r), hash: F(a) };
                    })(a, l),
                    s = o && "/" !== o && o.endsWith("/"),
                    c = (i || "." === o) && n.endsWith("/");
                  return (
                    u.pathname.endsWith("/") ||
                      (!s && !c) ||
                      (u.pathname += "/"),
                    u
                  );
                })(n, JSON.parse(o), l, "path" === a.relative);
                (null == e &&
                  "/" !== t &&
                  (i.pathname = "/" === i.pathname ? t : Y([t, i.pathname])),
                  (a.replace ? r.replace : r.push)(i, a.state, a));
              },
              [t, r, o, l, e],
            )
          );
        })();
  }
  function Z(e, t, n, r) {
    Q() || p(!1);
    let { navigator: a } = i.useContext($),
      { matches: o } = i.useContext(W),
      u = o[o.length - 1],
      s = u ? u.params : {},
      c = (u && u.pathname, u ? u.pathnameBase : "/");
    u && u.route;
    let d,
      f = K();
    if (t) {
      var m;
      let e = "string" == typeof t ? v(t) : t;
      ("/" === c ||
        (null == (m = e.pathname) ? void 0 : m.startsWith(c)) ||
        p(!1),
        (d = e));
    } else d = f;
    let g = d.pathname || "/",
      h = g;
    if ("/" !== c) {
      let e = c.replace(/^\//, "").split("/");
      h = "/" + g.replace(/^\//, "").split("/").slice(e.length).join("/");
    }
    let y = S(e, { pathname: h }),
      b = (function (e, t, n, r) {
        var a;
        if (
          (void 0 === t && (t = []),
          void 0 === n && (n = null),
          void 0 === r && (r = null),
          null == e)
        ) {
          var l;
          if (!n) return null;
          if (n.errors) e = n.matches;
          else {
            if (!(
              null != (l = r) &&
              l.v7_partialHydration &&
              0 === t.length &&
              !n.initialized &&
              n.matches.length > 0
            ))
              return null;
            e = n.matches;
          }
        }
        let o = e,
          u = null == (a = n) ? void 0 : a.errors;
        if (null != u) {
          let e = o.findIndex(
            (e) =>
              e.route.id && void 0 !== (null == u ? void 0 : u[e.route.id]),
          );
          (e >= 0 || p(!1), (o = o.slice(0, Math.min(o.length, e + 1))));
        }
        let s = !1,
          c = -1;
        if (n && r && r.v7_partialHydration)
          for (let e = 0; e < o.length; e++) {
            let t = o[e];
            if (
              ((t.route.HydrateFallback || t.route.hydrateFallbackElement) &&
                (c = e),
              t.route.id)
            ) {
              let { loaderData: e, errors: r } = n,
                a =
                  t.route.loader &&
                  void 0 === e[t.route.id] &&
                  (!r || void 0 === r[t.route.id]);
              if (t.route.lazy || a) {
                ((s = !0), (o = c >= 0 ? o.slice(0, c + 1) : [o[0]]));
                break;
              }
            }
          }
        return o.reduceRight((e, r, a) => {
          let l,
            d = !1,
            f = null,
            p = null;
          var m;
          n &&
            ((l = u && r.route.id ? u[r.route.id] : void 0),
            (f = r.route.errorElement || te),
            s &&
              (c < 0 && 0 === a
                ? (oe[(m = "route-fallback")] || (oe[m] = !0),
                  (d = !0),
                  (p = null))
                : c === a &&
                  ((d = !0), (p = r.route.hydrateFallbackElement || null))));
          let g = t.concat(o.slice(0, a + 1)),
            h = () => {
              let t;
              return (
                (t = l
                  ? f
                  : d
                    ? p
                    : r.route.Component
                      ? i.createElement(r.route.Component, null)
                      : r.route.element
                        ? r.route.element
                        : e),
                i.createElement(re, {
                  match: r,
                  routeContext: {
                    outlet: e,
                    matches: g,
                    isDataRoute: null != n,
                  },
                  children: t,
                })
              );
            };
          return n && (r.route.ErrorBoundary || r.route.errorElement || 0 === a)
            ? i.createElement(ne, {
                location: n.location,
                revalidation: n.revalidation,
                component: f,
                error: l,
                children: h(),
                routeContext: { outlet: null, matches: g, isDataRoute: !0 },
              })
            : h();
        }, null);
      })(
        y &&
          y.map((e) =>
            Object.assign({}, e, {
              params: Object.assign({}, s, e.params),
              pathname: Y([
                c,
                a.encodeLocation
                  ? a.encodeLocation(e.pathname).pathname
                  : e.pathname,
              ]),
              pathnameBase:
                "/" === e.pathnameBase
                  ? c
                  : Y([
                      c,
                      a.encodeLocation
                        ? a.encodeLocation(e.pathnameBase).pathname
                        : e.pathnameBase,
                    ]),
            }),
          ),
        o,
        n,
        r,
      );
    return t && b
      ? i.createElement(
          j.Provider,
          {
            value: {
              location: U(
                {
                  pathname: "/",
                  search: "",
                  hash: "",
                  state: null,
                  key: "default",
                },
                d,
              ),
              navigationType: l.Pop,
            },
          },
          b,
        )
      : b;
  }
  function ee() {
    let e = (function () {
        var e;
        let t = i.useContext(H),
          n = (function () {
            let e = i.useContext(q);
            return (e || p(!1), e);
          })(le.UseRouteError),
          r = ie(le.UseRouteError);
        return void 0 !== t ? t : null == (e = n.errors) ? void 0 : e[r];
      })(),
      t = (function (e) {
        return (
          null != e &&
          "number" == typeof e.status &&
          "string" == typeof e.statusText &&
          "boolean" == typeof e.internal &&
          "data" in e
        );
      })(e)
        ? e.status + " " + e.statusText
        : e instanceof Error
          ? e.message
          : JSON.stringify(e),
      n = e instanceof Error ? e.stack : null,
      r = { padding: "0.5rem", backgroundColor: "rgba(200,200,200, 0.5)" };
    return i.createElement(
      i.Fragment,
      null,
      i.createElement("h2", null, "Unexpected Application Error!"),
      i.createElement("h3", { style: { fontStyle: "italic" } }, t),
      n ? i.createElement("pre", { style: r }, n) : null,
      null,
    );
  }
  const te = i.createElement(ee, null);
  class ne extends i.Component {
    constructor(e) {
      (super(e),
        (this.state = {
          location: e.location,
          revalidation: e.revalidation,
          error: e.error,
        }));
    }
    static getDerivedStateFromError(e) {
      return { error: e };
    }
    static getDerivedStateFromProps(e, t) {
      return t.location !== e.location ||
        ("idle" !== t.revalidation && "idle" === e.revalidation)
        ? { error: e.error, location: e.location, revalidation: e.revalidation }
        : {
            error: void 0 !== e.error ? e.error : t.error,
            location: t.location,
            revalidation: e.revalidation || t.revalidation,
          };
    }
    componentDidCatch(e, t) {
      console.error(
        "React Router caught the following error during render",
        e,
        t,
      );
    }
    render() {
      return void 0 !== this.state.error
        ? i.createElement(
            W.Provider,
            { value: this.props.routeContext },
            i.createElement(H.Provider, {
              value: this.state.error,
              children: this.props.component,
            }),
          )
        : this.props.children;
    }
  }
  function re(e) {
    let { routeContext: t, match: n, children: r } = e,
      a = i.useContext(V);
    return (
      a &&
        a.static &&
        a.staticContext &&
        (n.route.errorElement || n.route.ErrorBoundary) &&
        (a.staticContext._deepestRenderedBoundaryId = n.route.id),
      i.createElement(W.Provider, { value: t }, r)
    );
  }
  var ae = (function (e) {
      return (
        (e.UseBlocker = "useBlocker"),
        (e.UseRevalidator = "useRevalidator"),
        (e.UseNavigateStable = "useNavigate"),
        e
      );
    })(ae || {}),
    le = (function (e) {
      return (
        (e.UseBlocker = "useBlocker"),
        (e.UseLoaderData = "useLoaderData"),
        (e.UseActionData = "useActionData"),
        (e.UseRouteError = "useRouteError"),
        (e.UseNavigation = "useNavigation"),
        (e.UseRouteLoaderData = "useRouteLoaderData"),
        (e.UseMatches = "useMatches"),
        (e.UseRevalidator = "useRevalidator"),
        (e.UseNavigateStable = "useNavigate"),
        (e.UseRouteId = "useRouteId"),
        e
      );
    })(le || {});
  function ie(e) {
    let t = (function () {
        let e = i.useContext(W);
        return (e || p(!1), e);
      })(),
      n = t.matches[t.matches.length - 1];
    return (n.route.id || p(!1), n.route.id);
  }
  const oe = {},
    ue = {},
    se = (e, t, n) => {
      var r;
      ue[
        (r =
          "⚠️ React Router Future Flag Warning: " +
          t +
          ". You can use the `" +
          e +
          "` future flag to opt-in early. For more information, see " +
          n +
          ".")
      ] || ((ue[r] = !0), console.warn(r));
    };
  function ce(e) {
    p(!1);
  }
  function de(e) {
    let {
      basename: t = "/",
      children: n = null,
      location: r,
      navigationType: a = l.Pop,
      navigator: o,
      static: u = !1,
      future: s,
    } = e;
    Q() && p(!1);
    let c = t.replace(/^\/*/, "/"),
      d = i.useMemo(
        () => ({
          basename: c,
          navigator: o,
          static: u,
          future: U({ v7_relativeSplatPath: !1 }, s),
        }),
        [c, s, o, u],
      );
    "string" == typeof r && (r = v(r));
    let {
        pathname: f = "/",
        search: m = "",
        hash: g = "",
        state: h = null,
        key: y = "default",
      } = r,
      b = i.useMemo(() => {
        let e = z(f, c);
        return null == e
          ? null
          : {
              location: { pathname: e, search: m, hash: g, state: h, key: y },
              navigationType: a,
            };
      }, [c, f, m, g, h, y, a]);
    return null == b
      ? null
      : i.createElement(
          $.Provider,
          { value: d },
          i.createElement(j.Provider, { children: n, value: b }),
        );
  }
  function fe(e) {
    let { children: t, location: n } = e;
    return Z(pe(t), n);
  }
  function pe(e, t) {
    void 0 === t && (t = []);
    let n = [];
    return (
      i.Children.forEach(e, (e, r) => {
        if (!i.isValidElement(e)) return;
        let a = [...t, r];
        if (e.type === i.Fragment)
          return void n.push.apply(n, pe(e.props.children, a));
        (e.type !== ce && p(!1), e.props.index && e.props.children && p(!1));
        let l = {
          id: e.props.id || a.join("-"),
          caseSensitive: e.props.caseSensitive,
          element: e.props.element,
          Component: e.props.Component,
          index: e.props.index,
          path: e.props.path,
          loader: e.props.loader,
          action: e.props.action,
          errorElement: e.props.errorElement,
          ErrorBoundary: e.props.ErrorBoundary,
          hasErrorBoundary:
            null != e.props.ErrorBoundary || null != e.props.errorElement,
          shouldRevalidate: e.props.shouldRevalidate,
          handle: e.props.handle,
          lazy: e.props.lazy,
        };
        (e.props.children && (l.children = pe(e.props.children, a)), n.push(l));
      }),
      n
    );
  }
  (o.startTransition,
    new Promise(() => {}),
    i.Component,
    new Set([
      "application/x-www-form-urlencoded",
      "multipart/form-data",
      "text/plain",
    ]));
  try {
    window.__reactRouterVersion = "6";
  } catch (e) {}
  new Map();
  const me = o.startTransition;
  function ge(e) {
    let { basename: t, children: n, future: r, window: a } = e,
      o = i.useRef();
    var u;
    null == o.current &&
      (o.current =
        (void 0 === (u = { window: a, v5Compat: !0 }) && (u = {}),
        (function (e, t, n, r) {
          void 0 === r && (r = {});
          let { window: a = document.defaultView, v5Compat: i = !1 } = r,
            o = a.history,
            u = l.Pop,
            s = null,
            c = m();
          function m() {
            return (o.state || { idx: null }).idx;
          }
          function v() {
            u = l.Pop;
            let e = m(),
              t = null == e ? null : e - c;
            ((c = e), s && s({ action: u, location: S.location, delta: t }));
          }
          function b(e) {
            let t =
                "null" !== a.location.origin
                  ? a.location.origin
                  : a.location.href,
              n = "string" == typeof e ? e : y(e);
            return (
              (n = n.replace(/ $/, "%20")),
              p(
                t,
                "No window.location.(origin|href) available to create URL for href: " +
                  n,
              ),
              new URL(n, t)
            );
          }
          null == c &&
            ((c = 0), o.replaceState(d({}, o.state, { idx: c }), ""));
          let S = {
            get action() {
              return u;
            },
            get location() {
              return e(a, o);
            },
            listen(e) {
              if (s)
                throw new Error("A history only accepts one active listener");
              return (
                a.addEventListener(f, v),
                (s = e),
                () => {
                  (a.removeEventListener(f, v), (s = null));
                }
              );
            },
            createHref: (e) => t(a, e),
            createURL: b,
            encodeLocation(e) {
              let t = b(e);
              return { pathname: t.pathname, search: t.search, hash: t.hash };
            },
            push: function (e, t) {
              u = l.Push;
              let r = h(S.location, e, t);
              (n && n(r, e), (c = m() + 1));
              let d = g(r, c),
                f = S.createHref(r);
              try {
                o.pushState(d, "", f);
              } catch (e) {
                if (e instanceof DOMException && "DataCloneError" === e.name)
                  throw e;
                a.location.assign(f);
              }
              i && s && s({ action: u, location: S.location, delta: 1 });
            },
            replace: function (e, t) {
              u = l.Replace;
              let r = h(S.location, e, t);
              (n && n(r, e), (c = m()));
              let a = g(r, c),
                d = S.createHref(r);
              (o.replaceState(a, "", d),
                i && s && s({ action: u, location: S.location, delta: 0 }));
            },
            go: (e) => o.go(e),
          };
          return S;
        })(
          function (e, t) {
            let {
              pathname: n = "/",
              search: r = "",
              hash: a = "",
            } = v(e.location.hash.substr(1));
            return (
              n.startsWith("/") || n.startsWith(".") || (n = "/" + n),
              h(
                "",
                { pathname: n, search: r, hash: a },
                (t.state && t.state.usr) || null,
                (t.state && t.state.key) || "default",
              )
            );
          },
          function (e, t) {
            let n = e.document.querySelector("base"),
              r = "";
            if (n && n.getAttribute("href")) {
              let t = e.location.href,
                n = t.indexOf("#");
              r = -1 === n ? t : t.slice(0, n);
            }
            return r + "#" + ("string" == typeof t ? t : y(t));
          },
          function (e, t) {
            m(
              "/" === e.pathname.charAt(0),
              "relative pathnames are not supported in hash history.push(" +
                JSON.stringify(t) +
                ")",
            );
          },
          u,
        )));
    let s = o.current,
      [c, b] = i.useState({ action: s.action, location: s.location }),
      { v7_startTransition: S } = r || {},
      E = i.useCallback(
        (e) => {
          S && me ? me(() => b(e)) : b(e);
        },
        [b, S],
      );
    return (
      i.useLayoutEffect(() => s.listen(E), [s, E]),
      i.useEffect(() => {
        return (
          (null != (e = r) && e.v7_startTransition) ||
            se(
              "v7_startTransition",
              "React Router will begin wrapping state updates in `React.startTransition` in v7",
              "https://reactrouter.com/v6/upgrading/future#v7_starttransition",
            ),
          (null != e && e.v7_relativeSplatPath) ||
            (t && t.v7_relativeSplatPath) ||
            se(
              "v7_relativeSplatPath",
              "Relative route resolution within Splat routes is changing in v7",
              "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath",
            ),
          void (
            t &&
            (t.v7_fetcherPersist ||
              se(
                "v7_fetcherPersist",
                "The persistence behavior of fetchers is changing in v7",
                "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist",
              ),
            t.v7_normalizeFormMethod ||
              se(
                "v7_normalizeFormMethod",
                "Casing of `formMethod` fields is being normalized to uppercase in v7",
                "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod",
              ),
            t.v7_partialHydration ||
              se(
                "v7_partialHydration",
                "`RouterProvider` hydration behavior is changing in v7",
                "https://reactrouter.com/v6/upgrading/future#v7_partialhydration",
              ),
            t.v7_skipActionErrorRevalidation ||
              se(
                "v7_skipActionErrorRevalidation",
                "The revalidation behavior after 4xx/5xx `action` responses is changing in v7",
                "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation",
              ))
          )
        );
        var e, t;
      }, [r]),
      i.createElement(de, {
        basename: t,
        children: n,
        location: c.location,
        navigationType: c.action,
        navigator: s,
        future: r,
      })
    );
  }
  var he, ye;
  (c.flushSync,
    o.useId,
    "undefined" != typeof window &&
      void 0 !== window.document &&
      window.document.createElement,
    (function (e) {
      ((e.UseScrollRestoration = "useScrollRestoration"),
        (e.UseSubmit = "useSubmit"),
        (e.UseSubmitFetcher = "useSubmitFetcher"),
        (e.UseFetcher = "useFetcher"),
        (e.useViewTransitionState = "useViewTransitionState"));
    })(he || (he = {})),
    (function (e) {
      ((e.UseFetcher = "useFetcher"),
        (e.UseFetchers = "useFetchers"),
        (e.UseScrollRestoration = "useScrollRestoration"));
    })(ye || (ye = {})));
  const ve = (e) => {
      let {
        label: t,
        onClick: n,
        className: r,
        type: a = "button",
        disabled: l = !1,
        color: o = "default",
      } = e;
      return i.createElement(
        "button",
          { type: a, className: `learn-more-btn ${o} ${r || ""}`, onClick: n, disabled: l },
         t,
      );
    },
    be = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE289.jpg",
    Se = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE250.jpg",
    Ee = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE302.jpg",
    ke = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE350.jpg",
    we = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE388N.jpg",
    xe = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE358N.jpg",
    Ce = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE355.jpg",
    _e = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE357N.jpg",
    Pe = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE430.jpg",
    De = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE449N.jpg",
    Ne = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/SE800.jpg",

    Le = {
      fr_CH: [
 		    {
          sku: "NXX90100",
          name: "Designcenter X Essentials",
          qty: 1,
          image: be,
          priceMonthly: 155.70,
          priceYearly: 1868.39,
          price3Years: 5605.16,
          description:
            "Designcenter X Essentials bietet wichtige Werkzeuge und Funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
                 
                {
          sku: "NXX91100",
          name: "Designcenter X NX Standard",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 6309.11,
          price3Years: 18927.32,
          description:
            "Designcenter X NX Standard bietet Standardwerkzeuge und -funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
                {
          sku: "NXX92100",
          name: "Designcenter X NX Advanced",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 8196.50,
          price3Years: 24589.50,
          description:
            "Designcenter X NX Standard bietet Standardwerkzeuge und -funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
                {
          sku: "NXX93100",
          name: "Designcenter X NX Premium",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 10461.30,
          price3Years: 31383.89,
          description:
            "Designcenter X NX Standard bietet Standardwerkzeuge und -funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },		

               {
          sku: "SE800",
          name: "Designcenter X Solid Edge Standard",
          qty: 1,
          image: Ne,
          priceMonthly: 363.57,
          priceYearly:  3490.27,
          price3Years: 10470.80,
          description:
            "Designcenter X Solid Edge Standard ist eine leistungsstarke 3D-CAD-Lösung, die kleine und mittelständische Unternehmen (KMU) mit umfassenden Konstruktions- und Kollaborationsfunktionen unterstützt.",
        },
        {
          sku: "SE801",
          name: "Designcenter X Solid Edge Advanced",
          qty: 1,
          image: Ne,
          priceMonthly:  451.61,
          priceYearly: 4335.44,
          price3Years: 13006.33,
          description:
            "Designcenter X Solid Edge Advanced ist eine umfassende CAD-Software, die eine präzise und effiziente Produktentwicklung unterstützt.",
        },
        {
          sku: "SE802",
          name: "Designcenter X Solid Edge Premium",
          qty: 1,
          image: Ne,
          priceMonthly: 647.25,
          priceYearly:  6213.61,
          price3Years: 18640.84,
          description:
            "Designcenter X Solid Edge Premium hebt die Produktentwicklung mit erweiterten Werkzeugen und Funktionen für umfassende und anspruchsvolle CAD-Projekte auf die nächste Stufe.",
        },
        {
          sku: "SE806",
          name: "Designcenter X Solid Edge Value Based Licensing 50 pk",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 8803.92,
          price3Years:  26411.77,
          description:
            "Solid Edge X Value Based Licensing (VBL) ermöglicht Kunden die Nutzung verschiedener Solid Edge X Zusatzanwendungen.",
        },
        {
          sku: "SE805",
          name: "Designcenter X Solid Edge Value Based Licensing 25 pk",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 4401.96,
          price3Years: 13205.88,
          description:
            "Solid Edge X Value Based Licensing (VBL) ermöglicht Kunden die Nutzung mehrerer Solid Edge X Zusatzanwendungen.",
        },
        {
          sku: "SE804",
          name: "Designcenter X Solid Edge Value Based Licensing 10 pk",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 1760.78,
          price3Years: 5282.35,
          description:
            "Solid Edge X Value Based Licensing (VBL) ermöglicht Kunden die Nutzung mehrerer Solid Edge X Zusatzanwendungen.",
        },
        {
          sku: "SE809",
          name: "Designcenter X Solid Edge Advanced Simulation Add-on",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 2641.18,
          price3Years: 7923.53,
          description:
            "Das Add-on „Designcenter X Solid Edge Advanced Simulation“ bietet in Solid Edge integrierte, erweiterte Simulationsfunktionen, die speziell für Konstrukteure zur Struktursimulation von Teilen und Baugruppen entwickelt wurden.",
        },
        {
          sku: "SE302",
          name: "Designcenter Solid Edge Design and Drafting",
          qty: 1,
          image: Ee,
          priceMonthly: 163.10,
          priceYearly: 1565.72,
          price3Years: 4697.16,
          description:
            "Solid Edge Design and Drafting XaaS ist eine umfassende Lösung zur Erstellung detaillierter 2D- und 3D-Konstruktionen mit erweiterten Funktionen für die Zeichnungserstellung.",
        },
        {
          sku: "SE807",
          name: "Solid Edge X Piping Library",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 440.20,
          price3Years: 1320.59,
          description:
            "Die Solid Edge X Rohrleitungsbibliothek umfasst Rohrleitungskomponenten wie Bögen, T-Stücke, Reduzierstücke und weitere Bauteile.",
        },
        {
          sku: "SE808",
          name: "Solid Edge X Routing Piping and Tubing",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 831.48,
          price3Years: 2494.44,
          description:
            "Solid Edge X Routing Piping and Tubing (XpresRoute) ist ein integriertes Add-on-Paket zum schnellen Verlegen und Modellieren von Rohren sowie starren oder flexiblen Schlauchleitungen.",
        },		
      ],

      de_DE: [
		{
          sku: "NXX90100",
          name: "Designcenter X Essentials",
          qty: 1,
          image: be,
          priceMonthly: 188.38,
          priceYearly: 2260.52,
          price3Years: 6781.56,
          description:
            "Designcenter X Essentials bietet wichtige Werkzeuge und Funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
       
                {
          sku: "NXX91100",
          name: "Designcenter X NX Standard",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 7633.24,
          price3Years: 22899.72,
          description:
            "Designcenter X NX Standard bietet Standardwerkzeuge und -funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
                {
          sku: "NXX92100",
          name: "Designcenter X NX Advanced",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 9916.75,
          price3Years: 29750.26,
          description:
            "Designcenter X NX Standard bietet Standardwerkzeuge und -funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
                {
          sku: "NXX93100",
          name: "Designcenter X NX Premium",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 12656.88,
          price3Years: 37970.64,
          description:
            "Designcenter X NX Standard bietet Standardwerkzeuge und -funktionen für eine effiziente Produktkonstruktion und -entwicklung.",
        },
                {
          sku: "SE800",
          name: "Designcenter X Solid Edge Standard",
          qty: 1,
          image: Ne,
          priceMonthly: 404.13,
          priceYearly: 3879.69,
          price3Years: 11639.07,
          description:
            "Designcenter X Solid Edge Standard ist eine leistungsstarke 3D-CAD-Lösung, die kleine und mittelständische Unternehmen (KMU) mit umfassenden Konstruktions- und Kollaborationsfunktionen unterstützt.",
        },		
        {
          sku: "SE801",
          name: "Designcenter X Solid Edge Advanced",
          qty: 1,
          image: Ne,
          priceMonthly: 502,
          priceYearly: 4819.17,
          price3Years: 14457.5,
          description:
            "Designcenter X Solid Edge Advanced ist eine umfassende CAD-Software, die eine präzise und effiziente Produktentwicklung unterstützt.",
        },
        {
          sku: "SE802",
          name: "Designcenter X Solid Edge Premium",
          qty: 1,
          image: Ne,
          priceMonthly: 719.47,
          priceYearly: 6906.89,
          price3Years: 20720.68
,
          description:
            "Designcenter X Solid Edge Premium hebt die Produktentwicklung mit erweiterten Werkzeugen und Funktionen für umfassende und anspruchsvolle CAD-Projekte auf die nächste Stufe.",
        },
        {
          sku: "SE806",
          name: "Designcenter X Solid Edge Value Based Licensing 50 pk",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 10651.66,
          price3Years: 31954.99,
          description:
            "Solid Edge X Value Based Licensing (VBL) ermöglicht Kunden die Nutzung verschiedener Solid Edge X Zusatzanwendungen.",
        },
        {
          sku: "SE805",
          name: "Designcenter X Solid Edge Value Based Licensing 25 pk",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 5325.83,
          price3Years: 15977.49,
          description:
            "Solid Edge X Value Based Licensing (VBL) ermöglicht Kunden die Nutzung mehrerer Solid Edge X Zusatzanwendungen.",
        },
        {
          sku: "SE804",
          name: "Designcenter X Solid Edge Value Based Licensing 10 pk",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 2130.33,
          price3Years: 6391,
          description:
            "Solid Edge X Value Based Licensing (VBL) ermöglicht Kunden die Nutzung mehrerer Solid Edge X Zusatzanwendungen.",
        },
        {
          sku: "SE809",
          name: "Designcenter X Solid Edge Advanced Simulation Add-on",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 3195.5,
          price3Years: 9586.5,
          description:
            "Das Add-on „Designcenter X Solid Edge Advanced Simulation“ bietet in Solid Edge integrierte, erweiterte Simulationsfunktionen, die speziell für Konstrukteure zur Struktursimulation von Teilen und Baugruppen entwickelt wurden.",
        },
                 {
          sku: "SE302",
          name: "Designcenter Solid Edge Design and Drafting",
          qty: 1,
          image: Ee,
          priceMonthly: 181.52,
          priceYearly: 1742.56,
          price3Years: 5227.67,
          description:
            "Solid Edge Design and Drafting XaaS ist eine umfassende Lösung zur Erstellung detaillierter 2D- und 3D-Konstruktionen mit erweiterten Funktionen für die Zeichnungserstellung.",
        },
        {
          sku: "SE807",
          name: "Solid Edge X Piping Library",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 532.58,
          price3Years: 1597.75,
          description:
            "Die Solid Edge X Rohrleitungsbibliothek umfasst Rohrleitungskomponenten wie Bögen, T-Stücke, Reduzierstücke und weitere Bauteile.",
        },
        {
          sku: "SE808",
          name: "Solid Edge X Routing Piping & Tubing",
          qty: 1,
          image: Ne,
          priceMonthly: 0,
          priceYearly: 1005.99,
          price3Years: 3017.97,
          description:
            "Solid Edge X Routing Piping & Tubing (XpresRoute) ist ein integriertes Add-on-Paket zum schnellen Verlegen und Modellieren von Rohren sowie starren oder flexiblen Schlauchleitungen.",
        },		
      ],
    },
    Me = {
      "€": ["de_DE"],
      CHF: ["fr_CH"],
    },
    Xe = "de_DE",
    Te = () => {
      const e = document.querySelector("store-template");
      return {
        locale: e?.getAttribute("locale"),
        spi: e?.getAttribute("spi"),
        country: e?.getAttribute("country"),
      };
    },
    ze = () => {
      const englishStorefrontUrl =
        "https://bct-technology.shop/en/pages/siemens-software";
      const browserLanguage = (navigator.language || "").toLowerCase();
      const isEnglishStorefrontPage =
        window.location.pathname.replace(/\/$/, "") ===
        "/en/pages/siemens-software";

      // English browser language: redirect only once per browser tab/session.
      // After that, Shopify's language switcher takes precedence, so users can
      // deliberately switch back to the German storefront without being redirected again.
      const languageRedirectDone =
        sessionStorage.getItem("storefrontLanguageRedirectDone") === "true";

      if (
        browserLanguage.startsWith("en") &&
        !isEnglishStorefrontPage &&
        !languageRedirectDone
      ) {
        sessionStorage.setItem("storefrontLanguageRedirectDone", "true");
        window.location.replace(englishStorefrontUrl);
        return "de_DE";
      }

      const e = Te(),
        t = new URLSearchParams(window.location.search).get("locale");

      if (t && Re(t)) return t;
      if (e.locale && Re(e.locale)) return e.locale;

      const r = (e.country || window.Shopify?.country || "").toUpperCase();
      if ("CH" === r) return "fr_CH";

      // fr-CH can also be selected directly from the browser language.
      if (browserLanguage === "fr-ch") return "fr_CH";

      // All remaining visitors use the German storefront.
      return "de_DE";
    },
    Re = (e) => Object.keys(Me).some((t) => Me[t].includes(e)),
    Ye = (e) => {
      let { country: t, locale: n, spi: r } = e;
      const a = J(),
        l = K(),
        [o, u] = (0, i.useState)(Xe),
        [s, c] = (0, i.useState)("$"),
        [d, f] = (0, i.useState)([]),
        p = (0, i.useMemo)(() => Te(), []);
      ((0, i.useEffect)(() => {
        let e;
        ((e = ze()),
          u(e),
          c(((e) => Object.keys(Me).find((t) => Me[t].includes(e)) || "$")(e)),
          f(Le[e] || Le[Xe] || []));
      }, [n, p.locale, l.search]),
        (0, i.useEffect)(() => {
          const e = r || p.spi;
          e && sessionStorage.setItem("spi", e);
        }, [r, p.spi]));
      const m = (0, i.useCallback)(
        (e) => {
          const t = parseInt(sessionStorage.getItem(e) || "0", 10);
          sessionStorage.setItem(e, (t + 1).toString());
          const n = sessionStorage.getItem("spi");
          a(`/cart/${e}?spi=${n}&locale=${o}`);
        },
        [a, o],
      );
      return (
        (0, i.useCallback)(() => {
          const e = `https://www.plm.automation.siemens.com/offer/one?spi=${sessionStorage.getItem("spi")}`;
          window.location.href = e;
        }, []),
        i.createElement(
          "div",
          { className: "landing-page" },
          i.createElement(
            "h1",
            { className: "title" },
            "Designcenter X Produkte",
          ),
          i.createElement(
            "div",
            { className: "grid" },
            d.map((e) =>
              i.createElement(
                "div",
                { key: e.sku, className: "card" },
                i.createElement("img", {
				  src: e.image,
				  alt: e.name,
				  className: "image",
				  style: { width: "100%", objectFit: "cover" },
          
				}),
                
                i.createElement(
                  "p",
                  { className: "price" },
                  i.createElement(
                    "strong",
                    null,
                     Number(e.priceYearly).toLocaleString("de-DE", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                      }),
                     " " + s,
                    " / Jahr",
                  ),
                ),
                i.createElement("h3", null, e.name),
                i.createElement(ve, {
                  label: "Mehr erfahren",
                  onClick: () => m(e.sku),
                }),
              ),
            ),
          ),
        )
      );
    },
    Oe = (e) => {
      let { onCountryChange: t } = e;
      const n = K();
      return (
        (0, i.useEffect)(() => {
          const e = ze();
          t(
            {
              de_DE: "DE",
              fr_CH: "CH",
            }[e] || "DE",
          );
        }, [t, n.search]),
        null
      );
    },
    Ae = a.p + "https://bct-technology.shop/cdn/shop/t/7/assets/shopping-cart.svg",
    Fe = (e) => {
      let { country: t, locale: n, spi: r } = e;
      const { sku: a } = (function () {
          let { matches: e } = i.useContext(W),
            t = e[e.length - 1];
          return t ? t.params : {};
        })(),
        l = J(),
        o = K(),
        u = new URLSearchParams(o.search),
        [s, c] = (n || u.get("locale"), (0, i.useState)([])),
        [d, f] = (0, i.useState)(s?.qty || 1),
        [p, m] = (0, i.useState)(""),
        [g, h] = (0, i.useState)(t || ""),
        [y, v] = (0, i.useState)("Yearly"),
        [b, S] = (0, i.useState)(s?.priceYearly),
        [E, k] = (0, i.useState)([]),
        [w, x] = (0, i.useState)(!1),
        [C, _] = (0, i.useState)(null),
        [P, D] = (0, i.useState)(r || "");

const termLabels = {
  Monthly: "Monatlich",
  Yearly: "Jährlich",
  "3 Years": "3 Jahre",
};


      ((0, i.useEffect)(() => {
        const e = u.get("locale") || n || ze() || "de_DE",
          t = (Le[e] || []).find((e) => e.sku === a);
        c(t);
      }, [a, n, u]),
        (0, i.useEffect)(() => {
          const e = new URLSearchParams(window.location.search),
            t = r || e.get("spi") || sessionStorage.getItem("spi");
          t && (D(t), sessionStorage.setItem("spi", t));
        }, [r]),
        (0, i.useEffect)(() => {
          switch (y) {
            case "Monthly":
              S(s?.priceMonthly);
              break;
            case "Yearly":
            default:
              S(s?.priceYearly);
              break;
            case "3 Years":
              S(s?.price3Years);
          }
        }, [y, s]),
        (0, i.useEffect)(() => {
          const e = JSON.parse(sessionStorage.getItem("cart")) || [];
          (k(e), e.length > 0 && !C && _(e[0].subscriptionTerm));
        }, []));
      const N = () => {
        x(!1);
        const e = JSON.parse(sessionStorage.getItem("cart")) || [];
        let t = `https://www.plm.automation.siemens.com/offer/configurable_cart?country=${g}`;
        (e.forEach((e) => {
          let n = "yearly",
            r = 1;
          switch (e.subscriptionTerm) {
            case "Monthly":
              n = "monthly";
              break;
            case "Yearly":
            default:
              ((n = "yearly"), (r = 1));
              break;
            case "3 Years":
              ((n = "yearly"), (r = 3));
          }
          t += `&sku=${e.sku}&qty=${e.qty}&term=${n}&length=${r}`;
        }),
          "" !== p.trim() && (t += `&coupon=${encodeURIComponent(p.trim())}`),
          P && (t += `&spi=${P}`),
          (t += "&create_cart=Create+Cart"),
          (window.location.href = t));
      };
      return i.createElement(
        "div",
        null,
        i.createElement(
          "div",
          { className: "cart-plugin-container" },
          E.length > 0 &&
            i.createElement(
              "div",
              { className: "clear-cart-container" },
              i.createElement("img", {
                src: Ae,
                alt: "Clear Cart",
                className: "clear-cart-image",
                onClick: () => {
                  (sessionStorage.removeItem("cart"), k([]), _(null));
                },
              }),
              i.createElement(
                "p",
                { className: "clear-cart-text" },
                "Warenkorb leeren",
              ),
            ),
          i.createElement(Oe, { onCountryChange: h }),
          s &&
            i.createElement(
              "div",
              { className: "product-info" },
              i.createElement("img", {
			  className: "product-image",
			  src: s.image,
			  alt: s.name || "Product",
			  style: { width: "400px", objectFit: "contain" },
			}),

            ),
          i.createElement(
            "form",
            { className: "cart-form" },
              i.createElement("h2", { className: "product-name" }, s.name),
              s.description &&
                i.createElement(
                  "p",
                  { className: "product-description" },
                  s.description,
                ),

            i.createElement(
              "div",
              { className: "form-group" },
              i.createElement("label", null, "Anzahl:"),
              i.createElement("input", {
                type: "number",
                value: d,
                min: "1",
                onChange: (e) => f(parseInt(e.target.value)),
                className: "form-input",
              }),
            ),
 i.createElement(
  "div",
  { className: "form-group" },
  i.createElement("label", null, "Preis:"),
  i.createElement(
    "p",
    null,
    Number(
      ((e, t) => {
        switch (t) {
          case "Monthly":
            return e.priceMonthly;
          case "Yearly":
          default:
            return e.priceYearly;
          case "3 Years":
            return e.price3Years;
        }
      })(s, C || y)
    ).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ((u.get("locale") || n || ze()) === "fr_CH" ? " CHF" : " €")
  )
),
            i.createElement(
              "div",
              { className: "laufzeit" },
              i.createElement("label", null, "Abonnementlaufzeit:"),
              i.createElement(
                "div",
                { className: "subscription-buttons" },
                [
  { term: "Monthly", price: s?.priceMonthly },
  { term: "Yearly", price: s?.priceYearly },
  { term: "3 Years", price: s?.price3Years },
]
                  .filter((e) => e.price > 0)
                  .filter((e) => !C || e.term === C)
                  .map((e) =>
                    i.createElement(
                      "button",
                      {
                        key: e.term,
                        type: "button",
                        className:
                          "subscription-button " +
                          (y === e.term ? "active" : ""),
                        onClick: () => {
                          return ((t = e.term), void (C || v(t)));
                          var t;
                        },
                      },
                      termLabels[e.term] || e.term,
                    ),
                  ),
              ),
              C &&
  i.createElement(
  "p",
  { className: "global-term-message" },

  i.createElement(
    "span",
    null,
    "Sie haben beim ersten Produkt die Laufzeit "
  ),

  i.createElement(
    "strong",
    null,
    termLabels[C] || C
  ),

  i.createElement(
    "span",
    null,
    " ausgewählt. Daher ist für weitere Produkte nur diese Laufzeit verfügbar."
  )
),
            ),
      E.length === 0 &&
            i.createElement(ve, {
                label: "In den Warenkorb",
                className: "cart-btn",
                onClick: () => {
                C || _(y);
                const e = [
                  ...E,
                  { sku: a, qty: d, subscriptionTerm: y, price: b },
                ];
                (sessionStorage.setItem("cart", JSON.stringify(e)), k(e));
              },
              disabled:
                !!C &&
                ![
  { term: "Monthly", price: s?.priceMonthly },
  { term: "Yearly", price: s?.priceYearly },
  { term: "3 Years", price: s?.price3Years },
]
                  .filter((e) => e.price > 0)
                  .map((e) => e.term)
                  .includes(C),
            }),
            E.length > 0 &&
              i.createElement(
                "div",
                { className: "cart-actions" },
                i.createElement(
                  "div",
                  { className: "cart-buttons cart-btn" },
                  i.createElement(ve, {
                    label: "Zum Warenkorb",
                    className: "cart-btn",
                      onClick: N,
                      /* Oeffnen von Rabattcodefenster:
                    onClick: () => {
                      x(!0);
                    },*/
                  }),
                  i.createElement(ve, {
                    label: "Zur Übersicht",
                    className: "cart-btn",
                    onClick: () => l("/"),
                  }),
                ),
              i.createElement(
                "p",
                { className: "cart-count" },

                i.createElement(
                  "span",
                  null,
                  "Sie haben "
                ),

                E.length,

                i.createElement(
                  "span",
                  null,
                  " Artikel im Warenkorb."
                ),
              ),
              ),
          ),
        ),
        /* Rabattcode Fenster (ausgeblendet)
        w &&
          i.createElement(
            "div",
            { className: "modal-overlay" },
            i.createElement(
              "div",
              { className: "modal-content", style: { position: "relative" } },
              i.createElement(
                "button",
                {
                  className: "modal-close",
                  onClick: () => x(!1),
                  "aria-label": "Close",
                },
                "×",
              ),
              i.createElement("h2", null, "Rabattcode eingeben"),
              i.createElement("input", {
                type: "text",
                value: p,
                onChange: (e) => m(e.target.value),
                placeholder: "Rabattcode eingeben",
                className: "form-input",
              }),
              i.createElement(
                "div",
                { className: "modal-actions" },
                i.createElement(
                  "button",
                  { className: "apply-button", onClick: N },
                  "Anwenden",
                ),
                i.createElement(
                  "button",
                  { className: "skip-button", onClick: N },
                  "Überspringen",
                ),
              ),
            ),
          ),*/
      );
    },
    Be = (e) => {
      let { country: t, locale: n, spi: r } = e;
      return i.createElement(
        ge,
        null,
        i.createElement(
          fe,
          null,
          i.createElement(ce, {
            path: "/",
            element: i.createElement(Ye, { country: t, locale: n, spi: r }),
          }),
          i.createElement(ce, {
            path: "/cart/:sku",
            element: i.createElement(Fe, { country: t, locale: n, spi: r }),
          }),
        ),
      );
    };
  class Ie extends HTMLElement {
    constructor() {
      (super(), this.attachShadow({ mode: "open" }), (this.root = null));
    }
    static get observedAttributes() {
      return ["country", "locale", "spi"];
    }
    connectedCallback() {
      const e = document.createElement("link");
      ((e.rel = "stylesheet"),
        /*(e.href = "https://bct-technology.shop/cdn/shop/t/7/assets/main.css"), */

        (e.href = this.getAttribute("css-url") || "https://bct-technology.shop/cdn/shop/t/7/assets/main.css"),


        this.shadowRoot.appendChild(e),
        this.render());
    }
    attributeChangedCallback(e, t, n) {
      this.root && t !== n && this.render();
    }
    render() {
      const e = this.getAttribute("country"),
        t = this.getAttribute("locale"),
        n = this.getAttribute("spi");
      (this.root || (this.root = u.createRoot(this.shadowRoot)),
        this.root.render(
          i.createElement(Be, { country: e, locale: t, spi: n }),
        ));
    }
    disconnectedCallback() {
      this.root && (this.root.unmount(), (this.root = null));
    }
  }
  customElements.define("store-template", Ie);
})();
